(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ui-library-da"] = factory(require("vue"));
	else
		root["ui-library-da"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__203__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 679:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ 669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(609);

/***/ }),

/***/ 448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);
var settle = __webpack_require__(26);
var cookies = __webpack_require__(372);
var buildURL = __webpack_require__(327);
var buildFullPath = __webpack_require__(97);
var parseHeaders = __webpack_require__(109);
var isURLSameOrigin = __webpack_require__(985);
var createError = __webpack_require__(61);
var defaults = __webpack_require__(655);
var Cancel = __webpack_require__(263);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);
var bind = __webpack_require__(849);
var Axios = __webpack_require__(321);
var mergeConfig = __webpack_require__(185);
var defaults = __webpack_require__(655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(263);
axios.CancelToken = __webpack_require__(972);
axios.isCancel = __webpack_require__(502);
axios.VERSION = (__webpack_require__(288).version);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);
var buildURL = __webpack_require__(327);
var InterceptorManager = __webpack_require__(782);
var dispatchRequest = __webpack_require__(572);
var mergeConfig = __webpack_require__(185);
var validator = __webpack_require__(875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  if (!config.url) {
    throw new Error('Provided config url is not valid');
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  if (!config.url) {
    throw new Error('Provided config url is not valid');
  }
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 97:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(793);
var combineURLs = __webpack_require__(303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 61:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);
var transformData = __webpack_require__(527);
var isCancel = __webpack_require__(502);
var defaults = __webpack_require__(655);
var Cancel = __webpack_require__(263);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),

/***/ 185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 26:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(61);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);
var defaults = __webpack_require__(655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);
var normalizeHeaderName = __webpack_require__(16);
var enhanceError = __webpack_require__(481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 288:
/***/ (function(module) {

module.exports = {
  "version": "0.25.0"
};

/***/ }),

/***/ 849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(288).version);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return toString.call(val) === '[object FormData]';
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return toString.call(val) === '[object URLSearchParams]';
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 285:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d\d/,r=/\d\d?/,i=/\d*[^\s\d-_:/()]+/,o={},s=function(e){return(e=+e)+(e>68?1900:2e3)};var a=function(e){return function(t){this[e]=+t}},f=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e)}],h=function(e){var t=o[e];return t&&(t.indexOf?t:t.s.concat(t.f))},u=function(e,t){var n,r=o.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},d={A:[i,function(e){this.afternoon=u(e,!1)}],a:[i,function(e){this.afternoon=u(e,!0)}],S:[/\d/,function(e){this.milliseconds=100*+e}],SS:[n,function(e){this.milliseconds=10*+e}],SSS:[/\d{3}/,function(e){this.milliseconds=+e}],s:[r,a("seconds")],ss:[r,a("seconds")],m:[r,a("minutes")],mm:[r,a("minutes")],H:[r,a("hours")],h:[r,a("hours")],HH:[r,a("hours")],hh:[r,a("hours")],D:[r,a("day")],DD:[n,a("day")],Do:[i,function(e){var t=o.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r)}],M:[r,a("month")],MM:[n,a("month")],MMM:[i,function(e){var t=h("months"),n=(h("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n}],MMMM:[i,function(e){var t=h("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t}],Y:[/[+-]?\d+/,a("year")],YY:[n,function(e){this.year=s(e)}],YYYY:[/\d{4}/,a("year")],Z:f,ZZ:f};function c(n){var r,i;r=n,i=o&&o.formats;for(var s=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=s.length,f=0;f<a;f+=1){var h=s[f],u=d[h],c=u&&u[0],l=u&&u[1];s[f]=l?{regex:c,parser:l}:h.replace(/^\[|\]$/g,"")}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=s[n];if("string"==typeof i)r+=i.length;else{var o=i.regex,f=i.parser,h=e.slice(r),u=o.exec(h)[0];f.call(t,u),e=e.replace(u,"")}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(s=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,s=e.args;this.$u=r;var a=s[1];if("string"==typeof a){var f=!0===s[2],h=!0===s[3],u=f||h,d=s[2];h&&(d=s[2]),o=this.$locale(),!f&&d&&(o=n.Ls[d]),this.$d=function(e,t,n){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var r=c(t)(e),i=r.year,o=r.month,s=r.day,a=r.hours,f=r.minutes,h=r.seconds,u=r.milliseconds,d=r.zone,l=new Date,m=s||(i||o?1:l.getDate()),M=i||l.getFullYear(),Y=0;i&&!o||(Y=o>0?o-1:l.getMonth());var p=a||0,v=f||0,D=h||0,g=u||0;return d?new Date(Date.UTC(M,Y,m,p,v,D,g+60*d.offset*1e3)):n?new Date(Date.UTC(M,Y,m,p,v,D,g)):new Date(M,Y,m,p,v,D,g)}catch(e){return new Date("")}}(t,a,r),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),o={}}else if(a instanceof Array)for(var l=a.length,m=1;m<=l;m+=1){s[1]=a[m-1];var M=n.apply(this,s);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===l&&(this.$d=new Date(""))}else i.call(this,e)}}}));

/***/ }),

/***/ 437:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.5 2021-03-13*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
(function (define, undefined) {
define(function () {
    'use strict';

    var impl = {};

    impl.mobileDetectRules = {
    "phones": {
        "iPhone": "\\biPhone\\b|\\biPod\\b",
        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
        "Pixel": "; \\bPixel\\b",
        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 5X|Nexus 6",
        "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
        "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F|SM-G610F|SM-G981B|SM-G892A|SM-A530F",
        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533|SOV34|601SO|F8332",
        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
        "Xiaomi": "^(?!.*\\bx11\\b).*xiaomi.*$|POCOPHONE F1|MI 8|Redmi Note 9S|Redmi Note 5A Prime|N2G47H|M2001J2G|M2001J2I|M1805E10A|M2004J11G|M1902F1G|M2002J9G|M2004J19G|M2003J6A1G",
        "NokiaLumia": "Lumia [0-9]{3,4}",
        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
        "Palm": "PalmSource|Palm",
        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
        "Alcatel": "Alcatel",
        "Nintendo": "Nintendo (3DS|Switch)",
        "Amoi": "Amoi",
        "INQ": "INQ",
        "OnePlus": "ONEPLUS",
        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
    },
    "tablets": {
        "iPad": "iPad|iPad.*Mobile",
        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
        "GoogleTablet": "Android.*Pixel C",
        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V|SM-P610|SM-T290|SM-T515|SM-T590|SM-T595|SM-T725|SM-T817P|SM-P585N0|SM-T395|SM-T295|SM-T865|SM-P610N|SM-P615|SM-T970|SM-T380|SM-T5950|SM-T905|SM-T231|SM-T500|SM-T860",
        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
        "BlackBerryTablet": "PlayBook|RIM Tablet",
        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30|A3-A40",
        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X|TB-X704F|TB-X104F|TB3-X70F|TB-X705F|TB-8504F|TB3-X70L|TB3-710F|TB-X704L",
        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
        "IRUTablet": "M702pro",
        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
        "NokiaLumiaTablet": "Lumia 2520",
        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
        "FlyTablet": "IQ310|Fly Vision",
        "bqTablet": "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
        "NecTablet": "\\bN-06D|\\bN-08D",
        "PantechTablet": "Pantech.*P4100",
        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
        "ZyncTablet": "z1000|Z99 2G|z930|z990|z909|Z919|z900",
        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
        "NabiTablet": "Android.*\\bNabi",
        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
        "PlaystationTablet": "Playstation.*(Portable|Vita)",
        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
        "GalapadTablet": "Android [0-9.]+; [a-z-]+; \\bG1\\b",
        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
        "DPSTablet": "DPS Dream 9|DPS Dual 7",
        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
        "iMobileTablet": "i-mobile i-note",
        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
        "AMPETablet": "Android.* A78 ",
        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
        "TecnoTablet": "TECNO P9|TECNO DP8D",
        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
        "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
        "CaptivaTablet": "CAPTIVA PAD",
        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
        "JaytechTablet": "TPC-PA762",
        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
        "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
        "UbislateTablet": "UbiSlate[\\s]?7C",
        "PocketBookTablet": "Pocketbook",
        "KocasoTablet": "\\b(TB-1207)\\b",
        "HisenseTablet": "\\b(F5281|E2371)\\b",
        "Hudl": "Hudl HT7S3|Hudl 2",
        "TelstraTablet": "T-Hub2",
        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
    },
    "oss": {
        "AndroidOS": "Android",
        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
        "iPadOS": "CPU OS 13",
        "SailfishOS": "Sailfish",
        "MeeGoOS": "MeeGo",
        "MaemoOS": "Maemo",
        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
        "webOS": "webOS|hpwOS",
        "badaOS": "\\bBada\\b",
        "BREWOS": "BREW"
    },
    "uas": {
        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
        "Dolfin": "\\bDolfin\\b",
        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
        "Skyfire": "Skyfire",
        "Edge": "\\bEdgiOS\\b|Mobile Safari\/[.0-9]* Edge",
        "IE": "IEMobile|MSIEMobile",
        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
        "Bolt": "bolt",
        "TeaShark": "teashark",
        "Blazer": "Blazer",
        "Safari": "Version((?!\\bEdgiOS\\b).)*Mobile.*Safari|Safari.*Mobile|MobileSafari",
        "WeChat": "\\bMicroMessenger\\b",
        "UCBrowser": "UC.*Browser|UCWEB",
        "baiduboxapp": "baiduboxapp",
        "baidubrowser": "baidubrowser",
        "DiigoBrowser": "DiigoBrowser",
        "Mercury": "\\bMercury\\b",
        "ObigoBrowser": "Obigo",
        "NetFront": "NF-Browser",
        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
    },
    "props": {
        "Mobile": "Mobile\/[VER]",
        "Build": "Build\/[VER]",
        "Version": "Version\/[VER]",
        "VendorID": "VendorID\/[VER]",
        "iPad": "iPad.*CPU[a-z ]+[VER]",
        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
        "iPod": "iPod.*CPU[a-z ]+[VER]",
        "Kindle": "Kindle\/[VER]",
        "Chrome": [
            "Chrome\/[VER]",
            "CriOS\/[VER]",
            "CrMo\/[VER]"
        ],
        "Coast": [
            "Coast\/[VER]"
        ],
        "Dolfin": "Dolfin\/[VER]",
        "Firefox": [
            "Firefox\/[VER]",
            "FxiOS\/[VER]"
        ],
        "Fennec": "Fennec\/[VER]",
        "Edge": "Edge\/[VER]",
        "IE": [
            "IEMobile\/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident\/[0-9.]+;.*rv:[VER]"
        ],
        "NetFront": "NetFront\/[VER]",
        "NokiaBrowser": "NokiaBrowser\/[VER]",
        "Opera": [
            " OPR\/[VER]",
            "Opera Mini\/[VER]",
            "Version\/[VER]"
        ],
        "Opera Mini": "Opera Mini\/[VER]",
        "Opera Mobi": "Version\/[VER]",
        "UCBrowser": [
            "UCWEB[VER]",
            "UC.*Browser\/[VER]"
        ],
        "MQQBrowser": "MQQBrowser\/[VER]",
        "MicroMessenger": "MicroMessenger\/[VER]",
        "baiduboxapp": "baiduboxapp\/[VER]",
        "baidubrowser": "baidubrowser\/[VER]",
        "SamsungBrowser": "SamsungBrowser\/[VER]",
        "Iron": "Iron\/[VER]",
        "Safari": [
            "Version\/[VER]",
            "Safari\/[VER]"
        ],
        "Skyfire": "Skyfire\/[VER]",
        "Tizen": "Tizen\/[VER]",
        "Webkit": "webkit[ \/][VER]",
        "PaleMoon": "PaleMoon\/[VER]",
        "SailfishBrowser": "SailfishBrowser\/[VER]",
        "Gecko": "Gecko\/[VER]",
        "Trident": "Trident\/[VER]",
        "Presto": "Presto\/[VER]",
        "Goanna": "Goanna\/[VER]",
        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
        "Android": "Android [VER]",
        "Sailfish": "Sailfish [VER]",
        "BlackBerry": [
            "BlackBerry[\\w]+\/[VER]",
            "BlackBerry.*Version\/[VER]",
            "Version\/[VER]"
        ],
        "BREW": "BREW [VER]",
        "Java": "Java\/[VER]",
        "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
        ],
        "Windows Phone": "Windows Phone [VER]",
        "Windows CE": "Windows CE\/[VER]",
        "Windows NT": "Windows NT [VER]",
        "Symbian": [
            "SymbianOS\/[VER]",
            "Symbian\/[VER]"
        ],
        "webOS": [
            "webOS\/[VER]",
            "hpwOS\/[VER];"
        ]
    },
    "utils": {
        "Bot": "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp|AspiegelBot",
        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
        "DesktopMode": "WPDesktop",
        "TV": "SonyDTV|HbbTV",
        "WebKit": "(webkit)[ \/]([\\w.]+)",
        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
        "Watch": "SM-V700"
    }
};

    // following patterns come from http://detectmobilebrowsers.com/
    impl.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
    };

    var hasOwnProp = Object.prototype.hasOwnProperty,
        isArray;

    impl.FALLBACK_PHONE = 'UnknownPhone';
    impl.FALLBACK_TABLET = 'UnknownTablet';
    impl.FALLBACK_MOBILE = 'UnknownMobile';

    isArray = ('isArray' in Array) ?
        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };

    function equalIC(a, b) {
        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
    }

    function containsIC(array, value) {
        var valueLC, i, len = array.length;
        if (!len || !value) {
            return false;
        }
        valueLC = value.toLowerCase();
        for (i = 0; i < len; ++i) {
            if (valueLC === array[i].toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    function convertPropsToRegExp(object) {
        for (var key in object) {
            if (hasOwnProp.call(object, key)) {
                object[key] = new RegExp(object[key], 'i');
            }
        }
    }

    function prepareUserAgent(userAgent) {
        return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
    }

    (function init() {
        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
        for (key in mobileDetectRules.props) {
            if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) {
                    values = [values];
                }
                len = values.length;
                for (i = 0; i < len; ++i) {
                    value = values[i];
                    verPos = value.indexOf('[VER]');
                    if (verPos >= 0) {
                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                    }
                    values[i] = new RegExp(value, 'i');
                }
                mobileDetectRules.props[key] = values;
            }
        }
        convertPropsToRegExp(mobileDetectRules.oss);
        convertPropsToRegExp(mobileDetectRules.phones);
        convertPropsToRegExp(mobileDetectRules.tablets);
        convertPropsToRegExp(mobileDetectRules.uas);
        convertPropsToRegExp(mobileDetectRules.utils);

        // copy some patterns to oss0 which are tested first (see issue#15)
        mobileDetectRules.oss0 = {
            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
        };
    }());

    /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */
    impl.findMatch = function(rules, userAgent) {
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    return key;
                }
            }
        }
        return null;
    };

    /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */
    impl.findMatches = function(rules, userAgent) {
        var result = [];
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    result.push(key);
                }
            }
        }
        return result;
    };

    /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */
    impl.getVersionStr = function (propertyName, userAgent) {
        var props = impl.mobileDetectRules.props, patterns, i, len, match;
        if (hasOwnProp.call(props, propertyName)) {
            patterns = props[propertyName];
            len = patterns.length;
            for (i = 0; i < len; ++i) {
                match = patterns[i].exec(userAgent);
                if (match !== null) {
                    return match[1];
                }
            }
        }
        return null;
    };

    /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */
    impl.getVersion = function (propertyName, userAgent) {
        var version = impl.getVersionStr(propertyName, userAgent);
        return version ? impl.prepareVersionNo(version) : NaN;
    };

    /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */
    impl.prepareVersionNo = function (version) {
        var numbers;

        numbers = version.split(/[a-z._ \/\-]/i);
        if (numbers.length === 1) {
            version = numbers[0];
        }
        if (numbers.length > 1) {
            version = numbers[0] + '.';
            numbers.shift();
            version += numbers.join('');
        }
        return Number(version);
    };

    impl.isMobileFallback = function (userAgent) {
        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
    };

    impl.isTabletFallback = function (userAgent) {
        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
    };

    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
        if (cache.mobile !== undefined) {
            return;
        }
        var phone, tablet, phoneSized;

        // first check for stronger tablet rules, then phone (see issue#5)
        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
        if (tablet) {
            cache.mobile = cache.tablet = tablet;
            cache.phone = null;
            return; // unambiguously identified as tablet
        }

        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
        if (phone) {
            cache.mobile = cache.phone = phone;
            cache.tablet = null;
            return; // unambiguously identified as phone
        }

        // our rules haven't found a match -> try more general fallback rules
        if (impl.isMobileFallback(userAgent)) {
            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
            if (phoneSized === undefined) {
                cache.mobile = impl.FALLBACK_MOBILE;
                cache.tablet = cache.phone = null;
            } else if (phoneSized) {
                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                cache.tablet = null;
            } else {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            }
        } else if (impl.isTabletFallback(userAgent)) {
            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
            cache.phone = null;
        } else {
            // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        }
    };

    // t is a reference to a MobileDetect instance
    impl.mobileGrade = function (t) {
        // impl note:
        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
        // When changes are made in Mobile_Detect.php, copy this method and replace:
        //     $this-> / t.
        //     self::MOBILE_GRADE_(.) / '$1'
        //     , self::VERSION_TYPE_FLOAT / (nothing)
        //     isIOS() / os('iOS')
        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
        var $isMobile = t.mobile() !== null;

        if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad')>=4.3 ||
            t.os('iOS') && t.version('iPhone')>=3.1 ||
            t.os('iOS') && t.version('iPod')>=3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            ( t.version('Android')>2.1 && t.is('Webkit') ) ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS')>=7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada')>=2.0 ||

            // UC Browser - Tested on Android 2.3 device
            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            ( t.match('Kindle Fire') ||
                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome')>=11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari')>=5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox')>=4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE')>=7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera')>=10 && !$isMobile

            ){
            return 'A';
        }

        if (
            t.os('iOS') && t.version('iPad')<4.3 ||
            t.os('iOS') && t.version('iPhone')<3.1 ||
            t.os('iOS') && t.version('iPod')<3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
                (t.version('Android')>=2.3 || t.is('iOS')) ) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
            ){
            return 'B';
        }

        if (
        // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry')<5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2

            ){
            return 'C';
        }

        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
        //will receive the basic, C grade experience.
        return 'C';
    };

    impl.detectOS = function (ua) {
        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
            impl.findMatch(impl.mobileDetectRules.oss, ua);
    };

    impl.getDeviceSmallerSide = function () {
        return window.screen.width < window.screen.height ?
            window.screen.width :
            window.screen.height;
    };

    /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */
    function MobileDetect(userAgent, maxPhoneWidth) {
        this.ua = prepareUserAgent(userAgent);
        this._cache = {};
        //600dp is typical 7" tablet minimum width
        this.maxPhoneWidth = maxPhoneWidth || 600;
    }

    MobileDetect.prototype = {
        constructor: MobileDetect,

        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.mobile;
        },

        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, Pixel, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * Xiaomi, NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile,
         * SimValley, Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.phone;
        },

        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.tablet;
        },

        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function () {
            if (this._cache.userAgent === undefined) {
                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgent;
        },

        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function () {
            if (this._cache.userAgents === undefined) {
                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgents;
        },

        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, iPadOS, SailfishOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function () {
            if (this._cache.os === undefined) {
                this._cache.os = impl.detectOS(this.ua);
            }
            return this._cache.os;
        },

        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function (key) {
            return impl.getVersion(key, this.ua);
        },

        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function (key) {
            return impl.getVersionStr(key, this.ua);
        },

        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function (key) {
            return containsIC(this.userAgents(), key) ||
                   equalIC(key, this.os()) ||
                   equalIC(key, this.phone()) ||
                   equalIC(key, this.tablet()) ||
                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
        },

        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function (pattern) {
            if (!(pattern instanceof RegExp)) {
                pattern = new RegExp(pattern, 'i');
            }
            return pattern.test(this.ua);
        },

        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function (maxPhoneWidth) {
            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
        },

        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function () {
            if (this._cache.grade === undefined) {
                this._cache.grade = impl.mobileGrade(this);
            }
            return this._cache.grade;
        }
    };

    // environment-dependent
    if (typeof window !== 'undefined' && window.screen) {
        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
    } else {
        MobileDetect.isPhoneSized = function () {};
    }

    // should not be replaced by a completely new object - just overwrite existing methods
    MobileDetect._impl = impl;
    
    MobileDetect.version = '1.4.5 2021-03-13';

    return MobileDetect;
}); // end of call of define()
})((function (undefined) {
    if ( true && module.exports) {
        return function (factory) { module.exports = factory(); };
    } else if (true) {
        return __webpack_require__.amdD;
    } else {}
})());

/***/ }),

/***/ 377:
/***/ (function() {



/***/ }),

/***/ 70:
/***/ (function() {



/***/ }),

/***/ 546:
/***/ (function() {



/***/ }),

/***/ 676:
/***/ (function() {



/***/ }),

/***/ 746:
/***/ (function() {



/***/ }),

/***/ 645:
/***/ (function() {



/***/ }),

/***/ 332:
/***/ (function() {



/***/ }),

/***/ 278:
/***/ (function() {



/***/ }),

/***/ 904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createDecorator": function() { return /* binding */ createDecorator; },
/* harmony export */   "mixins": function() { return /* binding */ mixins; }
/* harmony export */ });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(203);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return vue__WEBPACK_IMPORTED_MODULE_0___default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (vue__WEBPACK_IMPORTED_MODULE_0___default()) ? superProto.constructor : (vue__WEBPACK_IMPORTED_MODULE_0___default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ __webpack_exports__["default"] = (Component);



/***/ }),

/***/ 390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports, __webpack_require__(904)) :
    0;
}(this, function (exports, VCComponent) { 'use strict';

    VCComponent = VCComponent && VCComponent.hasOwnProperty('default') ? VCComponent['default'] : VCComponent;

    /**
     * @file Mixins Vue Extension
     * @see https://github.com/vuejs/vue-class-component/issues/91#issuecomment-312534798
     */
    /**
     *
     * @param {typeof Vue} parent
     * @param {typeof Vue} mixins
     * @returns {VueClass<T extends Vue>}
     * @constructor
     */
    function Mixins(parent) {
        var mixins = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            mixins[_i - 1] = arguments[_i];
        }
        return parent.extend({ mixins: mixins });
    }

    /**
     * @file Component Decorator
     * @see https://github.com/vuejs/vue-class-component/issues/91#issuecomment-312534798
     */
    /**
     * Component decorator
     * @param {ComponentOptions<U extends Vue> | V} options
     * @returns {any}
     * @constructor
     */
    function Component(options) {
        return VCComponent(options);
    }

    exports.Mixin = VCComponent;
    exports.Component = Component;
    exports.Mixins = Mixins;

    Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),

/***/ 938:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}("undefined"!=typeof self?self:this,(function(){return(()=>{var t={646:t=>{t.exports=function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}},713:t=>{t.exports=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},860:t=>{t.exports=function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}},206:t=>{t.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},319:(t,e,n)=>{var o=n(646),i=n(860),s=n(206);t.exports=function(t){return o(t)||i(t)||s()}},8:t=>{function e(n){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?t.exports=e=function(t){return typeof t}:t.exports=e=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},e(n)}t.exports=e}},e={};function n(o){var i=e[o];if(void 0!==i)return i.exports;var s=e[o]={exports:{}};return t[o](s,s.exports,n),s.exports}n.n=t=>{var e=t&&t.__esModule?()=>t.default:()=>t;return n.d(e,{a:e}),e},n.d=(t,e)=>{for(var o in e)n.o(e,o)&&!n.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:e[o]})},n.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),n.r=t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})};var o={};return(()=>{"use strict";n.r(o),n.d(o,{VueSelect:()=>m,default:()=>O,mixins:()=>_});var t=n(319),e=n.n(t),i=n(8),s=n.n(i),r=n(713),a=n.n(r);const l={props:{autoscroll:{type:Boolean,default:!0}},watch:{typeAheadPointer:function(){this.autoscroll&&this.maybeAdjustScroll()},open:function(t){var e=this;this.autoscroll&&t&&this.$nextTick((function(){return e.maybeAdjustScroll()}))}},methods:{maybeAdjustScroll:function(){var t,e=(null===(t=this.$refs.dropdownMenu)||void 0===t?void 0:t.children[this.typeAheadPointer])||!1;if(e){var n=this.getDropdownViewport(),o=e.getBoundingClientRect(),i=o.top,s=o.bottom,r=o.height;if(i<n.top)return this.$refs.dropdownMenu.scrollTop=e.offsetTop;if(s>n.bottom)return this.$refs.dropdownMenu.scrollTop=e.offsetTop-(n.height-r)}},getDropdownViewport:function(){return this.$refs.dropdownMenu?this.$refs.dropdownMenu.getBoundingClientRect():{height:0,top:0,bottom:0}}}},c={data:function(){return{typeAheadPointer:-1}},watch:{filteredOptions:function(){for(var t=0;t<this.filteredOptions.length;t++)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},open:function(t){t&&this.typeAheadToLastSelected()},selectedValue:function(){this.open&&this.typeAheadToLastSelected()}},methods:{typeAheadUp:function(){for(var t=this.typeAheadPointer-1;t>=0;t--)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},typeAheadDown:function(){for(var t=this.typeAheadPointer+1;t<this.filteredOptions.length;t++)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},typeAheadSelect:function(){var t=this.filteredOptions[this.typeAheadPointer];t&&this.selectable(t)&&this.select(t)},typeAheadToLastSelected:function(){this.typeAheadPointer=0!==this.selectedValue.length?this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length-1]):-1}}},u={props:{loading:{type:Boolean,default:!1}},data:function(){return{mutableLoading:!1}},watch:{search:function(){this.$emit("search",this.search,this.toggleLoading)},loading:function(t){this.mutableLoading=t}},methods:{toggleLoading:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return this.mutableLoading=null==t?!this.mutableLoading:t}}};function p(t,e,n,o,i,s,r,a){var l,c="function"==typeof t?t.options:t;if(e&&(c.render=e,c.staticRenderFns=n,c._compiled=!0),o&&(c.functional=!0),s&&(c._scopeId="data-v-"+s),r?(l=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(r)},c._ssrRegister=l):i&&(l=a?function(){i.call(this,(c.functional?this.parent:this).$root.$options.shadowRoot)}:i),l)if(c.functional){c._injectStyles=l;var u=c.render;c.render=function(t,e){return l.call(e),u(t,e)}}else{var p=c.beforeCreate;c.beforeCreate=p?[].concat(p,l):[l]}return{exports:t,options:c}}const h={Deselect:p({},(function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"10",height:"10"}},[e("path",{attrs:{d:"M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"}})])}),[],!1,null,null,null).exports,OpenIndicator:p({},(function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"14",height:"10"}},[e("path",{attrs:{d:"M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"}})])}),[],!1,null,null,null).exports},d={inserted:function(t,e,n){var o=n.context;if(o.appendToBody){var i=o.$refs.toggle.getBoundingClientRect(),s=i.height,r=i.top,a=i.left,l=i.width,c=window.scrollX||window.pageXOffset,u=window.scrollY||window.pageYOffset;t.unbindPosition=o.calculatePosition(t,o,{width:l+"px",left:c+a+"px",top:u+r+s+"px"}),document.body.appendChild(t)}},unbind:function(t,e,n){n.context.appendToBody&&(t.unbindPosition&&"function"==typeof t.unbindPosition&&t.unbindPosition(),t.parentNode&&t.parentNode.removeChild(t))}};const f=function(t){var e={};return Object.keys(t).sort().forEach((function(n){e[n]=t[n]})),JSON.stringify(e)};var y=0;const b=function(){return++y};function g(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,o)}return n}function v(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?g(Object(n),!0).forEach((function(e){a()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):g(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}const m=p({components:v({},h),directives:{appendToBody:d},mixins:[l,c,u],props:{value:{},components:{type:Object,default:function(){return{}}},options:{type:Array,default:function(){return[]}},disabled:{type:Boolean,default:!1},clearable:{type:Boolean,default:!0},deselectFromDropdown:{type:Boolean,default:!1},searchable:{type:Boolean,default:!0},multiple:{type:Boolean,default:!1},placeholder:{type:String,default:""},transition:{type:String,default:"vs__fade"},clearSearchOnSelect:{type:Boolean,default:!0},closeOnSelect:{type:Boolean,default:!0},label:{type:String,default:"label"},autocomplete:{type:String,default:"off"},reduce:{type:Function,default:function(t){return t}},selectable:{type:Function,default:function(t){return!0}},getOptionLabel:{type:Function,default:function(t){return"object"===s()(t)?t.hasOwnProperty(this.label)?t[this.label]:console.warn('[vue-select warn]: Label key "option.'.concat(this.label,'" does not')+" exist in options object ".concat(JSON.stringify(t),".\n")+"https://vue-select.org/api/props.html#getoptionlabel"):t}},getOptionKey:{type:Function,default:function(t){if("object"!==s()(t))return t;try{return t.hasOwnProperty("id")?t.id:f(t)}catch(e){return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey",t,e)}}},onTab:{type:Function,default:function(){this.selectOnTab&&!this.isComposing&&this.typeAheadSelect()}},taggable:{type:Boolean,default:!1},tabindex:{type:Number,default:null},pushTags:{type:Boolean,default:!1},filterable:{type:Boolean,default:!0},filterBy:{type:Function,default:function(t,e,n){return(e||"").toLocaleLowerCase().indexOf(n.toLocaleLowerCase())>-1}},filter:{type:Function,default:function(t,e){var n=this;return t.filter((function(t){var o=n.getOptionLabel(t);return"number"==typeof o&&(o=o.toString()),n.filterBy(t,o,e)}))}},createOption:{type:Function,default:function(t){return"object"===s()(this.optionList[0])?a()({},this.label,t):t}},resetOnOptionsChange:{default:!1,validator:function(t){return["function","boolean"].includes(s()(t))}},clearSearchOnBlur:{type:Function,default:function(t){var e=t.clearSearchOnSelect,n=t.multiple;return e&&!n}},noDrop:{type:Boolean,default:!1},inputId:{type:String},dir:{type:String,default:"auto"},selectOnTab:{type:Boolean,default:!1},selectOnKeyCodes:{type:Array,default:function(){return[13]}},searchInputQuerySelector:{type:String,default:"[type=search]"},mapKeydown:{type:Function,default:function(t,e){return t}},appendToBody:{type:Boolean,default:!1},calculatePosition:{type:Function,default:function(t,e,n){var o=n.width,i=n.top,s=n.left;t.style.top=i,t.style.left=s,t.style.width=o}},dropdownShouldOpen:{type:Function,default:function(t){var e=t.noDrop,n=t.open,o=t.mutableLoading;return!e&&(n&&!o)}},uid:{type:[String,Number],default:function(){return b()}}},data:function(){return{search:"",open:!1,isComposing:!1,pushedTags:[],_value:[]}},computed:{isTrackingValues:function(){return void 0===this.value||this.$options.propsData.hasOwnProperty("reduce")},selectedValue:function(){var t=this.value;return this.isTrackingValues&&(t=this.$data._value),null!=t&&""!==t?[].concat(t):[]},optionList:function(){return this.options.concat(this.pushTags?this.pushedTags:[])},searchEl:function(){return this.$scopedSlots.search?this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector):this.$refs.search},scope:function(){var t=this,e={search:this.search,loading:this.loading,searching:this.searching,filteredOptions:this.filteredOptions};return{search:{attributes:v({disabled:this.disabled,placeholder:this.searchPlaceholder,tabindex:this.tabindex,readonly:!this.searchable,id:this.inputId,"aria-autocomplete":"list","aria-labelledby":"vs".concat(this.uid,"__combobox"),"aria-controls":"vs".concat(this.uid,"__listbox"),ref:"search",type:"search",autocomplete:this.autocomplete,value:this.search},this.dropdownOpen&&this.filteredOptions[this.typeAheadPointer]?{"aria-activedescendant":"vs".concat(this.uid,"__option-").concat(this.typeAheadPointer)}:{}),events:{compositionstart:function(){return t.isComposing=!0},compositionend:function(){return t.isComposing=!1},keydown:this.onSearchKeyDown,blur:this.onSearchBlur,focus:this.onSearchFocus,input:function(e){return t.search=e.target.value}}},spinner:{loading:this.mutableLoading},noOptions:{search:this.search,loading:this.mutableLoading,searching:this.searching},openIndicator:{attributes:{ref:"openIndicator",role:"presentation",class:"vs__open-indicator"}},listHeader:e,listFooter:e,header:v({},e,{deselect:this.deselect}),footer:v({},e,{deselect:this.deselect})}},childComponents:function(){return v({},h,{},this.components)},stateClasses:function(){return{"vs--open":this.dropdownOpen,"vs--single":!this.multiple,"vs--multiple":this.multiple,"vs--searching":this.searching&&!this.noDrop,"vs--searchable":this.searchable&&!this.noDrop,"vs--unsearchable":!this.searchable,"vs--loading":this.mutableLoading,"vs--disabled":this.disabled}},searching:function(){return!!this.search},dropdownOpen:function(){return this.dropdownShouldOpen(this)},searchPlaceholder:function(){return this.isValueEmpty&&this.placeholder?this.placeholder:void 0},filteredOptions:function(){var t=[].concat(this.optionList);if(!this.filterable&&!this.taggable)return t;var e=this.search.length?this.filter(t,this.search,this):t;if(this.taggable&&this.search.length){var n=this.createOption(this.search);this.optionExists(n)||e.unshift(n)}return e},isValueEmpty:function(){return 0===this.selectedValue.length},showClearButton:function(){return!this.multiple&&this.clearable&&!this.open&&!this.isValueEmpty}},watch:{options:function(t,e){var n=this;!this.taggable&&("function"==typeof n.resetOnOptionsChange?n.resetOnOptionsChange(t,e,n.selectedValue):n.resetOnOptionsChange)&&this.clearSelection(),this.value&&this.isTrackingValues&&this.setInternalValueFromOptions(this.value)},value:{immediate:!0,handler:function(t){this.isTrackingValues&&this.setInternalValueFromOptions(t)}},multiple:function(){this.clearSelection()},open:function(t){this.$emit(t?"open":"close")}},created:function(){this.mutableLoading=this.loading,this.$on("option:created",this.pushTag)},methods:{setInternalValueFromOptions:function(t){var e=this;Array.isArray(t)?this.$data._value=t.map((function(t){return e.findOptionFromReducedValue(t)})):this.$data._value=this.findOptionFromReducedValue(t)},select:function(t){this.$emit("option:selecting",t),this.isOptionSelected(t)?this.deselectFromDropdown&&(this.clearable||this.multiple&&this.selectedValue.length>1)&&this.deselect(t):(this.taggable&&!this.optionExists(t)&&this.$emit("option:created",t),this.multiple&&(t=this.selectedValue.concat(t)),this.updateValue(t),this.$emit("option:selected",t)),this.onAfterSelect(t)},deselect:function(t){var e=this;this.$emit("option:deselecting",t),this.updateValue(this.selectedValue.filter((function(n){return!e.optionComparator(n,t)}))),this.$emit("option:deselected",t)},clearSelection:function(){this.updateValue(this.multiple?[]:null)},onAfterSelect:function(t){this.closeOnSelect&&(this.open=!this.open,this.searchEl.blur()),this.clearSearchOnSelect&&(this.search="")},updateValue:function(t){var e=this;void 0===this.value&&(this.$data._value=t),null!==t&&(t=Array.isArray(t)?t.map((function(t){return e.reduce(t)})):this.reduce(t)),this.$emit("input",t)},toggleDropdown:function(t){var n=t.target!==this.searchEl;n&&t.preventDefault();var o=[].concat(e()(this.$refs.deselectButtons||[]),e()([this.$refs.clearButton]||0));void 0===this.searchEl||o.filter(Boolean).some((function(e){return e.contains(t.target)||e===t.target}))?t.preventDefault():this.open&&n?this.searchEl.blur():this.disabled||(this.open=!0,this.searchEl.focus())},isOptionSelected:function(t){var e=this;return this.selectedValue.some((function(n){return e.optionComparator(n,t)}))},isOptionDeselectable:function(t){return this.isOptionSelected(t)&&this.deselectFromDropdown},optionComparator:function(t,e){return this.getOptionKey(t)===this.getOptionKey(e)},findOptionFromReducedValue:function(t){var n=this,o=[].concat(e()(this.options),e()(this.pushedTags)).filter((function(e){return JSON.stringify(n.reduce(e))===JSON.stringify(t)}));return 1===o.length?o[0]:o.find((function(t){return n.optionComparator(t,n.$data._value)}))||t},closeSearchOptions:function(){this.open=!1,this.$emit("search:blur")},maybeDeleteValue:function(){if(!this.searchEl.value.length&&this.selectedValue&&this.selectedValue.length&&this.clearable){var t=null;this.multiple&&(t=e()(this.selectedValue.slice(0,this.selectedValue.length-1))),this.updateValue(t)}},optionExists:function(t){var e=this;return this.optionList.some((function(n){return e.optionComparator(n,t)}))},normalizeOptionForSlot:function(t){return"object"===s()(t)?t:a()({},this.label,t)},pushTag:function(t){this.pushedTags.push(t)},onEscape:function(){this.search.length?this.search="":this.searchEl.blur()},onSearchBlur:function(){if(!this.mousedown||this.searching){var t=this.clearSearchOnSelect,e=this.multiple;return this.clearSearchOnBlur({clearSearchOnSelect:t,multiple:e})&&(this.search=""),void this.closeSearchOptions()}this.mousedown=!1,0!==this.search.length||0!==this.options.length||this.closeSearchOptions()},onSearchFocus:function(){this.open=!0,this.$emit("search:focus")},onMousedown:function(){this.mousedown=!0},onMouseUp:function(){this.mousedown=!1},onSearchKeyDown:function(t){var e=this,n=function(t){return t.preventDefault(),!e.isComposing&&e.typeAheadSelect()},o={8:function(t){return e.maybeDeleteValue()},9:function(t){return e.onTab()},27:function(t){return e.onEscape()},38:function(t){return t.preventDefault(),e.typeAheadUp()},40:function(t){return t.preventDefault(),e.typeAheadDown()}};this.selectOnKeyCodes.forEach((function(t){return o[t]=n}));var i=this.mapKeydown(o,this);if("function"==typeof i[t.keyCode])return i[t.keyCode](t)}}},(function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"v-select",class:t.stateClasses,attrs:{dir:t.dir}},[t._t("header",null,null,t.scope.header),t._v(" "),n("div",{ref:"toggle",staticClass:"vs__dropdown-toggle",attrs:{id:"vs"+t.uid+"__combobox",role:"combobox","aria-expanded":t.dropdownOpen.toString(),"aria-owns":"vs"+t.uid+"__listbox","aria-label":"Search for option"},on:{mousedown:function(e){return t.toggleDropdown(e)}}},[n("div",{ref:"selectedOptions",staticClass:"vs__selected-options"},[t._l(t.selectedValue,(function(e){return t._t("selected-option-container",[n("span",{key:t.getOptionKey(e),staticClass:"vs__selected"},[t._t("selected-option",[t._v("\n            "+t._s(t.getOptionLabel(e))+"\n          ")],null,t.normalizeOptionForSlot(e)),t._v(" "),t.multiple?n("button",{ref:"deselectButtons",refInFor:!0,staticClass:"vs__deselect",attrs:{disabled:t.disabled,type:"button",title:"Deselect "+t.getOptionLabel(e),"aria-label":"Deselect "+t.getOptionLabel(e)},on:{click:function(n){return t.deselect(e)}}},[n(t.childComponents.Deselect,{tag:"component"})],1):t._e()],2)],{option:t.normalizeOptionForSlot(e),deselect:t.deselect,multiple:t.multiple,disabled:t.disabled})})),t._v(" "),t._t("search",[n("input",t._g(t._b({staticClass:"vs__search"},"input",t.scope.search.attributes,!1),t.scope.search.events))],null,t.scope.search)],2),t._v(" "),n("div",{ref:"actions",staticClass:"vs__actions"},[n("button",{directives:[{name:"show",rawName:"v-show",value:t.showClearButton,expression:"showClearButton"}],ref:"clearButton",staticClass:"vs__clear",attrs:{disabled:t.disabled,type:"button",title:"Clear Selected","aria-label":"Clear Selected"},on:{click:t.clearSelection}},[n(t.childComponents.Deselect,{tag:"component"})],1),t._v(" "),t._t("open-indicator",[t.noDrop?t._e():n(t.childComponents.OpenIndicator,t._b({tag:"component"},"component",t.scope.openIndicator.attributes,!1))],null,t.scope.openIndicator),t._v(" "),t._t("spinner",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.mutableLoading,expression:"mutableLoading"}],staticClass:"vs__spinner"},[t._v("Loading...")])],null,t.scope.spinner)],2)]),t._v(" "),n("transition",{attrs:{name:t.transition}},[t.dropdownOpen?n("ul",{directives:[{name:"append-to-body",rawName:"v-append-to-body"}],key:"vs"+t.uid+"__listbox",ref:"dropdownMenu",staticClass:"vs__dropdown-menu",attrs:{id:"vs"+t.uid+"__listbox",role:"listbox",tabindex:"-1"},on:{mousedown:function(e){return e.preventDefault(),t.onMousedown(e)},mouseup:t.onMouseUp}},[t._t("list-header",null,null,t.scope.listHeader),t._v(" "),t._l(t.filteredOptions,(function(e,o){return n("li",{key:t.getOptionKey(e),staticClass:"vs__dropdown-option",class:{"vs__dropdown-option--deselect":t.isOptionDeselectable(e)&&o===t.typeAheadPointer,"vs__dropdown-option--selected":t.isOptionSelected(e),"vs__dropdown-option--highlight":o===t.typeAheadPointer,"vs__dropdown-option--disabled":!t.selectable(e)},attrs:{id:"vs"+t.uid+"__option-"+o,role:"option","aria-selected":o===t.typeAheadPointer||null},on:{mouseover:function(n){t.selectable(e)&&(t.typeAheadPointer=o)},click:function(n){n.preventDefault(),n.stopPropagation(),t.selectable(e)&&t.select(e)}}},[t._t("option",[t._v("\n          "+t._s(t.getOptionLabel(e))+"\n        ")],null,t.normalizeOptionForSlot(e))],2)})),t._v(" "),0===t.filteredOptions.length?n("li",{staticClass:"vs__no-options"},[t._t("no-options",[t._v("\n          Sorry, no matching options.\n        ")],null,t.scope.noOptions)],2):t._e(),t._v(" "),t._t("list-footer",null,null,t.scope.listFooter)],2):n("ul",{staticStyle:{display:"none",visibility:"hidden"},attrs:{id:"vs"+t.uid+"__listbox",role:"listbox"}})]),t._v(" "),t._t("footer",null,null,t.scope.footer)],2)}),[],!1,null,null,null).exports,_={ajax:u,pointer:c,pointerScroll:l},O=m})(),o})()}));
//# sourceMappingURL=vue-select.js.map

/***/ }),

/***/ 203:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__203__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd define */
/******/ 	!function() {
/******/ 		__webpack_require__.amdD = function () {
/******/ 			throw new Error('define cannot be used indirect');
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AddressData": function() { return /* reexport */ AddressData.AddressData; },
  "AddressInput": function() { return /* reexport */ main_AddressInput; },
  "Alert": function() { return /* reexport */ main_Alert; },
  "AlertSize": function() { return /* reexport */ AlertSize; },
  "AlertStatus": function() { return /* reexport */ AlertStatus; },
  "ApiRequestConfig": function() { return /* reexport */ ApiRequestConfig.ApiRequestConfig; },
  "BackToTop": function() { return /* reexport */ main_BackToTop; },
  "BasicTextfield": function() { return /* reexport */ main_BasicTextfield; },
  "CarLicense": function() { return /* reexport */ main_CarLicense; },
  "Card": function() { return /* reexport */ main_Card; },
  "ChangeRequestType": function() { return /* reexport */ ChangeRequestType; },
  "Checkbox": function() { return /* reexport */ main_Checkbox; },
  "Collapser": function() { return /* reexport */ main_Collapser; },
  "Contact": function() { return /* reexport */ main_Contact; },
  "CustomButton": function() { return /* reexport */ main_CustomButton; },
  "DDSLines": function() { return /* reexport */ DDSLines; },
  "DataBox": function() { return /* reexport */ main_DataBox; },
  "DataLine": function() { return /* reexport */ main_DataLine; },
  "DataSection": function() { return /* reexport */ main_DataSection; },
  "DataTable": function() { return /* reexport */ main_DataTable; },
  "DateInput": function() { return /* reexport */ main_DateInput; },
  "EnterDateCardRow": function() { return /* reexport */ main_EnterDateCardRow; },
  "FlexGrid": function() { return /* reexport */ main_FlexGrid; },
  "GridContent": function() { return /* reexport */ main_GridContent; },
  "HeaderConfig": function() { return /* reexport */ DataTable_namespaceObject.HeaderConfig; },
  "HeaderTitle": function() { return /* reexport */ main_HeaderTitle; },
  "HoverableIcon": function() { return /* reexport */ main_HoverableIcon; },
  "HoverableIconBig": function() { return /* reexport */ main_HoverableIconBig; },
  "IconData": function() { return /* reexport */ DataBoxInterface.IconData; },
  "IconDataSpan": function() { return /* reexport */ DataBoxInterface.IconDataSpan; },
  "InputStatus": function() { return /* reexport */ InputStatus; },
  "KeyValueType": function() { return /* reexport */ KeyValueType.KeyValueType; },
  "Modal": function() { return /* reexport */ main_Modal; },
  "NameData": function() { return /* reexport */ NameData.NameData; },
  "NameInput": function() { return /* reexport */ main_NameInput; },
  "Navigation": function() { return /* reexport */ main_Navigation; },
  "Policy": function() { return /* reexport */ Policy.Policy; },
  "PolicyPaymentData": function() { return /* reexport */ Payment.PolicyPaymentData; },
  "PostboxTable": function() { return /* reexport */ main_PostboxTable; },
  "PostboxTeaser": function() { return /* reexport */ main_PostboxTeaser; },
  "PromotionArea": function() { return /* reexport */ main_PromotionArea; },
  "Radiogroup": function() { return /* reexport */ main_Radiogroup; },
  "ResponseTile": function() { return /* reexport */ main_ResponseTile; },
  "SearchResultBox": function() { return /* reexport */ main_SearchResultBox; },
  "SearchResultList": function() { return /* reexport */ main_SearchResultList; },
  "SearchResultListLine": function() { return /* reexport */ main_SearchResultListLine; },
  "SelectMenue": function() { return /* reexport */ main_SelectMenue; },
  "SelectablePolicyTile": function() { return /* reexport */ main_SelectablePolicyTile; },
  "SelfServiceForm": function() { return /* reexport */ main_SelfServiceForm; },
  "SelfServiceLabels": function() { return /* reexport */ SelfServiceLabels.SelfServiceLabels; },
  "SelfServiceTile": function() { return /* reexport */ main_SelfServiceTile; },
  "Spinner": function() { return /* reexport */ main_Spinner; },
  "StyleOption": function() { return /* reexport */ StyleOption; },
  "SubCard": function() { return /* reexport */ main_SubCard; },
  "SwitchButton": function() { return /* reexport */ main_SwitchButton; },
  "TabPane": function() { return /* reexport */ main_TabPane; },
  "TextArea": function() { return /* reexport */ main_TextArea; },
  "TextImageTeaser": function() { return /* reexport */ main_TextImageTeaser; },
  "ValidationRule": function() { return /* reexport */ main_ValidationRule; },
  "WidthType": function() { return /* reexport */ WidthType; },
  "getEmptyNewAddressData": function() { return /* reexport */ getEmptyNewAddressData; },
  "getEmptyNewNameData": function() { return /* reexport */ getEmptyNewNameData; },
  "getTranslatedDDSLine": function() { return /* reexport */ getTranslatedDDSLine; },
  "isMotorContract": function() { return /* reexport */ isMotorContract; }
});

// NAMESPACE OBJECT: ./src/components/types/DataTable.ts
var DataTable_namespaceObject = {};
__webpack_require__.r(DataTable_namespaceObject);
__webpack_require__.d(DataTable_namespaceObject, {
  "Y": function() { return WidthType; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__(679)
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(203);
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/da/tabpane/TabPane.vue?vue&type=template&id=708dc9e8&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasValidData)?_c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"tabs__toggler",on:{"click":_vm.toggleMobileList}},[_vm._v(" "+_vm._s(_vm.tabsTitle)+" "+_vm._s(_vm.currentIdentifier)+" "),_c('span',{staticClass:"mobile-icon icon-chevron-down",class:{ open: _vm.showMobileList }})]),(_vm.showMobileList)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMobileList),expression:"showMobileList"}],staticClass:"tabs__list mobile"},_vm._l((_vm.tabs),function(item,index){return _c('li',{key:index,staticClass:"tabs__tab",class:{ tab__selected: index === _vm.selectedIndex },on:{"click":function($event){_vm.setTabActive(index, item.tabId)
        _vm.toggleMobileList()}}},[_vm._v(" "+_vm._s(_vm.tabsTitle)+" "+_vm._s(item.tabId)+" ")])}),0):_vm._e(),(!_vm.showMobileList)?_c('ul',{staticClass:"tabs__list not-mobile"},_vm._l((_vm.tabs),function(item,index){return _c('li',{key:index,staticClass:"tabs__tab",class:{ tab__selected: index === _vm.selectedIndex },on:{"click":function($event){return _vm.setTabActive(index, item.tabId)}}},[_vm._v(" "+_vm._s(_vm.tabsTitle)+" "+_vm._s(item.tabId)+" ")])}),0):_vm._e()]):_vm._e()}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

// EXTERNAL MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
var vue_class_component_esm = __webpack_require__(904);
;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js
/** vue-property-decorator verson 8.5.1 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>




/** Used for keying reactive provide/inject properties */
var reactiveInjectKey = '__reactiveInject__';
/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}
/**
 * decorator of a reactive inject
 * @param from key
 * @return PropertyDecorator
 */
function InjectReactive(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            var fromKey_1 = !!options ? options.from || options : key;
            var defaultVal_1 = (!!options && options.default) || undefined;
            if (!componentOptions.computed)
                componentOptions.computed = {};
            componentOptions.computed[key] = function () {
                var obj = this[reactiveInjectKey];
                return obj ? obj[fromKey_1] : defaultVal_1;
            };
            componentOptions.inject[reactiveInjectKey] = reactiveInjectKey;
        }
    });
}
function produceProvide(original) {
    var provide = function () {
        var _this = this;
        var rv = typeof original === 'function' ? original.call(this) : original;
        rv = Object.create(rv || null);
        // set reactive services (propagates previous services if necessary)
        rv[reactiveInjectKey] = this[reactiveInjectKey] || {};
        for (var i in provide.managed) {
            rv[provide.managed[i]] = this[i];
        }
        var _loop_1 = function (i) {
            rv[provide.managedReactive[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
            Object.defineProperty(rv[reactiveInjectKey], provide.managedReactive[i], {
                enumerable: true,
                get: function () { return _this[i]; },
            });
        };
        var this_1 = this;
        for (var i in provide.managedReactive) {
            _loop_1(i);
        }
        return rv;
    };
    provide.managed = {};
    provide.managedReactive = {};
    return provide;
}
function needToProduceProvide(original) {
    return (typeof original !== 'function' ||
        (!original.managed && !original.managedReactive));
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managed[k] = key || k;
    });
}
/**
 * decorator of a reactive provide
 * @param key key
 * @return PropertyDecorator | void
 */
function ProvideReactive(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        // inject parent reactive services (if any)
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject = componentOptions.inject || {};
            componentOptions.inject[reactiveInjectKey] = {
                from: reactiveInjectKey,
                default: {},
            };
        }
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managedReactive[k] = key || k;
    });
}
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        (0,vue_class_component_esm.createDecorator)(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    // @ts-ignore
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return (0,vue_class_component_esm.createDecorator)(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, [emitName].concat(args));
                    }
                }
                else {
                    if (args.length === 0) {
                        _this.$emit(emitName, returnValue);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, returnValue, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, [emitName, returnValue].concat(args));
                    }
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
/**
 * decorator of a ref prop
 * @param refKey the ref key defined in template
 */
function Ref(refKey) {
    return (0,vue_class_component_esm.createDecorator)(function (options, key) {
        options.computed = options.computed || {};
        options.computed[key] = {
            cache: false,
            get: function () {
                return this.$refs[refKey || key];
            },
        };
    });
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/da/tabpane/TabPane.vue?vue&type=script&lang=ts&
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }




var TabPane = /*#__PURE__*/function (_Vue) {
  _inherits(TabPane, _Vue);

  var _super = _createSuper(TabPane);

  function TabPane() {
    var _this;

    _classCallCheck(this, TabPane);

    _this = _super.apply(this, arguments);
    _this.selectedIndex = 0;
    _this.showMobileList = false;
    _this.currentIdentifier = _this.initialIdentifier;
    return _this;
  }

  _createClass(TabPane, [{
    key: "hasValidData",
    get: function get() {
      if (this.tabs && this.tabs.length > 1) {
        return Array.isArray(this.tabs);
      }

      return false;
    }
  }, {
    key: "setTabActive",
    value: function setTabActive(index, tabId) {
      this.selectedIndex = index;
      this.currentIdentifier = tabId;
      this.$emit('identifierChanged', this.currentIdentifier);
    }
  }, {
    key: "toggleMobileList",
    value: function toggleMobileList() {
      this.showMobileList = !this.showMobileList;
    }
  }]);

  return TabPane;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], TabPane.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: function _default() {
    return [];
  }
})], TabPane.prototype, "tabs", void 0);

__decorate([Prop({
  default: ''
})], TabPane.prototype, "idProp", void 0);

__decorate([Prop({
  default: ''
})], TabPane.prototype, "tabsTitle", void 0);

__decorate([Prop({
  default: ''
})], TabPane.prototype, "initialIdentifier", void 0);

TabPane = __decorate([vue_class_component_esm["default"]], TabPane);
/* harmony default export */ var TabPanevue_type_script_lang_ts_ = (TabPane);
;// CONCATENATED MODULE: ./src/components/da/tabpane/TabPane.vue?vue&type=script&lang=ts&
 /* harmony default export */ var tabpane_TabPanevue_type_script_lang_ts_ = (TabPanevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/da/tabpane/TabPane.vue?vue&type=style&index=0&id=708dc9e8&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/da/tabpane/TabPane.vue?vue&type=style&index=0&id=708dc9e8&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/da/tabpane/TabPane.vue



;


/* normalize component */

var component = normalizeComponent(
  tabpane_TabPanevue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  "708dc9e8",
  null
  
)

/* harmony default export */ var tabpane_TabPane = (component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/da/navigation/BackToTop.vue?vue&type=template&id=72b43dbb&scoped=true&
var BackToTopvue_type_template_id_72b43dbb_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-styled"},[_c('Transition',[(_vm.isVisible)?_c('button',{staticClass:"btnScrollToTop",class:{ 'hidden-desktop': _vm.onlyMobile },attrs:{"title":"Go to top"},on:{"click":function($event){return _vm.topFunction()}}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 98 98"},attrs:{"id":"backtotopsvg","x":"0px","y":"0px","viewBox":"0 0 98 98","xml:space":"preserve"}},[_c('g',[_c('circle',{staticClass:"st0",attrs:{"id":"Oval","cx":"49","cy":"49","r":"49"}}),_c('path',{staticClass:"st1",attrs:{"d":"M34.5,42.6l4.5,4.3l6.7-6.4V69h6.5V40.5l6.7,6.4l4.5-4.3L49,29L34.5,42.6z M49,10c-21.5,0-39,17.5-39,39\n\t\tc0,21.5,17.5,39,39,39s39-17.5,39-39C88,27.5,70.5,10,49,10z M49,82c-18.2,0-33-14.8-33-33c0-18.2,14.8-33,33-33s33,14.8,33,33\n\t\tC82,67.2,67.2,82,49,82z"}})])])]):_vm._e()])],1)}
var BackToTopvue_type_template_id_72b43dbb_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/da/navigation/BackToTop.vue?vue&type=script&lang=ts&
function BackToTopvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return BackToTopvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, BackToTopvue_type_script_lang_ts_typeof(obj); }

function BackToTopvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BackToTopvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function BackToTopvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) BackToTopvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) BackToTopvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function BackToTopvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) BackToTopvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function BackToTopvue_type_script_lang_ts_setPrototypeOf(o, p) { BackToTopvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return BackToTopvue_type_script_lang_ts_setPrototypeOf(o, p); }

function BackToTopvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = BackToTopvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = BackToTopvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = BackToTopvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return BackToTopvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function BackToTopvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (BackToTopvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return BackToTopvue_type_script_lang_ts_assertThisInitialized(self); }

function BackToTopvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function BackToTopvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function BackToTopvue_type_script_lang_ts_getPrototypeOf(o) { BackToTopvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return BackToTopvue_type_script_lang_ts_getPrototypeOf(o); }




var BackToTop = /*#__PURE__*/function (_Vue) {
  BackToTopvue_type_script_lang_ts_inherits(BackToTop, _Vue);

  var _super = BackToTopvue_type_script_lang_ts_createSuper(BackToTop);

  function BackToTop() {
    var _this;

    BackToTopvue_type_script_lang_ts_classCallCheck(this, BackToTop);

    _this = _super.apply(this, arguments);
    _this.isVisible = false;
    _this.fadeTimeout = 0;
    _this.oldScrollStop = 0;
    return _this;
  }

  BackToTopvue_type_script_lang_ts_createClass(BackToTop, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      window.onscroll = function () {
        var scrollingUp = _this2.oldScrollStop > scrollY;
        _this2.oldScrollStop = scrollY;

        if (_this2.showOn == 'both') {
          _this2.scrollFunction();
        } else if (_this2.showOn == 'scrollUp') {
          if (scrollingUp) {
            _this2.scrollFunction();

            return;
          } else {
            _this2.fadeOut();

            return;
          }
        } else if (_this2.showOn == 'scrollDown') {
          if (scrollingUp) {
            _this2.fadeOut();

            return;
          } else {
            _this2.scrollFunction();

            return;
          }
        }
      };
    }
  }, {
    key: "fadeOut",
    value: function fadeOut() {
      clearTimeout(this.fadeTimeout);
      this.isVisible = false;
    }
  }, {
    key: "setFadeTimeout",
    value: function setFadeTimeout() {
      var _this3 = this;

      clearTimeout(this.fadeTimeout);
      this.fadeTimeout = setTimeout(function () {
        _this3.isVisible = false;
      }, this.fadeOutTime);
    }
  }, {
    key: "scrollFunction",
    value: function scrollFunction() {
      this.isVisible = scrollY > this.showAtHeight;
      if (this.isVisible && this.autoFadeOut) this.setFadeTimeout();
    } // When the user clicks on the button, scroll to the top of the document

  }, {
    key: "topFunction",
    value: function topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }]);

  return BackToTop;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: true
})], BackToTop.prototype, "onlyMobile", void 0);

__decorate([Prop({
  default: false
})], BackToTop.prototype, "autoFadeOut", void 0);

__decorate([Prop({
  default: 1500
})], BackToTop.prototype, "fadeOutTime", void 0);

__decorate([Prop({
  default: 'scrollDown'
})], BackToTop.prototype, "showOn", void 0);

__decorate([Prop({
  default: 1250
})], BackToTop.prototype, "showAtHeight", void 0);

BackToTop = __decorate([vue_class_component_esm["default"]], BackToTop);
/* harmony default export */ var BackToTopvue_type_script_lang_ts_ = (BackToTop);
;// CONCATENATED MODULE: ./src/components/da/navigation/BackToTop.vue?vue&type=script&lang=ts&
 /* harmony default export */ var navigation_BackToTopvue_type_script_lang_ts_ = (BackToTopvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/da/navigation/BackToTop.vue?vue&type=style&index=0&id=72b43dbb&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/da/navigation/BackToTop.vue?vue&type=style&index=0&id=72b43dbb&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/da/navigation/BackToTop.vue



;


/* normalize component */

var BackToTop_component = normalizeComponent(
  navigation_BackToTopvue_type_script_lang_ts_,
  BackToTopvue_type_template_id_72b43dbb_scoped_true_render,
  BackToTopvue_type_template_id_72b43dbb_scoped_true_staticRenderFns,
  false,
  null,
  "72b43dbb",
  null
  
)

/* harmony default export */ var navigation_BackToTop = (BackToTop_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/buttons/CustomButton.vue?vue&type=template&id=5ec3cc5a&scoped=true&
var CustomButtonvue_type_template_id_5ec3cc5a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"button",class:[
    { 'button--cta2': _vm.isCta2 },
    { 'button--cta3': _vm.isCta3 },
    { 'button--cta4': _vm.isCta4 },
    { 'button--cta5': _vm.isCta5 },
    { 'button--disabled': _vm.isCta1Disabled },
    { 'button--cta2--disabled': _vm.isCta2Disabled },
    { 'button--cta3--disabled': _vm.isCta3Disabled },
    { 'button--cta4--disabled': _vm.isCta4Disabled },
    { 'button--cta5--disabled': _vm.isCta5Disabled },
    { 'button--big': _vm.isCta1Big },
    { 'button--cta2--big': _vm.isCta2Big },
    { 'button--cta3--big': _vm.isCta3Big },
    { 'button--cta4--big': _vm.isCta4Big },
    { 'button--cta5--big': _vm.isCta5Big },
    { 'button--disabled--big': _vm.isCta1BigDisabled },
    { 'button--cta2--disabled--big': _vm.isCta2BigDisabled },
    { 'button--cta3--disabled--big': _vm.isCta3BigDisabled },
    { 'button--cta4--disabled--big': _vm.isCta4BigDisabled },
    { 'button--cta5--disabled--big': _vm.isCta5BigDisabled },
    { 'button--small': _vm.isCta1Small },
    { 'button--cta2--small': _vm.isCta2Small },
    { 'button--cta3--small': _vm.isCta3Small },
    { 'button--cta4--small': _vm.isCta4Small },
    { 'button--cta5--small': _vm.isCta5Small },
    { 'button--disabled--small': _vm.isCta1SmallDisabled },
    { 'button--cta2--disabled--small': _vm.isCta2SmallDisabled },
    { 'button--cta3--disabled--small': _vm.isCta3SmallDisabled },
    { 'button--cta4--disabled--small': _vm.isCta4SmallDisabled },
    { 'button--cta5--disabled--small': _vm.isCta5SmallDisabled },
    { 'button--pending': _vm.isCta1Pending },
    { 'button--cta2 button--pending': _vm.isCta2Pending },
    { 'button--cta3 button--pending': _vm.isCta3Pending },
    { 'button--cta4 button--pending': _vm.isCta4Pending },
    { 'button--cta5 button--pending': _vm.isCta5Pending },
    { 'button--cta-link': _vm.isCtaLink },
    { 'button--cta-link--small': _vm.isCtaLinkSmall },
    { 'button--cta-link--big': _vm.isCtaLinkBig },
    { 'button--cta-link--disabled': _vm.isCtaLinkDisabled },
    { 'button--cta-link--big--disabled': _vm.isCtaLinkSmallDisabled },
    { 'button--cta-link--big--disabled': _vm.isCtaLinkBigDisabled },
    { 'show-refresh-spinner': _vm.showRefreshSpinner },
    { 'is-styled': !_vm.disableStyles } ],attrs:{"disabled":!!_vm.disabledState || !!_vm.pendingState,"type":_vm.type,"id":_vm.buttonId,"data-track-id":_vm.trackId}},_vm.$listeners),[_vm._t("default")],2)}
var CustomButtonvue_type_template_id_5ec3cc5a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/types/ButtonType.ts
var ButtonType;

(function (ButtonType) {
  ButtonType["SUBMIT"] = "submit";
  ButtonType["RESET"] = "reset";
  ButtonType["BUTTON"] = "button";
})(ButtonType || (ButtonType = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/buttons/CustomButton.vue?vue&type=script&lang=ts&
function CustomButtonvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return CustomButtonvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, CustomButtonvue_type_script_lang_ts_typeof(obj); }

function CustomButtonvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CustomButtonvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function CustomButtonvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) CustomButtonvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) CustomButtonvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function CustomButtonvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) CustomButtonvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function CustomButtonvue_type_script_lang_ts_setPrototypeOf(o, p) { CustomButtonvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return CustomButtonvue_type_script_lang_ts_setPrototypeOf(o, p); }

function CustomButtonvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = CustomButtonvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = CustomButtonvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = CustomButtonvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return CustomButtonvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function CustomButtonvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (CustomButtonvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return CustomButtonvue_type_script_lang_ts_assertThisInitialized(self); }

function CustomButtonvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function CustomButtonvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function CustomButtonvue_type_script_lang_ts_getPrototypeOf(o) { CustomButtonvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return CustomButtonvue_type_script_lang_ts_getPrototypeOf(o); }





var CustomButton = /*#__PURE__*/function (_Vue) {
  CustomButtonvue_type_script_lang_ts_inherits(CustomButton, _Vue);

  var _super = CustomButtonvue_type_script_lang_ts_createSuper(CustomButton);

  function CustomButton() {
    CustomButtonvue_type_script_lang_ts_classCallCheck(this, CustomButton);

    return _super.apply(this, arguments);
  }

  CustomButtonvue_type_script_lang_ts_createClass(CustomButton, [{
    key: "isCta2",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta2') && this.buttonSize === 'medium';
    }
  }, {
    key: "isCta3",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta3') && this.buttonSize === 'medium';
    }
  }, {
    key: "isCta4",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta4') && this.buttonSize === 'medium';
    }
  }, {
    key: "isCta5",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta5') && this.buttonSize === 'medium';
    }
  }, {
    key: "isCta1Disabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta1') && this.buttonSize === 'medium';
    }
  }, {
    key: "isCta2Disabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta2') && this.buttonSize === 'medium';
    }
  }, {
    key: "isCta3Disabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta3') && this.buttonSize === 'medium';
    }
  }, {
    key: "isCta4Disabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta4') && this.buttonSize === 'medium';
    }
  }, {
    key: "isCta5Disabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta5') && this.buttonSize === 'medium';
    }
  }, {
    key: "isCta1Big",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta1') && this.buttonSize === 'big';
    }
  }, {
    key: "isCta2Big",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta2') && this.buttonSize === 'big';
    }
  }, {
    key: "isCta3Big",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta3') && this.buttonSize === 'big';
    }
  }, {
    key: "isCta4Big",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta4') && this.buttonSize === 'big';
    }
  }, {
    key: "isCta5Big",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta5') && this.buttonSize === 'big';
    }
  }, {
    key: "isCta1BigDisabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta1') && this.buttonSize === 'big';
    }
  }, {
    key: "isCta2BigDisabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta2') && this.buttonSize === 'big';
    }
  }, {
    key: "isCta3BigDisabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta3') && this.buttonSize === 'big';
    }
  }, {
    key: "isCta4BigDisabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta4') && this.buttonSize === 'big';
    }
  }, {
    key: "isCta5BigDisabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta5') && this.buttonSize === 'big';
    }
  }, {
    key: "isCta1Small",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta1') && this.buttonSize === 'small';
    }
  }, {
    key: "isCta2Small",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta2') && this.buttonSize === 'small';
    }
  }, {
    key: "isCta3Small",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta3') && this.buttonSize === 'small';
    }
  }, {
    key: "isCta4Small",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta4') && this.buttonSize === 'small';
    }
  }, {
    key: "isCta5Small",
    get: function get() {
      return !this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta5') && this.buttonSize === 'small';
    }
  }, {
    key: "isCta1SmallDisabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta1') && this.buttonSize === 'small';
    }
  }, {
    key: "isCta2SmallDisabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta2') && this.buttonSize === 'small';
    }
  }, {
    key: "isCta3SmallDisabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta3') && this.buttonSize === 'small';
    }
  }, {
    key: "isCta4SmallDisabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta4') && this.buttonSize === 'small';
    }
  }, {
    key: "isCta5SmallDisabled",
    get: function get() {
      return this.disabledState && (this.pendingState ? false : this.buttonColor === 'cta5') && this.buttonSize === 'small';
    }
  }, {
    key: "isCtaLink",
    get: function get() {
      return !this.disabledState && this.buttonColor === 'cta-link' && this.buttonSize === 'medium';
    }
  }, {
    key: "isCtaLinkSmall",
    get: function get() {
      return !this.disabledState && this.buttonColor === 'cta-link' && this.buttonSize === 'small';
    }
  }, {
    key: "isCtaLinkBig",
    get: function get() {
      return !this.disabledState && this.buttonColor === 'cta-link' && this.buttonSize === 'big';
    }
  }, {
    key: "isCtaLinkDisabled",
    get: function get() {
      return this.disabledState && this.buttonColor === 'cta-link' && this.buttonSize === 'medium';
    }
  }, {
    key: "isCtaLinkSmallDisabled",
    get: function get() {
      return this.disabledState && this.buttonColor === 'cta-link' && this.buttonSize === 'small';
    }
  }, {
    key: "isCtaLinkBigDisabled",
    get: function get() {
      return this.disabledState && this.buttonColor === 'cta-link' && this.buttonSize === 'big';
    }
  }, {
    key: "isCta1Pending",
    get: function get() {
      return this.pendingState;
    }
  }, {
    key: "isCta2Pending",
    get: function get() {
      return this.pendingState && this.buttonColor === 'cta2';
    }
  }, {
    key: "isCta3Pending",
    get: function get() {
      return this.pendingState && this.buttonColor === 'cta3';
    }
  }, {
    key: "isCta4Pending",
    get: function get() {
      return this.pendingState && this.buttonColor === 'cta4';
    }
  }, {
    key: "isCta5Pending",
    get: function get() {
      return this.pendingState && this.buttonColor === 'cta5';
    }
  }, {
    key: "type",
    get: function get() {
      switch (this.buttonType) {
        case ButtonType.SUBMIT:
        case ButtonType.RESET:
        case ButtonType.BUTTON:
          return this.buttonType;

        default:
          // Returning undefined will make this a submit button (as that is the default)
          return undefined;
      }
    }
  }]);

  return CustomButton;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], CustomButton.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: false
})], CustomButton.prototype, "pendingState", void 0);

__decorate([Prop({
  default: false
})], CustomButton.prototype, "disabledState", void 0);

__decorate([Prop({
  default: ''
})], CustomButton.prototype, "buttonColor", void 0);

__decorate([Prop({
  default: 'medium'
})], CustomButton.prototype, "buttonSize", void 0);

__decorate([Prop({
  default: false
})], CustomButton.prototype, "showRefreshSpinner", void 0);

__decorate([Prop()], CustomButton.prototype, "buttonType", void 0);

__decorate([Prop()], CustomButton.prototype, "buttonId", void 0);

__decorate([Prop()], CustomButton.prototype, "trackId", void 0);

CustomButton = __decorate([vue_class_component_esm["default"]], CustomButton);
/* harmony default export */ var CustomButtonvue_type_script_lang_ts_ = (CustomButton);
;// CONCATENATED MODULE: ./src/components/base/buttons/CustomButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var buttons_CustomButtonvue_type_script_lang_ts_ = (CustomButtonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/buttons/CustomButton.vue?vue&type=style&index=0&id=5ec3cc5a&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/buttons/CustomButton.vue?vue&type=style&index=0&id=5ec3cc5a&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/buttons/CustomButton.vue



;


/* normalize component */

var CustomButton_component = normalizeComponent(
  buttons_CustomButtonvue_type_script_lang_ts_,
  CustomButtonvue_type_template_id_5ec3cc5a_scoped_true_render,
  CustomButtonvue_type_template_id_5ec3cc5a_scoped_true_staticRenderFns,
  false,
  null,
  "5ec3cc5a",
  null
  
)

/* harmony default export */ var buttons_CustomButton = (CustomButton_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/Card.vue?vue&type=template&id=6ae76e6a&scoped=true&
var Cardvue_type_template_id_6ae76e6a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-outer",class:{ 'is-styled': !_vm.disableStyles },style:(_vm.maxWidthValue)},[_c('div',{class:[
      _vm.classInput,
      _vm.cardClass,
      { 'is-teaser': _vm.isTeaser },
      { 'is-policy': _vm.isPolicy || _vm.isPolicyDetails },
      { 'is-policy-details': _vm.isPolicyDetails },
      { 'has-collapser-content': _vm.hasCollapserContent } ],attrs:{"data-track-id":_vm.trackId}},[(this.$slots.infobox)?_c('div',{staticClass:"card__info-box",class:("card__info-box--" + _vm.responsiveClass),attrs:{"data-observe-resizes":""}},[_vm._t("infobox")],2):_vm._e(),(_vm.title.length > 0)?_c('div',{staticClass:"card__header",class:[("card__header--" + _vm.responsiveClass), { clickable: _vm.isPolicyDetails }],attrs:{"data-observe-resizes":"","aria-expanded":_vm.isExpanded ? 'true' : 'false'},on:{"click":_vm.toggleExpansion}},[_c('div',{class:_vm.iconClassNames.outerClassName},[(_vm.iconClassNames.iconClassName)?_c('span',{staticClass:"has-icon__icon",class:_vm.iconClassNames.iconClassName}):_vm._e(),_c('div',{staticClass:"card__title--wrapper",class:{
            card__title: !_vm.titleFontsizeBig,
            'card__title--big': _vm.titleFontsizeBig,
            'card__title--bold': _vm.boldFont,
            'card__title--isButton': _vm.boldFont,
          }},[_c('h2',[_vm._v(_vm._s(_vm.title))]),(this.$slots['title-extra'])?_c('h3',{staticClass:"card__title-extra"},[_vm._t("title-extra")],2):_vm._e(),(_vm.isPolicyDetails)?_c('button',{staticClass:"toggler",attrs:{"aria-controls":_vm.id}},[_c('span',{staticClass:"toggler__icon",class:[{ 'icon-circle-plus': _vm.isExpanded }, { 'icon-circle-minus': !_vm.isExpanded }]})]):_vm._e()])]),(_vm.withBackground)?_c('div',{staticClass:"card__header--withBackground"}):_vm._e(),(_vm.headerDivider)?_c('div',{staticClass:"card__divider"}):_vm._e()]):_vm._e(),_c('div',{staticClass:"card__content",class:[("card__content--" + _vm.responsiveClass), { 'card__content--hide': _vm.isExpanded }],attrs:{"data-observe-resizes":""}},[_vm._t("content"),(_vm.iconClassNames.iconClassName && _vm.isPolicyDetails)?_c('span',{class:[
          _vm.iconClassNames.iconClassName,
          { 'has-icon__bgIcon': _vm.isPolicyDetails, 'has-icon__bgIcon--hide': _vm.hideBigBgIcon } ]}):_vm._e()],2),(this.$slots.footer)?_c('div',{staticClass:"card__footer",class:[("card__footer--" + _vm.responsiveClass), { 'card__footer--hide': _vm.isExpanded }],attrs:{"data-observe-resizes":""}},[(_vm.footerDivider)?_c('div',{staticClass:"card__divider card__divider--footer"}):_vm._e(),_vm._t("footer")],2):_vm._e(),(_vm.loadingState)?_vm._t("spinner",function(){return [_c('div',{staticClass:"card__spinner"},[_c('Spinner',{attrs:{"disableStyles":_vm.disableStyles,"isGlobal":false}})],1)]}):_vm._e()],2)])}
var Cardvue_type_template_id_6ae76e6a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mapper/iconClasses.map.ts
var IconClassMap = new Map();
/* TODO: set insurance-class (contract.insuranceClass) instead of insurance-title */

IconClassMap.set('Motor', 'icon-auto');
IconClassMap.set('Household', 'icon-hausrat');
IconClassMap.set('Liability', 'icon-haftpflicht');
IconClassMap.set('Accident', 'icon-unfall');
IconClassMap.set('LegalProtection', 'icon-rechtsschutz');
IconClassMap.set('BundledProperty', 'icon-package');
IconClassMap.set('Glass', 'icon-glas_kaputt_outline');
IconClassMap.set('FondgebundeneVersicherung', 'icon-klv');
IconClassMap.set('Kapitalversicherung', 'icon-klv');
IconClassMap.set('Risikolebenversicherung', 'icon-rislv');
IconClassMap.set('PrivateRentenversicherung', 'icon-renlv');
IconClassMap.set('Existenzschutz', 'icon-existenz');
IconClassMap.set('RiesterRente', 'icon-renlv');
IconClassMap.set('BasisRente', 'icon-renlv');
IconClassMap.set('Berufsunfaehigkeitsversicherung', 'icon-buv');
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/Spinner.vue?vue&type=template&id=5bce95a5&scoped=true&
var Spinnervue_type_template_id_5bce95a5_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"overlay",class:[{ 'is-styled': !_vm.disableStyles }, { 'overlay--global': _vm.isGlobal }]},[_c('div',{staticClass:"spinner"})])])}
var Spinnervue_type_template_id_5bce95a5_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/Spinner.vue?vue&type=script&lang=ts&
function Spinnervue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return Spinnervue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Spinnervue_type_script_lang_ts_typeof(obj); }

function Spinnervue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Spinnervue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) Spinnervue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) Spinnervue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Spinnervue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Spinnervue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) Spinnervue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function Spinnervue_type_script_lang_ts_setPrototypeOf(o, p) { Spinnervue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Spinnervue_type_script_lang_ts_setPrototypeOf(o, p); }

function Spinnervue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = Spinnervue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Spinnervue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Spinnervue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Spinnervue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function Spinnervue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (Spinnervue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Spinnervue_type_script_lang_ts_assertThisInitialized(self); }

function Spinnervue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Spinnervue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Spinnervue_type_script_lang_ts_getPrototypeOf(o) { Spinnervue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Spinnervue_type_script_lang_ts_getPrototypeOf(o); }




var Spinner = /*#__PURE__*/function (_Vue) {
  Spinnervue_type_script_lang_ts_inherits(Spinner, _Vue);

  var _super = Spinnervue_type_script_lang_ts_createSuper(Spinner);

  function Spinner() {
    Spinnervue_type_script_lang_ts_classCallCheck(this, Spinner);

    return _super.apply(this, arguments);
  }

  return Spinnervue_type_script_lang_ts_createClass(Spinner);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], Spinner.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: false
})], Spinner.prototype, "isGlobal", void 0);

__decorate([Prop({
  default: true
})], Spinner.prototype, "showOverlay", void 0);

Spinner = __decorate([vue_class_component_esm["default"]], Spinner);
/* harmony default export */ var Spinnervue_type_script_lang_ts_ = (Spinner);
;// CONCATENATED MODULE: ./src/components/base/modules/Spinner.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_Spinnervue_type_script_lang_ts_ = (Spinnervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/Spinner.vue?vue&type=style&index=0&id=5bce95a5&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/Spinner.vue?vue&type=style&index=0&id=5bce95a5&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/modules/Spinner.vue



;


/* normalize component */

var Spinner_component = normalizeComponent(
  modules_Spinnervue_type_script_lang_ts_,
  Spinnervue_type_template_id_5bce95a5_scoped_true_render,
  Spinnervue_type_template_id_5bce95a5_scoped_true_staticRenderFns,
  false,
  null,
  "5bce95a5",
  null
  
)

/* harmony default export */ var modules_Spinner = (Spinner_component.exports);
// EXTERNAL MODULE: ./node_modules/vue-mixin-decorator/dist/vue-mixin-decorator.umd.js
var vue_mixin_decorator_umd = __webpack_require__(390);
;// CONCATENATED MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ var ResizeObserver_es = (index);

;// CONCATENATED MODULE: ./src/mixin/responsiveClassMixin.ts
function responsiveClassMixin_typeof(obj) { "@babel/helpers - typeof"; return responsiveClassMixin_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, responsiveClassMixin_typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function responsiveClassMixin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function responsiveClassMixin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function responsiveClassMixin_createClass(Constructor, protoProps, staticProps) { if (protoProps) responsiveClassMixin_defineProperties(Constructor.prototype, protoProps); if (staticProps) responsiveClassMixin_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function responsiveClassMixin_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) responsiveClassMixin_setPrototypeOf(subClass, superClass); }

function responsiveClassMixin_setPrototypeOf(o, p) { responsiveClassMixin_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return responsiveClassMixin_setPrototypeOf(o, p); }

function responsiveClassMixin_createSuper(Derived) { var hasNativeReflectConstruct = responsiveClassMixin_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = responsiveClassMixin_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = responsiveClassMixin_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return responsiveClassMixin_possibleConstructorReturn(this, result); }; }

function responsiveClassMixin_possibleConstructorReturn(self, call) { if (call && (responsiveClassMixin_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return responsiveClassMixin_assertThisInitialized(self); }

function responsiveClassMixin_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function responsiveClassMixin_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function responsiveClassMixin_getPrototypeOf(o) { responsiveClassMixin_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return responsiveClassMixin_getPrototypeOf(o); }






var ResponsiveClassMixin = /*#__PURE__*/function (_Vue) {
  responsiveClassMixin_inherits(ResponsiveClassMixin, _Vue);

  var _super = responsiveClassMixin_createSuper(ResponsiveClassMixin);

  function ResponsiveClassMixin() {
    var _this;

    responsiveClassMixin_classCallCheck(this, ResponsiveClassMixin);

    _this = _super.apply(this, arguments);
    _this.responsiveClass = 'sm';
    return _this;
  }

  responsiveClassMixin_createClass(ResponsiveClassMixin, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      var observeMe = this.$el.querySelector('[data-observe-resizes]');
      var re = new ResizeObserver_es(function (entries) {
        var _iterator = _createForOfIteratorHelper(entries),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            var cr = entry.contentRect;

            if (cr.width <= 427) {
              _this2.responsiveClass = 'xs';
            } else if (cr.width < 600 && cr.width > 427) {
              _this2.responsiveClass = 'sm';
            } else if (cr.width > 600 && cr.width < 800) {
              _this2.responsiveClass = 'md';
            } else if (cr.width >= 800) {
              _this2.responsiveClass = 'lg';
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });

      if (observeMe) {
        re.observe(observeMe);
      }
    }
  }]);

  return ResponsiveClassMixin;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

ResponsiveClassMixin = __decorate([vue_mixin_decorator_umd.Mixin], ResponsiveClassMixin);
/* harmony default export */ var responsiveClassMixin = (ResponsiveClassMixin);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/Card.vue?vue&type=script&lang=ts&
function Cardvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return Cardvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Cardvue_type_script_lang_ts_typeof(obj); }

function Cardvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Cardvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Cardvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) Cardvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) Cardvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Cardvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) Cardvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function Cardvue_type_script_lang_ts_setPrototypeOf(o, p) { Cardvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Cardvue_type_script_lang_ts_setPrototypeOf(o, p); }

function Cardvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = Cardvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Cardvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Cardvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Cardvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function Cardvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (Cardvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Cardvue_type_script_lang_ts_assertThisInitialized(self); }

function Cardvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Cardvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Cardvue_type_script_lang_ts_getPrototypeOf(o) { Cardvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Cardvue_type_script_lang_ts_getPrototypeOf(o); }







var Card = /*#__PURE__*/function (_Vue) {
  Cardvue_type_script_lang_ts_inherits(Card, _Vue);

  var _super = Cardvue_type_script_lang_ts_createSuper(Card);

  function Card() {
    var _this;

    Cardvue_type_script_lang_ts_classCallCheck(this, Card);

    _this = _super.apply(this, arguments);
    _this.expandedStatus = _this.expanded;
    return _this;
  } // PolicyCollapserBlock


  Cardvue_type_script_lang_ts_createClass(Card, [{
    key: "toggleExpansion",
    value: function toggleExpansion() {
      if (this.isPolicyDetails) this.expandedStatus = !this.isExpanded;
    }
  }, {
    key: "isExpanded",
    get: function get() {
      return this.expandedStatus;
    }
  }, {
    key: "iconClassNames",
    get: function get() {
      var pattern = /^icon-.*/gi;

      if (this.iconClass && this.iconClass.toString().match(pattern) !== null) {
        return {
          outerClassName: "has-icon has-icon--".concat(this.iconClass),
          iconClassName: this.iconClass
        };
      }

      var outerClass = IconClassMap.has(this.iconClass) ? "has-icon has-icon--".concat(IconClassMap.get(this.iconClass)) : null;
      var iconClass = IconClassMap.has(this.iconClass) ? IconClassMap.get(this.iconClass) : null;
      return {
        outerClassName: outerClass,
        iconClassName: iconClass
      };
    }
  }, {
    key: "maxWidthValue",
    get: function get() {
      return this.maxWidth > 0 ? "maxWidth: ".concat(this.maxWidth, "px") : "maxWidth: 100%";
    }
  }, {
    key: "classInput",
    get: function get() {
      return this.className;
    }
  }, {
    key: "cardClass",
    get: function get() {
      var cardClass = this.boxShadow ? 'card-box-shadow' : 'card';

      switch (this.dockedPosition) {
        case 'top':
          cardClass += '--docked-top';
          break;

        case 'middle':
          cardClass += '--docked';
          break;

        case 'bottom':
          cardClass += '--docked-bottom';
          break;
      }

      if (this.clickable) {
        cardClass += '--clickable';
      }

      return cardClass;
    }
  }]);

  return Card;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: ''
})], Card.prototype, "title", void 0);

__decorate([Prop({
  default: ''
})], Card.prototype, "iconClass", void 0);

__decorate([Prop({
  default: ''
})], Card.prototype, "className", void 0);

__decorate([Prop({
  default: ''
})], Card.prototype, "dockedPosition", void 0);

__decorate([Prop({
  default: null
})], Card.prototype, "idProp", void 0);

__decorate([Prop()], Card.prototype, "trackId", void 0);

__decorate([Prop({
  default: null
})], Card.prototype, "maxWidth", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "loadingState", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "isTeaser", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "isPolicy", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "isPolicyDetails", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "hasCollapserContent", void 0);

__decorate([Prop({
  default: true
})], Card.prototype, "hideBigBgIcon", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "isCollapsable", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "titleFontsizeBig", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "boldFont", void 0);

__decorate([Prop({
  default: true
})], Card.prototype, "footerDivider", void 0);

__decorate([Prop({
  default: true
})], Card.prototype, "headerDivider", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "boxShadow", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "withBackground", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "clickable", void 0);

__decorate([Prop({
  default: false
})], Card.prototype, "expanded", void 0);

__decorate([Prop({
  default: ''
})], Card.prototype, "id", void 0);

Card = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    Spinner: modules_Spinner
  },
  mixins: [responsiveClassMixin]
})], Card);
/* harmony default export */ var Cardvue_type_script_lang_ts_ = (Card);
;// CONCATENATED MODULE: ./src/components/base/container/Card.vue?vue&type=script&lang=ts&
 /* harmony default export */ var container_Cardvue_type_script_lang_ts_ = (Cardvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/Card.vue?vue&type=style&index=0&id=6ae76e6a&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/container/Card.vue?vue&type=style&index=0&id=6ae76e6a&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/container/Card.vue



;


/* normalize component */

var Card_component = normalizeComponent(
  container_Cardvue_type_script_lang_ts_,
  Cardvue_type_template_id_6ae76e6a_scoped_true_render,
  Cardvue_type_template_id_6ae76e6a_scoped_true_staticRenderFns,
  false,
  null,
  "6ae76e6a",
  null
  
)

/* harmony default export */ var container_Card = (Card_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/SubCard.vue?vue&type=template&id=72dc5934&scoped=true&
var SubCardvue_type_template_id_72dc5934_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subCard is-styled"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"text title"},[_vm._v(_vm._s(_vm.subCardCurrentDataLabel))]),_vm._l((_vm.subCardCurrentInfoText),function(text,index){return _c('div',{key:index},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(text))])])})],2),_c('div',{staticClass:"content"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.subCardTitle))]),_vm._t("main")],2)])}
var SubCardvue_type_template_id_72dc5934_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/SubCard.vue?vue&type=script&lang=ts&
function SubCardvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return SubCardvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, SubCardvue_type_script_lang_ts_typeof(obj); }

function SubCardvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SubCardvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) SubCardvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) SubCardvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function SubCardvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SubCardvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) SubCardvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function SubCardvue_type_script_lang_ts_setPrototypeOf(o, p) { SubCardvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SubCardvue_type_script_lang_ts_setPrototypeOf(o, p); }

function SubCardvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = SubCardvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SubCardvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SubCardvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SubCardvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function SubCardvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (SubCardvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return SubCardvue_type_script_lang_ts_assertThisInitialized(self); }

function SubCardvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SubCardvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SubCardvue_type_script_lang_ts_getPrototypeOf(o) { SubCardvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SubCardvue_type_script_lang_ts_getPrototypeOf(o); }




var SubCard = /*#__PURE__*/function (_Vue) {
  SubCardvue_type_script_lang_ts_inherits(SubCard, _Vue);

  var _super = SubCardvue_type_script_lang_ts_createSuper(SubCard);

  function SubCard() {
    SubCardvue_type_script_lang_ts_classCallCheck(this, SubCard);

    return _super.apply(this, arguments);
  }

  return SubCardvue_type_script_lang_ts_createClass(SubCard);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  required: false,
  default: ''
})], SubCard.prototype, "subCardCurrentDataLabel", void 0);

__decorate([Prop({
  required: false,
  default: function _default() {
    return [''];
  }
})], SubCard.prototype, "subCardCurrentInfoText", void 0);

__decorate([Prop({
  required: false,
  default: ''
})], SubCard.prototype, "subCardTitle", void 0);

SubCard = __decorate([(0,vue_class_component_esm["default"])({
  components: {}
})], SubCard);
/* harmony default export */ var SubCardvue_type_script_lang_ts_ = (SubCard);
;// CONCATENATED MODULE: ./src/components/base/container/SubCard.vue?vue&type=script&lang=ts&
 /* harmony default export */ var container_SubCardvue_type_script_lang_ts_ = (SubCardvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/SubCard.vue?vue&type=style&index=0&id=72dc5934&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/container/SubCard.vue?vue&type=style&index=0&id=72dc5934&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/container/SubCard.vue



;


/* normalize component */

var SubCard_component = normalizeComponent(
  container_SubCardvue_type_script_lang_ts_,
  SubCardvue_type_template_id_72dc5934_scoped_true_render,
  SubCardvue_type_template_id_72dc5934_scoped_true_staticRenderFns,
  false,
  null,
  "72dc5934",
  null
  
)

/* harmony default export */ var container_SubCard = (SubCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/Collapser.vue?vue&type=template&id=65102a73&scoped=true&
var Collapservue_type_template_id_65102a73_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"collapser"},[(!_vm.collapseDownwards)?_c('div',{staticClass:"collapser__block",class:{ 'collapser__block--show': _vm.isExpanded },attrs:{"id":_vm.id}},[_vm._t("collapserContent")],2):_vm._e(),_c('div',[_c('button',{staticClass:"toggler",class:_vm.collapserClass,attrs:{"aria-expanded":_vm.isExpanded ? 'true' : 'false',"aria-controls":_vm.id,"data-track-id":_vm.trackId},on:{"click":_vm.toggleExpansion}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"subTitle"},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")])]),_c('div',{staticClass:"icon"},[_c('span',{staticClass:"toggler__icon",class:[{ 'icon-circle-minus': _vm.isExpanded }, { 'icon-circle-plus': !_vm.isExpanded }]})])]),(this.$slots['collapserTeaserContent'])?_c('div',{staticClass:"collapser__teaserContent",class:{ 'collapser__teaserContent--hide': _vm.isExpanded }},[_vm._t("collapserTeaserContent")],2):_vm._e()]),(_vm.collapseDownwards)?_c('div',{staticClass:"collapser__block",class:{ 'collapser__block--show': _vm.isExpanded },attrs:{"id":_vm.id}},[_vm._t("collapserContent")],2):_vm._e()])])}
var Collapservue_type_template_id_65102a73_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/Collapser.vue?vue&type=script&lang=ts&
function Collapservue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return Collapservue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Collapservue_type_script_lang_ts_typeof(obj); }

function Collapservue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Collapservue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Collapservue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) Collapservue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) Collapservue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Collapservue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) Collapservue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function Collapservue_type_script_lang_ts_setPrototypeOf(o, p) { Collapservue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Collapservue_type_script_lang_ts_setPrototypeOf(o, p); }

function Collapservue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = Collapservue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Collapservue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Collapservue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Collapservue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function Collapservue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (Collapservue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Collapservue_type_script_lang_ts_assertThisInitialized(self); }

function Collapservue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Collapservue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Collapservue_type_script_lang_ts_getPrototypeOf(o) { Collapservue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Collapservue_type_script_lang_ts_getPrototypeOf(o); }





var Collapser = /*#__PURE__*/function (_Vue) {
  Collapservue_type_script_lang_ts_inherits(Collapser, _Vue);

  var _super = Collapservue_type_script_lang_ts_createSuper(Collapser);

  function Collapser() {
    var _this;

    Collapservue_type_script_lang_ts_classCallCheck(this, Collapser);

    _this = _super.apply(this, arguments);
    _this.expandedStatus = _this.expanded;
    return _this;
  }

  Collapservue_type_script_lang_ts_createClass(Collapser, [{
    key: "toggleExpansion",
    value: function toggleExpansion() {
      this.expandedStatus = !this.isExpanded;
    }
  }, {
    key: "title",
    get: function get() {
      return this.isExpanded && this.expandedTitle !== '' ? this.expandedTitle : this.collapserTitle;
    }
  }, {
    key: "subTitle",
    get: function get() {
      return this.isExpanded && this.expandedTitle !== '' ? this.expandedTitle : this.collapserSubTitle;
    }
  }, {
    key: "isExpanded",
    get: function get() {
      return this.expandedStatus;
    }
  }]);

  return Collapser;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: ''
})], Collapser.prototype, "collapserTitle", void 0);

__decorate([Prop({
  default: ''
})], Collapser.prototype, "collapserSubTitle", void 0);

__decorate([Prop({
  default: ''
})], Collapser.prototype, "expandedTitle", void 0);

__decorate([Prop({
  default: false
})], Collapser.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: false
})], Collapser.prototype, "expanded", void 0);

__decorate([Prop({
  default: ''
})], Collapser.prototype, "id", void 0);

__decorate([Prop({
  default: 'collapser__headline'
})], Collapser.prototype, "collapserClass", void 0);

__decorate([Prop()], Collapser.prototype, "trackId", void 0);

__decorate([Prop({
  default: true
})], Collapser.prototype, "collapseDownwards", void 0);

Collapser = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    CustomButton: buttons_CustomButton
  }
})], Collapser);
/* harmony default export */ var Collapservue_type_script_lang_ts_ = (Collapser);
;// CONCATENATED MODULE: ./src/components/base/container/Collapser.vue?vue&type=script&lang=ts&
 /* harmony default export */ var container_Collapservue_type_script_lang_ts_ = (Collapservue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/Collapser.vue?vue&type=style&index=0&id=65102a73&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/container/Collapser.vue?vue&type=style&index=0&id=65102a73&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/container/Collapser.vue



;


/* normalize component */

var Collapser_component = normalizeComponent(
  container_Collapservue_type_script_lang_ts_,
  Collapservue_type_template_id_65102a73_scoped_true_render,
  Collapservue_type_template_id_65102a73_scoped_true_staticRenderFns,
  false,
  null,
  "65102a73",
  null
  
)

/* harmony default export */ var container_Collapser = (Collapser_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/BasicTextfield.vue?vue&type=template&id=225adea7&scoped=true&
var BasicTextfieldvue_type_template_id_225adea7_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"form-group",class:[
      { 'form-group--invalid': _vm.isError },
      { 'form-group--filled': _vm.isFilled },
      { 'form-group--empty': _vm.isEmpty },
      { 'form-group--disabled': _vm.isDisabled || _vm.isLocked } ]},[_c('input',_vm._g({staticClass:"form-group__control",class:[
        { 'has-left-icon': _vm.hasLeftIcon },
        { 'display-focused': _vm.showPWTriggerClass },
        { 'display-native-date': false },
        { 'checkmark-padding': _vm.showCheckmark && _vm.isValid } ],attrs:{"id":_vm.id,"type":_vm.inputType,"pattern":_vm.pattern,"inputmode":_vm.inputMode,"formnovalidate":_vm.formnovalidate,"autocomplete":_vm.autocomplete,"readonly":_vm.lockableTrigger && (_vm.isDisabled || _vm.isLocked),"disabled":!_vm.lockableTrigger && (_vm.isDisabled || _vm.isLocked),"placeholder":_vm.showPlaceHolder ? _vm.placeholder : '',"min":_vm.min,"max":_vm.max},domProps:{"value":_vm.value},on:{"blur":_vm.onBlur,"focus":_vm.onFocus}},Object.assign({}, _vm.$listeners,
        {input: function (event) { return _vm.$emit('input', event.target.value); }}))),(_vm.showCheckmark && _vm.isValid && _vm.showCheckmark && !_vm.isError)?_c('span',{staticClass:"icon-check"}):_vm._e(),(_vm.passwordVisibilityTrigger)?_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPWTrigger),expression:"showPWTrigger"}],staticClass:"form-group__show-value-btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showHidePWValue.apply(null, arguments)},"focus":_vm.showPWtriggerFocused,"blur":_vm.onBlur}},[_c('span',{staticClass:"icon-auge"})]):_vm._e(),(_vm.lockableTrigger)?_c('button',{staticClass:"form-group__locker-btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.toggleLocker.apply(null, arguments)}}},[(_vm.toggleLockerBtnLocked)?_c('span',{staticClass:"icon-locked"}):_c('span',{staticClass:"icon-unlocked"})]):_vm._e(),_c('label',{staticClass:"form-group__label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"form-group__bar"}),(_vm.isError)?_c('div',{staticClass:"form-group__error"},[_vm._t("error")],2):_vm._e(),_c('div',{staticClass:"form-group__info info-normal",class:[{ 'form-group__info--fade-in': _vm.showInfoText }, { 'form-group__info--fade-out': !_vm.showInfoText }]},[_vm._t("info")],2),(_vm.lockableTrigger)?_c('div',{staticClass:"form-group__info info-lockable",class:[
        { 'form-group__info--fade-in': _vm.showLockedInfoText },
        { 'form-group__info--fade-out': !_vm.showLockedInfoText } ]},[_vm._v(" "+_vm._s(_vm.showLockedInfoText ? 'Möchten Sie Änderungen vornehmen? Klicken Sie dazu auf das Schlosssymbol.' : '')+" ")]):_vm._e()])])}
var BasicTextfieldvue_type_template_id_225adea7_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixin/idMixin.ts
function idMixin_typeof(obj) { "@babel/helpers - typeof"; return idMixin_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, idMixin_typeof(obj); }

function idMixin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function idMixin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function idMixin_createClass(Constructor, protoProps, staticProps) { if (protoProps) idMixin_defineProperties(Constructor.prototype, protoProps); if (staticProps) idMixin_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function idMixin_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) idMixin_setPrototypeOf(subClass, superClass); }

function idMixin_setPrototypeOf(o, p) { idMixin_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return idMixin_setPrototypeOf(o, p); }

function idMixin_createSuper(Derived) { var hasNativeReflectConstruct = idMixin_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = idMixin_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = idMixin_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return idMixin_possibleConstructorReturn(this, result); }; }

function idMixin_possibleConstructorReturn(self, call) { if (call && (idMixin_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return idMixin_assertThisInitialized(self); }

function idMixin_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function idMixin_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function idMixin_getPrototypeOf(o) { idMixin_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return idMixin_getPrototypeOf(o); }






var IdMixin = /*#__PURE__*/function (_Vue) {
  idMixin_inherits(IdMixin, _Vue);

  var _super = idMixin_createSuper(IdMixin);

  function IdMixin() {
    var _this;

    idMixin_classCallCheck(this, IdMixin);

    _this = _super.call(this);
    _this.id = '';
    return _this;
  }

  idMixin_createClass(IdMixin, [{
    key: "created",
    value: function created() {
      var dt = new Date().getTime();

      if (this.idProp) {
        this.id = this.idProp;
      } else {
        this.id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
        });
      }
    }
  }]);

  return IdMixin;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: ''
})], IdMixin.prototype, "idProp", void 0);

IdMixin = __decorate([vue_mixin_decorator_umd.Mixin], IdMixin);
/* harmony default export */ var idMixin = (IdMixin);
;// CONCATENATED MODULE: ./src/components/base/input/InputStatus.ts
var InputStatus;

(function (InputStatus) {
  InputStatus["VALID"] = "VALID";
  InputStatus["ERROR"] = "ERROR";
  InputStatus["DEFAULT"] = "DEFAULT";
  InputStatus["DISABLED"] = "DISABLED";
})(InputStatus || (InputStatus = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/BasicTextfield.vue?vue&type=script&lang=ts&
function BasicTextfieldvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return BasicTextfieldvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, BasicTextfieldvue_type_script_lang_ts_typeof(obj); }

function BasicTextfieldvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BasicTextfieldvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function BasicTextfieldvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) BasicTextfieldvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) BasicTextfieldvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function BasicTextfieldvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) BasicTextfieldvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function BasicTextfieldvue_type_script_lang_ts_setPrototypeOf(o, p) { BasicTextfieldvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return BasicTextfieldvue_type_script_lang_ts_setPrototypeOf(o, p); }

function BasicTextfieldvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = BasicTextfieldvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = BasicTextfieldvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = BasicTextfieldvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return BasicTextfieldvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function BasicTextfieldvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (BasicTextfieldvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return BasicTextfieldvue_type_script_lang_ts_assertThisInitialized(self); }

function BasicTextfieldvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function BasicTextfieldvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function BasicTextfieldvue_type_script_lang_ts_getPrototypeOf(o) { BasicTextfieldvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return BasicTextfieldvue_type_script_lang_ts_getPrototypeOf(o); }






var BasicTextfield = /*#__PURE__*/function (_Vue) {
  BasicTextfieldvue_type_script_lang_ts_inherits(BasicTextfield, _Vue);

  var _super = BasicTextfieldvue_type_script_lang_ts_createSuper(BasicTextfield);

  function BasicTextfield() {
    var _this;

    BasicTextfieldvue_type_script_lang_ts_classCallCheck(this, BasicTextfield);

    _this = _super.apply(this, arguments);
    _this.visited = false;
    _this.id = '';
    _this.showPlaceHolder = false;
    _this.showInfoText = false;
    _this.showLockedInfoText = false;
    _this.showPWTrigger = false;
    _this.toggleLockerBtnLocked = _this.lockerLocked;
    _this.timer = null;
    return _this;
  }

  BasicTextfieldvue_type_script_lang_ts_createClass(BasicTextfield, [{
    key: "inputType",
    get: function get() {
      var t = this.type.toLowerCase();

      switch (t) {
        case 'text':
        case 'password':
        case 'email':
        case 'date':
        case 'number':
          return t;

        default:
          return 'text';
      }
    }
  }, {
    key: "inputMode",
    get: function get() {
      var mode = this.inputmode.toLowerCase();
      /*
          In accordance with
          https://www.w3.org/TR/2014/WD-html51-20140617/forms.html#input-modalities:-the-inputmode-attribute
         */

      switch (mode) {
        case 'verbatim':
        case 'latin':
        case 'latin-name':
        case 'latin-prose':
        case 'full-width-latin':
        case 'kana':
        case 'kana-name':
        case 'numeric':
        case 'tel':
        case 'email':
        case 'url':
          return mode;

        default:
          return 'verbatim';
      }
    } //Hatte ich raus genommen, aber warum?

  }, {
    key: "isValid",
    get: function get() {
      return this.status === InputStatus.VALID;
    }
  }, {
    key: "isError",
    get: function get() {
      if (this.status === InputStatus.ERROR) {
        return true;
      } else if (!this.visited) {
        return false;
      } else if (!this.required && this.value.length === 0) {
        return false;
      } else if (this.required && this.value.length === 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "isFilled",
    get: function get() {
      return this.value.toString().length > 0;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.value.toString().length === 0;
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return this.status === InputStatus.DISABLED ? true : false;
    }
  }, {
    key: "isLocked",
    get: function get() {
      return this.toggleLockerBtnLocked;
    }
  }, {
    key: "hasLeftIcon",
    get: function get() {
      return this.passwordVisibilityTrigger;
    }
  }, {
    key: "showPWTriggerClass",
    get: function get() {
      return this.showPWTrigger;
    }
  }, {
    key: "onBlur",
    value: function onBlur(_e) {
      var _this2 = this;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(function () {
        _this2.visited = true;
        _this2.showPlaceHolder = false;
        _this2.showInfoText = false;
        _this2.showLockedInfoText = false;
        _this2.showPWTrigger = false;

        if (_this2.required && !_this2.isFilled) {
          _this2.$emit('update:error');
        } else if (_this2.isFilled) {
          _this2.$emit('update:input');
        } else {
          _this2.$emit('update:cleared');
        }
      }, 250);
    }
  }, {
    key: "onFocus",
    value: function onFocus(_e) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      if (this.lockableTrigger && (this.isDisabled || this.isLocked)) {
        this.showLockedInfoText = true;
      } else {
        this.showPlaceHolder = true;
        this.showInfoText = true;
        this.showPWTrigger = true;
      }
    }
  }, {
    key: "showPWtriggerFocused",
    value: function showPWtriggerFocused() {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.showPlaceHolder = true;
      this.showInfoText = true;
      this.showPWTrigger = true;
    }
  }, {
    key: "showHidePWValue",
    value: function showHidePWValue() {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      var queryString = "input[id=\"".concat(this.id, "\"]");
      var d = this.$el.querySelector(queryString);

      if (d) {
        var type = d.getAttribute('type') === 'password' ? 'text' : 'password';
        d.setAttribute('type', type);
      }

      this.showPlaceHolder = true;
      this.showInfoText = true;
      this.showPWTrigger = true;
    }
  }, {
    key: "toggleLocker",
    value: function toggleLocker() {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      if (this.toggleLockerBtnLocked) {
        this.toggleLockerBtnLocked = false;
        this.showInfoText = true;
        this.showLockedInfoText = false;
      } else {
        this.toggleLockerBtnLocked = true;
        this.showInfoText = false;
        this.showLockedInfoText = false;
      }
    }
  }]);

  return BasicTextfield;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: 'Label'
})], BasicTextfield.prototype, "label", void 0);

__decorate([Prop({
  default: false
})], BasicTextfield.prototype, "required", void 0);

__decorate([Prop({
  default: InputStatus.DEFAULT
})], BasicTextfield.prototype, "status", void 0);

__decorate([Prop({
  default: ''
})], BasicTextfield.prototype, "value", void 0);

__decorate([Prop({
  default: false
})], BasicTextfield.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: 'text'
})], BasicTextfield.prototype, "type", void 0);

__decorate([Prop({
  default: 'on'
})], BasicTextfield.prototype, "autocomplete", void 0);

__decorate([Prop({
  default: ''
})], BasicTextfield.prototype, "placeholder", void 0);

__decorate([Prop({
  default: null
})], BasicTextfield.prototype, "min", void 0);

__decorate([Prop({
  default: null
})], BasicTextfield.prototype, "max", void 0);

__decorate([Prop({
  default: null
})], BasicTextfield.prototype, "pattern", void 0);

__decorate([Prop({
  default: 'verbatim'
})], BasicTextfield.prototype, "inputmode", void 0);

__decorate([Prop({
  default: false
})], BasicTextfield.prototype, "formnovalidate", void 0);

__decorate([Prop({
  default: false
})], BasicTextfield.prototype, "passwordVisibilityTrigger", void 0);

__decorate([Prop({
  default: false
})], BasicTextfield.prototype, "lockableTrigger", void 0);

__decorate([Prop({
  default: false
})], BasicTextfield.prototype, "lockerLocked", void 0);

__decorate([Prop({
  default: ''
})], BasicTextfield.prototype, "idProp", void 0);

__decorate([Prop({
  default: false
})], BasicTextfield.prototype, "showCheckmark", void 0);

BasicTextfield = __decorate([(0,vue_class_component_esm["default"])({
  mixins: [idMixin]
})], BasicTextfield);
/* harmony default export */ var BasicTextfieldvue_type_script_lang_ts_ = (BasicTextfield);
;// CONCATENATED MODULE: ./src/components/base/input/BasicTextfield.vue?vue&type=script&lang=ts&
 /* harmony default export */ var input_BasicTextfieldvue_type_script_lang_ts_ = (BasicTextfieldvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/BasicTextfield.vue?vue&type=style&index=0&id=225adea7&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/input/BasicTextfield.vue?vue&type=style&index=0&id=225adea7&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/input/BasicTextfield.vue



;


/* normalize component */

var BasicTextfield_component = normalizeComponent(
  input_BasicTextfieldvue_type_script_lang_ts_,
  BasicTextfieldvue_type_template_id_225adea7_scoped_true_render,
  BasicTextfieldvue_type_template_id_225adea7_scoped_true_staticRenderFns,
  false,
  null,
  "225adea7",
  null
  
)

/* harmony default export */ var input_BasicTextfield = (BasicTextfield_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/TextArea.vue?vue&type=template&id=70b12af0&scoped=true&
var TextAreavue_type_template_id_70b12af0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"form-group",class:[
      { 'form-group--invalid': _vm.isError },
      { 'form-group--filled': _vm.isFilled },
      { 'form-group--empty': _vm.isEmpty },
      { 'form-group--disabled': _vm.isDisabled },
      { 'form-group--valid': !_vm.isError } ]},[_c('div',{staticClass:"form-group-textarea--border"},[_c('textarea',_vm._g({staticClass:"form-group__control",class:[{ 'display-focused': _vm.showIsFocusedClass }, { 'display-native-date': false }],attrs:{"rows":"3","id":_vm.id,"disabled":_vm.isDisabled,"placeholder":_vm.showPlaceHolder ? _vm.placeholder : ''},domProps:{"value":_vm.value},on:{"blur":_vm.onBlur,"focus":_vm.onFocus}},Object.assign({}, _vm.$listeners,
          {input: function (event) { return _vm.$emit('input', event.target.value); }}))),_vm._v(" "),_c('span',{class:[
          'triangle',
          'icon-triangle',
          { 'additional-padding-info': _vm.showInfoText },
          { 'additional-padding-error': _vm.isError } ]}),_c('label',{staticClass:"form-group__label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])]),(_vm.isError)?_c('div',{staticClass:"form-group__error"},[_vm._v(" "+_vm._s(_vm.errorText)+" ")]):_vm._e(),_c('div',{staticClass:"form-group__info",class:[{ 'form-group__info--fade-in': _vm.showInfoText }, { 'form-group__info--fade-out': !_vm.showInfoText }]},[_vm._v(" "+_vm._s(_vm.infoText)+" ")])])])}
var TextAreavue_type_template_id_70b12af0_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/TextArea.vue?vue&type=script&lang=ts&
function TextAreavue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return TextAreavue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, TextAreavue_type_script_lang_ts_typeof(obj); }

function TextAreavue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TextAreavue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TextAreavue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) TextAreavue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) TextAreavue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function TextAreavue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) TextAreavue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function TextAreavue_type_script_lang_ts_setPrototypeOf(o, p) { TextAreavue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return TextAreavue_type_script_lang_ts_setPrototypeOf(o, p); }

function TextAreavue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = TextAreavue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = TextAreavue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = TextAreavue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return TextAreavue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function TextAreavue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (TextAreavue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return TextAreavue_type_script_lang_ts_assertThisInitialized(self); }

function TextAreavue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function TextAreavue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function TextAreavue_type_script_lang_ts_getPrototypeOf(o) { TextAreavue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return TextAreavue_type_script_lang_ts_getPrototypeOf(o); }






var TextArea = /*#__PURE__*/function (_Vue) {
  TextAreavue_type_script_lang_ts_inherits(TextArea, _Vue);

  var _super = TextAreavue_type_script_lang_ts_createSuper(TextArea);

  function TextArea() {
    var _this;

    TextAreavue_type_script_lang_ts_classCallCheck(this, TextArea);

    _this = _super.apply(this, arguments);
    _this.visited = false;
    _this.id = '';
    _this.showPlaceHolder = false;
    _this.showInfoText = false;
    _this.isFocused = false;
    _this.timer = null;
    return _this;
  } //Hatte ich raus genommen, aber warum?


  TextAreavue_type_script_lang_ts_createClass(TextArea, [{
    key: "isValid",
    get: function get() {
      return this.status === InputStatus.VALID;
    }
  }, {
    key: "isError",
    get: function get() {
      if (this.status === InputStatus.ERROR) {
        return true;
      } else if (!this.visited) {
        return false;
      } else if (!this.required && this.value.length === 0) {
        return false;
      } else if (this.required && this.value.length === 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "isFilled",
    get: function get() {
      return this.value.length > 0;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.value.length === 0;
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return this.status === InputStatus.DISABLED ? true : false;
    }
  }, {
    key: "showIsFocusedClass",
    get: function get() {
      return this.isFocused;
    }
  }, {
    key: "onBlur",
    value: function onBlur(_e) {
      var _this2 = this;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(function () {
        _this2.visited = true;
        _this2.showPlaceHolder = false;
        _this2.showInfoText = false;
        _this2.isFocused = false;

        if (_this2.required && !_this2.isFilled) {
          _this2.$emit('update:error');
        } else if (_this2.isFilled) {
          _this2.$emit('update:input');
        } else {
          _this2.$emit('update:cleared');
        }
      }, 250);
    }
  }, {
    key: "onFocus",
    value: function onFocus(_e) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.showPlaceHolder = true;
      this.showInfoText = true;
      this.isFocused = true;
    }
  }]);

  return TextArea;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: 'Label'
})], TextArea.prototype, "label", void 0);

__decorate([Prop({
  default: false
})], TextArea.prototype, "required", void 0);

__decorate([Prop({
  default: InputStatus.DEFAULT
})], TextArea.prototype, "status", void 0);

__decorate([Prop({
  default: ''
})], TextArea.prototype, "value", void 0);

__decorate([Prop({
  default: false
})], TextArea.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: ''
})], TextArea.prototype, "placeholder", void 0);

__decorate([Prop({
  default: false
})], TextArea.prototype, "formnovalidate", void 0);

__decorate([Prop({
  default: ''
})], TextArea.prototype, "idProp", void 0);

__decorate([Prop({
  default: ''
})], TextArea.prototype, "errorText", void 0);

__decorate([Prop({
  default: ''
})], TextArea.prototype, "infoText", void 0);

TextArea = __decorate([(0,vue_class_component_esm["default"])({
  mixins: [idMixin]
})], TextArea);
/* harmony default export */ var TextAreavue_type_script_lang_ts_ = (TextArea);
;// CONCATENATED MODULE: ./src/components/base/input/TextArea.vue?vue&type=script&lang=ts&
 /* harmony default export */ var input_TextAreavue_type_script_lang_ts_ = (TextAreavue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/TextArea.vue?vue&type=style&index=0&id=70b12af0&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/input/TextArea.vue?vue&type=style&index=0&id=70b12af0&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/input/TextArea.vue



;


/* normalize component */

var TextArea_component = normalizeComponent(
  input_TextAreavue_type_script_lang_ts_,
  TextAreavue_type_template_id_70b12af0_scoped_true_render,
  TextAreavue_type_template_id_70b12af0_scoped_true_staticRenderFns,
  false,
  null,
  "70b12af0",
  null
  
)

/* harmony default export */ var input_TextArea = (TextArea_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/DateInput.vue?vue&type=template&id=4bb105a3&
var DateInputvue_type_template_id_4bb105a3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"form-group",class:[
      { 'form-group--invalid': _vm.isError },
      { 'form-group--filled': _vm.isFilled },
      { 'form-group--empty': _vm.isEmpty },
      { 'form-group--disabled': _vm.isDisabled } ]},[(_vm.isMobile)?_c('input',_vm._g({ref:"inputFieldMobile",staticClass:"form-group__control",class:[{ 'display-native-date': false }, { 'checkmark-padding': _vm.showCheckmark && _vm.isValid }],attrs:{"id":_vm.id,"type":"text","inputmode":"numeric","pattern":"[0-9]*","formnovalidate":_vm.formnovalidate,"maxlength":_vm.maxlength,"disabled":_vm.isDisabled,"minValidYear":_vm.minValidYear,"placeholder":_vm.showPlaceHolder ? _vm.placeholder : ''},domProps:{"value":_vm.date},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }return _vm.triggerDateInputDeletePressed.apply(null, arguments)}}},Object.assign({}, _vm.$listeners,
        {input: function (event) { return _vm.$emit('input', event.target.value); }}))):_vm._e(),(!_vm.isMobile)?_c('input',_vm._g({directives:[{name:"model",rawName:"v-model",value:(_vm.maskedValue),expression:"maskedValue"}],ref:"inputField",staticClass:"form-group__control",class:[{ 'display-native-date': false }, { 'checkmark-padding': _vm.showCheckmark && _vm.isValid }],attrs:{"id":_vm.id,"type":"text","inputmode":"numeric","pattern":"[0-9]*","formnovalidate":_vm.formnovalidate,"maxlength":_vm.mask.length,"disabled":_vm.isDisabled,"minValidYear":_vm.minValidYear,"placeholder":_vm.showPlaceHolder ? _vm.placeholder : ''},domProps:{"value":(_vm.maskedValue)},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":function($event){if($event.target.composing){ return; }_vm.maskedValue=$event.target.value}}},Object.assign({}, _vm.$listeners,
        {input: function (event) { return _vm.$emit('input', event.target.value); }}))):_vm._e(),(_vm.showCheckmark && _vm.isValid)?_c('span',{staticClass:"icon-check"}):_vm._e(),_c('label',{staticClass:"form-group__label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"form-group__bar"}),(_vm.isError)?_c('div',{staticClass:"form-group__error"},[_vm._t("error")],2):_vm._e(),_c('div',{staticClass:"form-group__info",class:[{ 'form-group__info--fade-in': _vm.showInfoText }, { 'form-group__info--fade-out': !_vm.showInfoText }]},[_vm._t("info")],2)])])}
var DateInputvue_type_template_id_4bb105a3_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__(285);
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);
// EXTERNAL MODULE: ./node_modules/mobile-detect/mobile-detect.js
var mobile_detect = __webpack_require__(437);
var mobile_detect_default = /*#__PURE__*/__webpack_require__.n(mobile_detect);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/DateInput.vue?vue&type=script&lang=ts&
function DateInputvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return DateInputvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, DateInputvue_type_script_lang_ts_typeof(obj); }

function DateInputvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DateInputvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DateInputvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) DateInputvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) DateInputvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function DateInputvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) DateInputvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function DateInputvue_type_script_lang_ts_setPrototypeOf(o, p) { DateInputvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DateInputvue_type_script_lang_ts_setPrototypeOf(o, p); }

function DateInputvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = DateInputvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DateInputvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DateInputvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DateInputvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function DateInputvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (DateInputvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return DateInputvue_type_script_lang_ts_assertThisInitialized(self); }

function DateInputvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DateInputvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DateInputvue_type_script_lang_ts_getPrototypeOf(o) { DateInputvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DateInputvue_type_script_lang_ts_getPrototypeOf(o); }








dayjs_min_default().extend((customParseFormat_default()));

var DateInput = /*#__PURE__*/function (_Vue) {
  DateInputvue_type_script_lang_ts_inherits(DateInput, _Vue);

  var _super = DateInputvue_type_script_lang_ts_createSuper(DateInput);

  function DateInput() {
    var _this;

    DateInputvue_type_script_lang_ts_classCallCheck(this, DateInput);

    _this = _super.apply(this, arguments);
    _this.tokens = {
      Y: {
        pattern: /\d/
      },
      M: {
        pattern: /\d/
      },
      D: {
        pattern: /\d/
      }
    };
    _this.visited = false;
    _this.id = '';
    _this.showPlaceHolder = false;
    _this.showInfoText = false;
    _this.timer = null;
    _this.formattedDate = null;
    _this.deletePressed = false;
    _this.currentValue = '';
    _this.currentMask = '';
    return _this;
  }

  DateInputvue_type_script_lang_ts_createClass(DateInput, [{
    key: "isMobile",
    get: function get() {
      var md = new (mobile_detect_default())(window.navigator.userAgent);

      if (md.mobile()) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.status === InputStatus.VALID;
    }
  }, {
    key: "isError",
    get: function get() {
      if (this.status === InputStatus.ERROR) {
        return true;
      } else if (!this.visited) {
        return false;
      } else if (this.required && (!this.value || this.value.length === 0)) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "isFilled",
    get: function get() {
      return !!this.value && this.value.length > 0;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return !this.value || this.value.length === 0;
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return this.status === InputStatus.DISABLED ? true : false;
    }
  }, {
    key: "date",
    get: function get() {
      if (!this.value) {
        return '';
      }

      var dateInput = this.value.replace(/[^0-9.]/g, '');

      if (!this.deletePressed && /^.{2}(\..{2})?$/.test(dateInput)) {
        return dateInput = dateInput + '.';
      }

      this.deletePressed = false;
      return dateInput;
    } // desktop version

  }, {
    key: "maskedValue",
    get: function get() {
      // fix removing mask character at the end.
      // Pressing backspace after 1.2.3 result in 1.2. instead of 1.2
      return this.value === this.currentValue ? this.currentMask : this.currentMask = this.applyMask(this.value, this.mask, true);
    },
    set: function set(newValue) {
      var el = this.inputField;
      var currentPosition = el.selectionEnd;
      var lastMask = this.currentMask; // update the input before restoring the cursor position

      el.value = this.currentMask = this.applyMask(newValue, this.mask);

      if (!currentPosition) {
        return;
      }

      if (this.currentMask.length <= lastMask.length) {
        // BACKSPACE
        // when chars are removed, the cursor position is already right
        el.setSelectionRange(currentPosition, currentPosition);
      } else {
        // inserting characters
        // if the substring till the cursor position is the same, don't change position
        if (newValue.substring(0, currentPosition) === this.currentMask.substring(0, currentPosition)) {
          el.setSelectionRange(currentPosition, currentPosition);
        } else {
          // increment 1 fixed position, but will not work if the mask has 2+ placeholders, like: ##//##
          el.setSelectionRange(currentPosition + 1, currentPosition + 1);
        }
      }
    } // end desktop version

  }, {
    key: "isDateValid",
    get: function get() {
      if (this.value && this.value.length === 10) {
        var dateInput = this.value;

        if (!dateInput || dateInput === '') {
          return false;
        } else {
          this.formattedDate = null; // reset

          var momentDate = dayjs_min_default()(dateInput, 'DD.MM.YYYY', true);
          var age = Math.abs(momentDate.diff(dayjs_min_default()(), 'year')); // necessary cause of IE11 and IOS

          var isValid = age >= this.minValidYear;

          if (momentDate.isValid() && isValid) {
            this.formattedDate = momentDate.format('YYYY-MM-DD');
            return true;
          } else if (!dayjs_min_default()(dateInput, 'YYYY-MM-DD', true).isValid()) {
            return false;
          }
        }
      } else {
        return true;
      }

      return false;
    }
  }, {
    key: "onBlur",
    value: function onBlur(_e) {
      var _this2 = this;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(function () {
        _this2.visited = true;
        _this2.showPlaceHolder = false;
        _this2.showInfoText = false;

        if (_this2.required && !_this2.isFilled) {
          _this2.$emit('update:error');
        } else if (!_this2.isDateValid) {
          _this2.$emit('update:invalid-date');
        } else if (_this2.isFilled) {
          _this2.$emit('update:input');
        } else {
          _this2.$emit('update:cleared');
        }
      }, 250);
    }
  }, {
    key: "triggerDateInputDeletePressed",
    value: function triggerDateInputDeletePressed() {
      if (!this.value) {
        return '';
      }

      var dateInput = this.value.replace(/[^0-9.]/g, '');

      if (dateInput.length > 2 && (dateInput.substr(2, 1) === '.' || dateInput.substr(4, 1) === '.')) {
        this.deletePressed = true;
        return dateInput;
      }

      return dateInput;
    }
  }, {
    key: "applyMask",
    value: function applyMask(value, mask) {
      var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      value = value || '';
      var iMask = 0;
      var iValue = 0;
      var output = '';

      while (iMask < mask.length && iValue < value.length) {
        var cMask = mask[iMask];
        var masker = this.tokens[cMask];
        var cValue = value[iValue];

        if (masker) {
          if (masker.pattern.test(cValue)) {
            output += masker.transform ? masker.transform(cValue) : cValue;
            iMask++;
          }

          iValue++;
        } else {
          if (masked) {
            output += cMask;
          }

          if (cValue === cMask) {
            iValue++;
          }

          iMask++;
        }
      }

      return output;
    }
  }, {
    key: "onFocus",
    value: function onFocus(_e) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.showPlaceHolder = true;
      this.showInfoText = true;
    }
  }]);

  return DateInput;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: 'Label'
})], DateInput.prototype, "label", void 0);

__decorate([Prop({
  default: false
})], DateInput.prototype, "required", void 0);

__decorate([Prop({
  default: InputStatus.DEFAULT
})], DateInput.prototype, "status", void 0);

__decorate([Prop({
  default: false
})], DateInput.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: ''
})], DateInput.prototype, "placeholder", void 0);

__decorate([Prop({
  default: false
})], DateInput.prototype, "formnovalidate", void 0);

__decorate([Prop({
  default: false
})], DateInput.prototype, "disabled", void 0);

__decorate([Prop({
  default: ''
})], DateInput.prototype, "idProp", void 0);

__decorate([Prop({
  default: '10'
})], DateInput.prototype, "maxlength", void 0);

__decorate([Prop({
  default: ''
})], DateInput.prototype, "minValidYear", void 0);

__decorate([Prop({
  default: null
})], DateInput.prototype, "value", void 0);

__decorate([Prop({
  default: ''
})], DateInput.prototype, "mask", void 0);

__decorate([Prop({
  default: false
})], DateInput.prototype, "masked", void 0);

__decorate([Prop({
  default: false
})], DateInput.prototype, "showCheckmark", void 0);

__decorate([Ref('inputField')], DateInput.prototype, "inputField", void 0);

__decorate([Ref('inputFieldMobile')], DateInput.prototype, "inputFieldMobile", void 0);

DateInput = __decorate([(0,vue_class_component_esm["default"])({
  mixins: [idMixin]
})], DateInput);
/* harmony default export */ var DateInputvue_type_script_lang_ts_ = (DateInput);
;// CONCATENATED MODULE: ./src/components/base/input/DateInput.vue?vue&type=script&lang=ts&
 /* harmony default export */ var input_DateInputvue_type_script_lang_ts_ = (DateInputvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/DateInput.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/input/DateInput.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/input/DateInput.vue



;


/* normalize component */

var DateInput_component = normalizeComponent(
  input_DateInputvue_type_script_lang_ts_,
  DateInputvue_type_template_id_4bb105a3_render,
  DateInputvue_type_template_id_4bb105a3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var input_DateInput = (DateInput_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/Checkbox.vue?vue&type=template&id=dd8f3034&scoped=true&
var Checkboxvue_type_template_id_dd8f3034_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"checkbox",class:[
      { 'checkbox--invalid-primary': _vm.isError && _vm.styleOption === 'primary' },
      {
        'checkbox--invalid-secondary': _vm.isError && _vm.styleOption === 'secondary',
      },
      { 'checkbox--disabled': _vm.isDisabled },
      'checkbox--' + _vm.styleOption ]},[_c('div',{staticClass:"checkbox__bg"}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],staticClass:"checkbox__control",attrs:{"id":_vm.id,"disabled":_vm.isDisabled,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":[function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}},_vm.emitValue]}}),_c('label',{staticClass:"checkbox__label",attrs:{"for":_vm.id}},[_vm._t("label",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)]),(_vm.isError)?_c('div',{staticClass:"checkbox__error"},[_vm._t("error",function(){return [_vm._v(" Bitte stimmen Sie den Bedingungen zu ")]})],2):_vm._e()])}
var Checkboxvue_type_template_id_dd8f3034_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/types/StyleOption.ts
var StyleOption;

(function (StyleOption) {
  StyleOption["PRIMARY"] = "primary";
  StyleOption["SECONDARY"] = "secondary";
  StyleOption["TERTIARY"] = "tertiary";
})(StyleOption || (StyleOption = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/Checkbox.vue?vue&type=script&lang=ts&
function Checkboxvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return Checkboxvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Checkboxvue_type_script_lang_ts_typeof(obj); }

function Checkboxvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Checkboxvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Checkboxvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) Checkboxvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) Checkboxvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Checkboxvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) Checkboxvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function Checkboxvue_type_script_lang_ts_setPrototypeOf(o, p) { Checkboxvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Checkboxvue_type_script_lang_ts_setPrototypeOf(o, p); }

function Checkboxvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = Checkboxvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Checkboxvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Checkboxvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Checkboxvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function Checkboxvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (Checkboxvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Checkboxvue_type_script_lang_ts_assertThisInitialized(self); }

function Checkboxvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Checkboxvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Checkboxvue_type_script_lang_ts_getPrototypeOf(o) { Checkboxvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Checkboxvue_type_script_lang_ts_getPrototypeOf(o); }








var Checkbox = /*#__PURE__*/function (_Mixins) {
  Checkboxvue_type_script_lang_ts_inherits(Checkbox, _Mixins);

  var _super = Checkboxvue_type_script_lang_ts_createSuper(Checkbox);

  function Checkbox() {
    var _this;

    Checkboxvue_type_script_lang_ts_classCallCheck(this, Checkbox);

    _this = _super.apply(this, arguments);
    _this.checkedProxy = _this.value;
    return _this;
  }

  Checkboxvue_type_script_lang_ts_createClass(Checkbox, [{
    key: "checked",
    get: function get() {
      return this.value;
    },
    set: function set(checked) {
      this.checkedProxy = checked;
    }
  }, {
    key: "emitValue",
    value: function emitValue(_e) {
      this.$emit('input', this.checkedProxy);
    }
  }, {
    key: "isError",
    get: function get() {
      return this.status === InputStatus.ERROR;
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return this.status === InputStatus.DISABLED;
    }
  }]);

  return Checkbox;
}((0,vue_mixin_decorator_umd.Mixins)(idMixin));

__decorate([Prop({
  default: false
})], Checkbox.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: 'Label'
})], Checkbox.prototype, "label", void 0);

__decorate([Prop({
  default: false
})], Checkbox.prototype, "disabled", void 0);

__decorate([Prop({
  default: InputStatus.DEFAULT
})], Checkbox.prototype, "status", void 0);

__decorate([Prop({
  default: ''
})], Checkbox.prototype, "idProp", void 0);

__decorate([Prop({
  default: false
})], Checkbox.prototype, "value", void 0);

__decorate([Prop({
  default: StyleOption.PRIMARY
})], Checkbox.prototype, "styleOption", void 0);

Checkbox = __decorate([vue_mixin_decorator_umd.Component], Checkbox);
/* harmony default export */ var Checkboxvue_type_script_lang_ts_ = (Checkbox);
;// CONCATENATED MODULE: ./src/components/base/input/Checkbox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var input_Checkboxvue_type_script_lang_ts_ = (Checkboxvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/Checkbox.vue?vue&type=style&index=0&id=dd8f3034&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/input/Checkbox.vue?vue&type=style&index=0&id=dd8f3034&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/input/Checkbox.vue



;


/* normalize component */

var Checkbox_component = normalizeComponent(
  input_Checkboxvue_type_script_lang_ts_,
  Checkboxvue_type_template_id_dd8f3034_scoped_true_render,
  Checkboxvue_type_template_id_dd8f3034_scoped_true_staticRenderFns,
  false,
  null,
  "dd8f3034",
  null
  
)

/* harmony default export */ var input_Checkbox = (Checkbox_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/SwitchButton.vue?vue&type=template&id=64d5343f&scoped=true&
var SwitchButtonvue_type_template_id_64d5343f_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classObject},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.trigger}}),_c('div',{staticClass:"placeholder"}),(_vm.shouldShowLabel)?_c('span',{staticClass:"vue-switcher__label"},[(_vm.label)?_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e(),(!_vm.label && _vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.textChecked)}}):_vm._e(),(!_vm.label && !_vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.textUnchecked)}}):_vm._e()]):_vm._e()])}
var SwitchButtonvue_type_template_id_64d5343f_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/SwitchButton.vue?vue&type=script&lang=ts&
function SwitchButtonvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return SwitchButtonvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, SwitchButtonvue_type_script_lang_ts_typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SwitchButtonvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SwitchButtonvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SwitchButtonvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) SwitchButtonvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) SwitchButtonvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function SwitchButtonvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) SwitchButtonvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function SwitchButtonvue_type_script_lang_ts_setPrototypeOf(o, p) { SwitchButtonvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SwitchButtonvue_type_script_lang_ts_setPrototypeOf(o, p); }

function SwitchButtonvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = SwitchButtonvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SwitchButtonvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SwitchButtonvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SwitchButtonvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function SwitchButtonvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (SwitchButtonvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return SwitchButtonvue_type_script_lang_ts_assertThisInitialized(self); }

function SwitchButtonvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SwitchButtonvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SwitchButtonvue_type_script_lang_ts_getPrototypeOf(o) { SwitchButtonvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SwitchButtonvue_type_script_lang_ts_getPrototypeOf(o); }



 // ToDo: Disabled Bug ganz links am Rand
// ToDo: boldType Ausrichtung Label
// ToDo: Updaten der Disable props soll den Switch nicht wieder unchecken, wenn er gecheckt war

var SwitchButton = /*#__PURE__*/function (_Vue) {
  SwitchButtonvue_type_script_lang_ts_inherits(SwitchButton, _Vue);

  var _super = SwitchButtonvue_type_script_lang_ts_createSuper(SwitchButton);

  function SwitchButton() {
    SwitchButtonvue_type_script_lang_ts_classCallCheck(this, SwitchButton);

    return _super.apply(this, arguments);
  }

  SwitchButtonvue_type_script_lang_ts_createClass(SwitchButton, [{
    key: "mounted",
    value: function mounted() {
      if (this.emitOnMount) {
        this.$emit('input', this.value);
      }
    }
  }, {
    key: "trigger",
    value: function trigger(e) {
      this.$emit('input', e.target.checked);
    }
  }, {
    key: "classObject",
    get: function get() {
      var _ref;

      var color = this.color,
          value = this.value,
          typeBold = this.typeBold,
          disabled = this.disabled;
      return _ref = {
        'vue-switcher': true
      }, _defineProperty(_ref, 'vue-switcher--unchecked', !value), _defineProperty(_ref, 'vue-switcher--disabled', disabled), _defineProperty(_ref, 'vue-switcher--bold', typeBold), _defineProperty(_ref, 'vue-switcher--bold--unchecked', typeBold && !value), _defineProperty(_ref, "vue-switcher-color--".concat(color), color), _defineProperty(_ref, "vue-switcher-theme--default", color), _ref;
    }
  }, {
    key: "shouldShowLabel",
    get: function get() {
      return this.label !== '' || this.textChecked !== '' || this.textUnchecked !== '';
    }
  }]);

  return SwitchButton;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], SwitchButton.prototype, "value", void 0);

__decorate([Prop({
  default: false
})], SwitchButton.prototype, "disabled", void 0);

__decorate([Prop({
  default: ''
})], SwitchButton.prototype, "label", void 0);

__decorate([Prop({
  default: ''
})], SwitchButton.prototype, "textChecked", void 0);

__decorate([Prop({
  default: ''
})], SwitchButton.prototype, "textUnchecked", void 0);

__decorate([Prop({
  default: 'default'
})], SwitchButton.prototype, "color", void 0);

__decorate([Prop({
  default: false
})], SwitchButton.prototype, "typeBold", void 0);

__decorate([Prop({
  default: true
})], SwitchButton.prototype, "emitOnMount", void 0);

SwitchButton = __decorate([(0,vue_mixin_decorator_umd.Component)({
  components: {}
})], SwitchButton);
/* harmony default export */ var SwitchButtonvue_type_script_lang_ts_ = (SwitchButton);
;// CONCATENATED MODULE: ./src/components/base/input/SwitchButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var input_SwitchButtonvue_type_script_lang_ts_ = (SwitchButtonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/SwitchButton.vue?vue&type=style&index=0&id=64d5343f&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/input/SwitchButton.vue?vue&type=style&index=0&id=64d5343f&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/input/SwitchButton.vue



;


/* normalize component */

var SwitchButton_component = normalizeComponent(
  input_SwitchButtonvue_type_script_lang_ts_,
  SwitchButtonvue_type_template_id_64d5343f_scoped_true_render,
  SwitchButtonvue_type_template_id_64d5343f_scoped_true_staticRenderFns,
  false,
  null,
  "64d5343f",
  null
  
)

/* harmony default export */ var input_SwitchButton = (SwitchButton_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/Radiogroup.vue?vue&type=template&id=05482be6&scoped=true&
var Radiogroupvue_type_template_id_05482be6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"radio",class:[
      { 'radio--invalid-primary': _vm.isError && _vm.styleOption === 'primary' },
      { 'radio--invalid-secondary': _vm.isError && _vm.styleOption === 'secondary' },
      { 'radio--disabled': _vm.isDisabled },
      'radio--' + _vm.styleOption ]},_vm._l((_vm.items),function(item){return _c('div',{key:item.id},[_c('input',_vm._g({directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"radio__control",attrs:{"type":"radio","id":item.id,"name":_vm.name,"defaultCheckedValue":_vm.defaultCheckedValue,"disabled":_vm.isDisabled},domProps:{"value":item.id,"checked":_vm._q(_vm.value,item.id)},on:{"change":function($event){_vm.value=item.id}}},_vm.emitValue(_vm.value))),_c('label',{staticClass:"radio__label",attrs:{"for":item.id}},[_vm._v(" "+_vm._s(item.label))])])}),0),(_vm.isError)?_c('div',{staticClass:"radio__error"},[_vm._t("error",function(){return [_vm._v("Irgendeine Defaultfehlermeldung")]})],2):_vm._e()])}
var Radiogroupvue_type_template_id_05482be6_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/Radiogroup.vue?vue&type=script&lang=ts&
function Radiogroupvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return Radiogroupvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Radiogroupvue_type_script_lang_ts_typeof(obj); }

function Radiogroupvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Radiogroupvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Radiogroupvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) Radiogroupvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) Radiogroupvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Radiogroupvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) Radiogroupvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function Radiogroupvue_type_script_lang_ts_setPrototypeOf(o, p) { Radiogroupvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Radiogroupvue_type_script_lang_ts_setPrototypeOf(o, p); }

function Radiogroupvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = Radiogroupvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Radiogroupvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Radiogroupvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Radiogroupvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function Radiogroupvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (Radiogroupvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Radiogroupvue_type_script_lang_ts_assertThisInitialized(self); }

function Radiogroupvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Radiogroupvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Radiogroupvue_type_script_lang_ts_getPrototypeOf(o) { Radiogroupvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Radiogroupvue_type_script_lang_ts_getPrototypeOf(o); }








var Radiogroup = /*#__PURE__*/function (_Mixins) {
  Radiogroupvue_type_script_lang_ts_inherits(Radiogroup, _Mixins);

  var _super = Radiogroupvue_type_script_lang_ts_createSuper(Radiogroup);

  function Radiogroup() {
    var _this;

    Radiogroupvue_type_script_lang_ts_classCallCheck(this, Radiogroup);

    _this = _super.apply(this, arguments);
    _this.value = _this.defaultCheckedValue !== '' ? _this.defaultCheckedValue : '';
    return _this;
  }

  Radiogroupvue_type_script_lang_ts_createClass(Radiogroup, [{
    key: "emitValue",
    value: function emitValue(checkedValue) {
      this.$emit('input', checkedValue);
    }
  }, {
    key: "isError",
    get: function get() {
      return this.status === InputStatus.ERROR;
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return this.status === InputStatus.DISABLED;
    }
  }]);

  return Radiogroup;
}((0,vue_mixin_decorator_umd.Mixins)(idMixin));

__decorate([Prop({
  default: false
})], Radiogroup.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: function _default() {
    return [{}];
  }
})], Radiogroup.prototype, "items", void 0);

__decorate([Prop({
  default: ''
})], Radiogroup.prototype, "name", void 0);

__decorate([Prop({
  default: ''
})], Radiogroup.prototype, "defaultCheckedValue", void 0);

__decorate([Prop({
  default: false
})], Radiogroup.prototype, "disabled", void 0);

__decorate([Prop({
  default: InputStatus.DEFAULT
})], Radiogroup.prototype, "status", void 0);

__decorate([Prop({
  default: StyleOption.PRIMARY
})], Radiogroup.prototype, "styleOption", void 0);

Radiogroup = __decorate([vue_mixin_decorator_umd.Component], Radiogroup);
/* harmony default export */ var Radiogroupvue_type_script_lang_ts_ = (Radiogroup);
;// CONCATENATED MODULE: ./src/components/base/input/Radiogroup.vue?vue&type=script&lang=ts&
 /* harmony default export */ var input_Radiogroupvue_type_script_lang_ts_ = (Radiogroupvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/Radiogroup.vue?vue&type=style&index=0&id=05482be6&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/input/Radiogroup.vue?vue&type=style&index=0&id=05482be6&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/input/Radiogroup.vue



;


/* normalize component */

var Radiogroup_component = normalizeComponent(
  input_Radiogroupvue_type_script_lang_ts_,
  Radiogroupvue_type_template_id_05482be6_scoped_true_render,
  Radiogroupvue_type_template_id_05482be6_scoped_true_staticRenderFns,
  false,
  null,
  "05482be6",
  null
  
)

/* harmony default export */ var input_Radiogroup = (Radiogroup_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/CarLicense.vue?vue&type=template&id=c2f62442&scoped=true&
var CarLicensevue_type_template_id_c2f62442_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[(_vm.licenseData && _vm.licenseData.license)?_c('div',{staticClass:"car-licence"},[_c('span',{staticClass:"car-licence__country"},[_vm._v(" "+_vm._s(this.licenseData.country)+" ")]),_vm._v(" "+_vm._s(_vm.getCityPartial())+" "),(_vm.hasFormattedData)?_c('span',{staticClass:"car-licence__separator"}):_vm._e(),_vm._v(" "+_vm._s(_vm.getLicensePartial())+" ")]):_vm._e()])}
var CarLicensevue_type_template_id_c2f62442_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/CarLicense.vue?vue&type=script&lang=ts&
function CarLicensevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return CarLicensevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, CarLicensevue_type_script_lang_ts_typeof(obj); }

function CarLicensevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CarLicensevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function CarLicensevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) CarLicensevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) CarLicensevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function CarLicensevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) CarLicensevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function CarLicensevue_type_script_lang_ts_setPrototypeOf(o, p) { CarLicensevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return CarLicensevue_type_script_lang_ts_setPrototypeOf(o, p); }

function CarLicensevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = CarLicensevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = CarLicensevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = CarLicensevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return CarLicensevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function CarLicensevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (CarLicensevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return CarLicensevue_type_script_lang_ts_assertThisInitialized(self); }

function CarLicensevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function CarLicensevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function CarLicensevue_type_script_lang_ts_getPrototypeOf(o) { CarLicensevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return CarLicensevue_type_script_lang_ts_getPrototypeOf(o); }




var CarLicense = /*#__PURE__*/function (_Vue) {
  CarLicensevue_type_script_lang_ts_inherits(CarLicense, _Vue);

  var _super = CarLicensevue_type_script_lang_ts_createSuper(CarLicense);

  function CarLicense() {
    var _this;

    CarLicensevue_type_script_lang_ts_classCallCheck(this, CarLicense);

    _this = _super.apply(this, arguments);
    _this.hasFormattedData = false; // B-LG 123

    _this.licenzeExpression = /[A-ZÖÜÄ]{1,3}-[A-ZÖÜÄ]{1,2} [0-9]{1,3}/;
    return _this;
  }

  CarLicensevue_type_script_lang_ts_createClass(CarLicense, [{
    key: "getCityPartial",
    value: function getCityPartial() {
      // Regular expression for "AA-BB 123", "A-B 1"
      var cityPartial = this.licenseData.license;

      if (this.licenzeExpression.test(this.licenseData.license)) {
        this.hasFormattedData = true;
        cityPartial = this.licenseData.license.split('-')[0];
      }

      return cityPartial;
    }
  }, {
    key: "getLicensePartial",
    value: function getLicensePartial() {
      var LicensePartial = '';

      if (this.licenzeExpression.test(this.licenseData.license)) {
        LicensePartial = this.licenseData.license.split('-')[1];
      }

      return LicensePartial;
    }
  }]);

  return CarLicense;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: function _default() {
    return {
      country: '',
      license: ''
    };
  }
})], CarLicense.prototype, "licenseData", void 0);

__decorate([Prop({
  default: false
})], CarLicense.prototype, "disableStyles", void 0);

CarLicense = __decorate([vue_class_component_esm["default"]], CarLicense);
/* harmony default export */ var CarLicensevue_type_script_lang_ts_ = (CarLicense);
;// CONCATENATED MODULE: ./src/components/base/modules/CarLicense.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_CarLicensevue_type_script_lang_ts_ = (CarLicensevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/CarLicense.vue?vue&type=style&index=0&id=c2f62442&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/CarLicense.vue?vue&type=style&index=0&id=c2f62442&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/modules/CarLicense.vue



;


/* normalize component */

var CarLicense_component = normalizeComponent(
  modules_CarLicensevue_type_script_lang_ts_,
  CarLicensevue_type_template_id_c2f62442_scoped_true_render,
  CarLicensevue_type_template_id_c2f62442_scoped_true_staticRenderFns,
  false,
  null,
  "c2f62442",
  null
  
)

/* harmony default export */ var modules_CarLicense = (CarLicense_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataBox.vue?vue&type=template&id=7679abb8&scoped=true&
var DataBoxvue_type_template_id_7679abb8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"data"},[_vm._l((_vm.data),function(item,idx){return _c('div',{key:idx},[(item.title)?_c('div',{staticClass:"title-block",class:("title-block--" + _vm.responsiveClass),attrs:{"data-observe-resizes":""}},[(item.title)?_c('h3',{staticClass:"label"},[_vm._v(_vm._s(item.title.label))]):_vm._e(),(item.title && item.title.actionLink)?_c('a',{staticClass:"action-link",class:_vm.linkType,on:{"click":function($event){$event.preventDefault();return _vm.$emit('click:action-link', item.title.actionLink.id)}}},[_vm._v(" "+_vm._s(item.title.actionLink.label)+" "),_c('span',{class:_vm.actionLinkIconClass})]):_vm._e()]):_vm._e(),_c('div',{staticClass:"data__list list",class:("list--" + _vm.responsiveClass),attrs:{"data-observe-resizes":""}},_vm._l((item.data),function(listItem,idy){return _c('div',{key:idy,staticClass:"list__wrapper"},[(!listItem.hide)?_c('div',[_c('div',{staticClass:"list__term",class:{ 'list__term--full': !listItem.value },attrs:{"data-testid":listItem.labelHtmlId}},[_vm._v(" "+_vm._s(listItem.label)+" ")]),(listItem.value)?_c('div',{staticClass:"list__definition",attrs:{"data-testid":listItem.valueHtmlId}},[_vm._v(" "+_vm._s(listItem.value)+" ")]):_vm._e(),(listItem.iconSpan)?_c('div',{staticClass:"hoverable-icon hoverable-icon-span data-line__icon padding-right-0"},[_c('span',{class:_vm.getIconClass(listItem.iconSpan),on:{"click":function($event){return _vm.$emit('click:icon', listItem.iconSpan.href, listItem.iconSpan.isRouterLink)}}})]):_vm._e(),(listItem.icon && !listItem.iconSpan)?_c('HoverableIcon',{staticClass:"list__icon",attrs:{"image":listItem.icon.image,"hover-image":listItem.icon.hoverImage,"label":listItem.icon.label,"href":listItem.icon.href},on:{"input:click":function($event){return _vm.$emit('click:icon', listItem.icon.href, listItem.icon.isRouterLink)}}}):_vm._e()],1):_vm._e()])}),0)])}),_vm._t("databoxTitle"),_vm._t("databoxContent"),(this.$slots.datafooter)?_c('div',{staticClass:"data__footer"},[_vm._t("datafooter")],2):_vm._e()],2)])}
var DataBoxvue_type_template_id_7679abb8_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataSection.vue?vue&type=template&id=0532f474&
var DataSectionvue_type_template_id_0532f474_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",class:{ 'is-styled': !_vm.disableStyles }},[(_vm.title)?_c('h3',{staticClass:"section__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"data-items",class:("data-line--" + _vm.responsiveClass),attrs:{"data-observe-resizes":""}},[_vm._t("dataLines"),(this.$slots.sectionFooter)?_c('div',{staticClass:"section__footer"},[_vm._t("sectionFooter")],2):_vm._e()],2)])}
var DataSectionvue_type_template_id_0532f474_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataSection.vue?vue&type=script&lang=ts&
function DataSectionvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return DataSectionvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, DataSectionvue_type_script_lang_ts_typeof(obj); }

function DataSectionvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DataSectionvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) DataSectionvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) DataSectionvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function DataSectionvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DataSectionvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) DataSectionvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function DataSectionvue_type_script_lang_ts_setPrototypeOf(o, p) { DataSectionvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DataSectionvue_type_script_lang_ts_setPrototypeOf(o, p); }

function DataSectionvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = DataSectionvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DataSectionvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DataSectionvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DataSectionvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function DataSectionvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (DataSectionvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return DataSectionvue_type_script_lang_ts_assertThisInitialized(self); }

function DataSectionvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DataSectionvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DataSectionvue_type_script_lang_ts_getPrototypeOf(o) { DataSectionvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DataSectionvue_type_script_lang_ts_getPrototypeOf(o); }





var DataSection = /*#__PURE__*/function (_Vue) {
  DataSectionvue_type_script_lang_ts_inherits(DataSection, _Vue);

  var _super = DataSectionvue_type_script_lang_ts_createSuper(DataSection);

  function DataSection() {
    DataSectionvue_type_script_lang_ts_classCallCheck(this, DataSection);

    return _super.apply(this, arguments);
  }

  return DataSectionvue_type_script_lang_ts_createClass(DataSection);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: ''
})], DataSection.prototype, "title", void 0);

__decorate([Prop({
  default: false
})], DataSection.prototype, "disableStyles", void 0);

DataSection = __decorate([(0,vue_class_component_esm["default"])({
  mixins: [responsiveClassMixin]
})], DataSection);
/* harmony default export */ var DataSectionvue_type_script_lang_ts_ = (DataSection);
;// CONCATENATED MODULE: ./src/components/base/modules/DataSection.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_DataSectionvue_type_script_lang_ts_ = (DataSectionvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataSection.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/DataSection.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/modules/DataSection.vue



;


/* normalize component */

var DataSection_component = normalizeComponent(
  modules_DataSectionvue_type_script_lang_ts_,
  DataSectionvue_type_template_id_0532f474_render,
  DataSectionvue_type_template_id_0532f474_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var modules_DataSection = (DataSection_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataLine.vue?vue&type=template&id=890fddca&scoped=true&
var DataLinevue_type_template_id_890fddca_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-line"},[_c('div',{staticClass:"data-line__wrapper"},[_c('div',{staticClass:"data-line__term",class:{ 'data-line__term--full': !_vm.value }},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.value)?_c('div',{staticClass:"data-line__definition"},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e(),(_vm.iconSpan)?_c('div',{staticClass:"hoverable-icon hoverable-icon-span data-line__icon padding-right-0"},[_c('span',{class:_vm.getIconClass,on:{"click":function($event){return _vm.$emit('click:icon', _vm.iconSpan.href, _vm.iconSpan.isRouterLink)}}})]):_vm._e(),(_vm.icon && !_vm.iconSpan)?_c('HoverableIcon',{staticClass:"data-line__icon",attrs:{"image":_vm.icon.image,"hover-image":_vm.icon.hoverImage,"label":_vm.icon.label,"href":_vm.icon.href},on:{"input:click":function($event){return _vm.$emit('click:icon', _vm.icon.href, _vm.icon.isRouterLink)}}}):_vm._e()],1)])}
var DataLinevue_type_template_id_890fddca_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/HoverableIcon.vue?vue&type=template&id=7339db60&scoped=true&
var HoverableIconvue_type_template_id_7339db60_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hoverable-icon",on:{"click":function($event){return _vm.$emit('input:click', _vm.href, _vm.isRouterLink)}}},[_c('div',{staticClass:"hoverable-icon-link"},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.label}}),_c('img',{attrs:{"src":_vm.hoverImage,"alt":_vm.label}})]),_vm._t("label")],2)}
var HoverableIconvue_type_template_id_7339db60_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/HoverableIcon.vue?vue&type=script&lang=ts&
function HoverableIconvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return HoverableIconvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, HoverableIconvue_type_script_lang_ts_typeof(obj); }

function HoverableIconvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function HoverableIconvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) HoverableIconvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) HoverableIconvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function HoverableIconvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HoverableIconvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) HoverableIconvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function HoverableIconvue_type_script_lang_ts_setPrototypeOf(o, p) { HoverableIconvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return HoverableIconvue_type_script_lang_ts_setPrototypeOf(o, p); }

function HoverableIconvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = HoverableIconvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = HoverableIconvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = HoverableIconvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return HoverableIconvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function HoverableIconvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (HoverableIconvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return HoverableIconvue_type_script_lang_ts_assertThisInitialized(self); }

function HoverableIconvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function HoverableIconvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function HoverableIconvue_type_script_lang_ts_getPrototypeOf(o) { HoverableIconvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return HoverableIconvue_type_script_lang_ts_getPrototypeOf(o); }




var HoverableIcon = /*#__PURE__*/function (_Vue) {
  HoverableIconvue_type_script_lang_ts_inherits(HoverableIcon, _Vue);

  var _super = HoverableIconvue_type_script_lang_ts_createSuper(HoverableIcon);

  function HoverableIcon() {
    HoverableIconvue_type_script_lang_ts_classCallCheck(this, HoverableIcon);

    return _super.apply(this, arguments);
  }

  return HoverableIconvue_type_script_lang_ts_createClass(HoverableIcon);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  required: true
})], HoverableIcon.prototype, "image", void 0);

__decorate([Prop({
  required: true
})], HoverableIcon.prototype, "hoverImage", void 0);

__decorate([Prop({
  required: true
})], HoverableIcon.prototype, "label", void 0);

__decorate([Prop({
  required: true
})], HoverableIcon.prototype, "href", void 0);

__decorate([Prop({
  required: false,
  default: true
})], HoverableIcon.prototype, "isRouterLink", void 0);

HoverableIcon = __decorate([vue_class_component_esm["default"]], HoverableIcon);
/* harmony default export */ var HoverableIconvue_type_script_lang_ts_ = (HoverableIcon);
;// CONCATENATED MODULE: ./src/components/base/modules/HoverableIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_HoverableIconvue_type_script_lang_ts_ = (HoverableIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/HoverableIcon.vue?vue&type=style&index=0&id=7339db60&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/HoverableIcon.vue?vue&type=style&index=0&id=7339db60&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/modules/HoverableIcon.vue



;


/* normalize component */

var HoverableIcon_component = normalizeComponent(
  modules_HoverableIconvue_type_script_lang_ts_,
  HoverableIconvue_type_template_id_7339db60_scoped_true_render,
  HoverableIconvue_type_template_id_7339db60_scoped_true_staticRenderFns,
  false,
  null,
  "7339db60",
  null
  
)

/* harmony default export */ var modules_HoverableIcon = (HoverableIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataLine.vue?vue&type=script&lang=ts&
function DataLinevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return DataLinevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, DataLinevue_type_script_lang_ts_typeof(obj); }

function DataLinevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DataLinevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DataLinevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) DataLinevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) DataLinevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function DataLinevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) DataLinevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function DataLinevue_type_script_lang_ts_setPrototypeOf(o, p) { DataLinevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DataLinevue_type_script_lang_ts_setPrototypeOf(o, p); }

function DataLinevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = DataLinevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DataLinevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DataLinevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DataLinevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function DataLinevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (DataLinevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return DataLinevue_type_script_lang_ts_assertThisInitialized(self); }

function DataLinevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DataLinevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DataLinevue_type_script_lang_ts_getPrototypeOf(o) { DataLinevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DataLinevue_type_script_lang_ts_getPrototypeOf(o); }






var DataLine = /*#__PURE__*/function (_Vue) {
  DataLinevue_type_script_lang_ts_inherits(DataLine, _Vue);

  var _super = DataLinevue_type_script_lang_ts_createSuper(DataLine);

  function DataLine() {
    DataLinevue_type_script_lang_ts_classCallCheck(this, DataLine);

    return _super.apply(this, arguments);
  }

  DataLinevue_type_script_lang_ts_createClass(DataLine, [{
    key: "getIconClass",
    get: function get() {
      return "".concat(this.iconSpan.iconClass, " icon-hover");
    }
  }]);

  return DataLine;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: ''
})], DataLine.prototype, "label", void 0);

__decorate([Prop({
  default: ''
})], DataLine.prototype, "value", void 0);

__decorate([Prop({
  required: false
})], DataLine.prototype, "icon", void 0);

__decorate([Prop({
  required: false
})], DataLine.prototype, "iconSpan", void 0);

DataLine = __decorate([(0,vue_class_component_esm["default"])({
  mixins: [responsiveClassMixin],
  components: {
    HoverableIcon: modules_HoverableIcon
  }
})], DataLine);
/* harmony default export */ var DataLinevue_type_script_lang_ts_ = (DataLine);
;// CONCATENATED MODULE: ./src/components/base/modules/DataLine.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_DataLinevue_type_script_lang_ts_ = (DataLinevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataLine.vue?vue&type=style&index=0&id=890fddca&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/DataLine.vue?vue&type=style&index=0&id=890fddca&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/modules/DataLine.vue



;


/* normalize component */

var DataLine_component = normalizeComponent(
  modules_DataLinevue_type_script_lang_ts_,
  DataLinevue_type_template_id_890fddca_scoped_true_render,
  DataLinevue_type_template_id_890fddca_scoped_true_staticRenderFns,
  false,
  null,
  "890fddca",
  null
  
)

/* harmony default export */ var modules_DataLine = (DataLine_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataBox.vue?vue&type=script&lang=ts&
function DataBoxvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return DataBoxvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, DataBoxvue_type_script_lang_ts_typeof(obj); }

function DataBoxvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DataBoxvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DataBoxvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) DataBoxvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) DataBoxvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function DataBoxvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) DataBoxvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function DataBoxvue_type_script_lang_ts_setPrototypeOf(o, p) { DataBoxvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DataBoxvue_type_script_lang_ts_setPrototypeOf(o, p); }

function DataBoxvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = DataBoxvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DataBoxvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DataBoxvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DataBoxvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function DataBoxvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (DataBoxvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return DataBoxvue_type_script_lang_ts_assertThisInitialized(self); }

function DataBoxvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DataBoxvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DataBoxvue_type_script_lang_ts_getPrototypeOf(o) { DataBoxvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DataBoxvue_type_script_lang_ts_getPrototypeOf(o); }









var DataBox = /*#__PURE__*/function (_Vue) {
  DataBoxvue_type_script_lang_ts_inherits(DataBox, _Vue);

  var _super = DataBoxvue_type_script_lang_ts_createSuper(DataBox);

  function DataBox() {
    DataBoxvue_type_script_lang_ts_classCallCheck(this, DataBox);

    return _super.apply(this, arguments);
  }

  DataBoxvue_type_script_lang_ts_createClass(DataBox, [{
    key: "getIconClass",
    value: function getIconClass(iconSpan) {
      return iconSpan ? "".concat(iconSpan.iconClass, " icon-hover") : '';
    }
  }]);

  return DataBox;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], DataBox.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: function _default() {
    return [];
  }
})], DataBox.prototype, "data", void 0);

__decorate([Prop({
  default: ''
})], DataBox.prototype, "actionLinkIconClass", void 0);

__decorate([Prop({
  default: ''
})], DataBox.prototype, "linkType", void 0);

DataBox = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    CustomButton: buttons_CustomButton,
    DataSection: modules_DataSection,
    DataLine: modules_DataLine,
    HoverableIcon: modules_HoverableIcon
  },
  mixins: [responsiveClassMixin]
})], DataBox);
/* harmony default export */ var DataBoxvue_type_script_lang_ts_ = (DataBox);
;// CONCATENATED MODULE: ./src/components/base/modules/DataBox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_DataBoxvue_type_script_lang_ts_ = (DataBoxvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataBox.vue?vue&type=style&index=0&id=7679abb8&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/DataBox.vue?vue&type=style&index=0&id=7679abb8&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/modules/DataBox.vue



;


/* normalize component */

var DataBox_component = normalizeComponent(
  modules_DataBoxvue_type_script_lang_ts_,
  DataBoxvue_type_template_id_7679abb8_scoped_true_render,
  DataBoxvue_type_template_id_7679abb8_scoped_true_staticRenderFns,
  false,
  null,
  "7679abb8",
  null
  
)

/* harmony default export */ var modules_DataBox = (DataBox_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataTable.vue?vue&type=template&id=aa2139c2&scoped=true&
var DataTablevue_type_template_id_aa2139c2_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('table',[_c('tr',[_vm._l((_vm.header),function(headerItem){return [_c('th',{key:headerItem.name,style:({ width: _vm.getWidth(headerItem) })},[_c('span',[_vm._v(_vm._s(headerItem.name))])])]})],2),_vm._l((_vm.data),function(dataArray){return [_c('tr',{key:dataArray[0]},[_vm._l((dataArray),function(dataItem){return [_c('td',{key:dataItem},[_c('span',[_vm._v(_vm._s(dataItem))])])]})],2)]})],2)])}
var DataTablevue_type_template_id_aa2139c2_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/types/DataTable.ts
var WidthType;

(function (WidthType) {
  WidthType["PIXEL"] = "PIXEL";
  WidthType["PERCENTAGE"] = "PERCENTAGE";
})(WidthType || (WidthType = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataTable.vue?vue&type=script&lang=ts&
function DataTablevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return DataTablevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, DataTablevue_type_script_lang_ts_typeof(obj); }

function DataTablevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DataTablevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DataTablevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) DataTablevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) DataTablevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function DataTablevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) DataTablevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function DataTablevue_type_script_lang_ts_setPrototypeOf(o, p) { DataTablevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DataTablevue_type_script_lang_ts_setPrototypeOf(o, p); }

function DataTablevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = DataTablevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DataTablevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DataTablevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DataTablevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function DataTablevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (DataTablevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return DataTablevue_type_script_lang_ts_assertThisInitialized(self); }

function DataTablevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DataTablevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DataTablevue_type_script_lang_ts_getPrototypeOf(o) { DataTablevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DataTablevue_type_script_lang_ts_getPrototypeOf(o); }





var DataTable = /*#__PURE__*/function (_Vue) {
  DataTablevue_type_script_lang_ts_inherits(DataTable, _Vue);

  var _super = DataTablevue_type_script_lang_ts_createSuper(DataTable);

  function DataTable() {
    DataTablevue_type_script_lang_ts_classCallCheck(this, DataTable);

    return _super.apply(this, arguments);
  }

  DataTablevue_type_script_lang_ts_createClass(DataTable, [{
    key: "getWidth",
    value: function getWidth(headerItem) {
      if (headerItem.width) {
        return headerItem.width.size + (headerItem.width.type === WidthType.PIXEL ? 'px' : '%');
      }

      return '';
    }
  }]);

  return DataTable;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  required: false,
  default: false
})], DataTable.prototype, "disableStyles", void 0);

__decorate([Prop({
  required: true
})], DataTable.prototype, "header", void 0);

__decorate([Prop({
  required: true
})], DataTable.prototype, "data", void 0);

DataTable = __decorate([(0,vue_class_component_esm["default"])({})], DataTable);
/* harmony default export */ var DataTablevue_type_script_lang_ts_ = (DataTable);
;// CONCATENATED MODULE: ./src/components/base/modules/DataTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_DataTablevue_type_script_lang_ts_ = (DataTablevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/DataTable.vue?vue&type=style&index=0&id=aa2139c2&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/DataTable.vue?vue&type=style&index=0&id=aa2139c2&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/modules/DataTable.vue



;


/* normalize component */

var DataTable_component = normalizeComponent(
  modules_DataTablevue_type_script_lang_ts_,
  DataTablevue_type_template_id_aa2139c2_scoped_true_render,
  DataTablevue_type_template_id_aa2139c2_scoped_true_staticRenderFns,
  false,
  null,
  "aa2139c2",
  null
  
)

/* harmony default export */ var modules_DataTable = (DataTable_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/HeaderTitle.vue?vue&type=template&id=df01bbe4&
var HeaderTitlevue_type_template_id_df01bbe4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['wc-outer-wc-head', _vm.colorable ? 'colorable' : '']},[_c('div',{staticClass:"wc-container wc-head"},[_c('div',{staticClass:"head",class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"head__title"},[_vm._t("title",function(){return [_vm._v(" "+_vm._s(_vm.headline)+" ")]})],2),_vm._t("content"),(this.$slots.teaser || this.$slots.postbox)?_c('div',{staticClass:"head__content-block wc-row"},[(this.$slots.teaser)?_c('div',{staticClass:"wc-col wc-col__sm-6 wc-col__md-8 hidden-sm"},[_vm._t("teaser")],2):_vm._e(),(this.$slots.postbox)?_c('div',{staticClass:"wc-col wc-col__sm-6 wc-col__md-4"},[_vm._t("postbox")],2):_vm._e()]):_vm._e()],2)])])}
var HeaderTitlevue_type_template_id_df01bbe4_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/HeaderTitle.vue?vue&type=script&lang=ts&
function HeaderTitlevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return HeaderTitlevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, HeaderTitlevue_type_script_lang_ts_typeof(obj); }

function HeaderTitlevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function HeaderTitlevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) HeaderTitlevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) HeaderTitlevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function HeaderTitlevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HeaderTitlevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) HeaderTitlevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function HeaderTitlevue_type_script_lang_ts_setPrototypeOf(o, p) { HeaderTitlevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return HeaderTitlevue_type_script_lang_ts_setPrototypeOf(o, p); }

function HeaderTitlevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = HeaderTitlevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = HeaderTitlevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = HeaderTitlevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return HeaderTitlevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function HeaderTitlevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (HeaderTitlevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return HeaderTitlevue_type_script_lang_ts_assertThisInitialized(self); }

function HeaderTitlevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function HeaderTitlevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function HeaderTitlevue_type_script_lang_ts_getPrototypeOf(o) { HeaderTitlevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return HeaderTitlevue_type_script_lang_ts_getPrototypeOf(o); }




var HeaderTitle = /*#__PURE__*/function (_Vue) {
  HeaderTitlevue_type_script_lang_ts_inherits(HeaderTitle, _Vue);

  var _super = HeaderTitlevue_type_script_lang_ts_createSuper(HeaderTitle);

  function HeaderTitle() {
    HeaderTitlevue_type_script_lang_ts_classCallCheck(this, HeaderTitle);

    return _super.apply(this, arguments);
  }

  return HeaderTitlevue_type_script_lang_ts_createClass(HeaderTitle);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], HeaderTitle.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: null
})], HeaderTitle.prototype, "maxWidth", void 0);

__decorate([Prop({
  default: ''
})], HeaderTitle.prototype, "headline", void 0);

__decorate([Prop({
  default: false
})], HeaderTitle.prototype, "colorable", void 0);

HeaderTitle = __decorate([vue_class_component_esm["default"]], HeaderTitle);
/* harmony default export */ var HeaderTitlevue_type_script_lang_ts_ = (HeaderTitle);
;// CONCATENATED MODULE: ./src/components/base/container/HeaderTitle.vue?vue&type=script&lang=ts&
 /* harmony default export */ var container_HeaderTitlevue_type_script_lang_ts_ = (HeaderTitlevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/HeaderTitle.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/container/HeaderTitle.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/container/HeaderTitle.vue



;


/* normalize component */

var HeaderTitle_component = normalizeComponent(
  container_HeaderTitlevue_type_script_lang_ts_,
  HeaderTitlevue_type_template_id_df01bbe4_render,
  HeaderTitlevue_type_template_id_df01bbe4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var container_HeaderTitle = (HeaderTitle_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/Alert.vue?vue&type=template&id=01bae084&scoped=true&
var Alertvue_type_template_id_01bae084_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['alert', _vm.type, 'size-' + _vm.size]},[(_vm.text)?_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_vm._t("main")],2)}
var Alertvue_type_template_id_01bae084_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/types/AlertStatus.ts
var AlertStatus;

(function (AlertStatus) {
  AlertStatus["DEFAULT"] = "default";
  AlertStatus["SUCCESS"] = "success";
  AlertStatus["INFO"] = "info";
  AlertStatus["WARNING"] = "warning";
  AlertStatus["DANGER"] = "danger";
})(AlertStatus || (AlertStatus = {}));
;// CONCATENATED MODULE: ./src/components/types/AlertSize.ts
var AlertSize;

(function (AlertSize) {
  AlertSize["SMALL"] = "small";
  AlertSize["MEDIUM"] = "medium";
})(AlertSize || (AlertSize = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/Alert.vue?vue&type=script&lang=ts&
function Alertvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return Alertvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Alertvue_type_script_lang_ts_typeof(obj); }

function Alertvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Alertvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) Alertvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) Alertvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Alertvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Alertvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) Alertvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function Alertvue_type_script_lang_ts_setPrototypeOf(o, p) { Alertvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Alertvue_type_script_lang_ts_setPrototypeOf(o, p); }

function Alertvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = Alertvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Alertvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Alertvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Alertvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function Alertvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (Alertvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Alertvue_type_script_lang_ts_assertThisInitialized(self); }

function Alertvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Alertvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Alertvue_type_script_lang_ts_getPrototypeOf(o) { Alertvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Alertvue_type_script_lang_ts_getPrototypeOf(o); }






var Alert = /*#__PURE__*/function (_Vue) {
  Alertvue_type_script_lang_ts_inherits(Alert, _Vue);

  var _super = Alertvue_type_script_lang_ts_createSuper(Alert);

  function Alert() {
    Alertvue_type_script_lang_ts_classCallCheck(this, Alert);

    return _super.apply(this, arguments);
  }

  return Alertvue_type_script_lang_ts_createClass(Alert);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  required: false,
  default: ''
})], Alert.prototype, "text", void 0);

__decorate([Prop({
  required: false,
  default: AlertStatus.INFO
})], Alert.prototype, "type", void 0);

__decorate([Prop({
  required: false,
  default: AlertSize.MEDIUM
})], Alert.prototype, "size", void 0);

Alert = __decorate([(0,vue_class_component_esm["default"])({
  components: {}
})], Alert);
/* harmony default export */ var Alertvue_type_script_lang_ts_ = (Alert);
;// CONCATENATED MODULE: ./src/components/base/container/Alert.vue?vue&type=script&lang=ts&
 /* harmony default export */ var container_Alertvue_type_script_lang_ts_ = (Alertvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/Alert.vue?vue&type=style&index=0&id=01bae084&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/container/Alert.vue?vue&type=style&index=0&id=01bae084&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/container/Alert.vue



;


/* normalize component */

var Alert_component = normalizeComponent(
  container_Alertvue_type_script_lang_ts_,
  Alertvue_type_template_id_01bae084_scoped_true_render,
  Alertvue_type_template_id_01bae084_scoped_true_staticRenderFns,
  false,
  null,
  "01bae084",
  null
  
)

/* harmony default export */ var container_Alert = (Alert_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/navigation/Navigation.vue?vue&type=template&id=86d2a74c&scoped=true&
var Navigationvue_type_template_id_86d2a74c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasValidData)?_c('div',{staticClass:"outer-navi-block",class:{ 'is-styled': !_vm.disableStyles },style:([_vm.topPosition ? { top: _vm.topPosition + 'px' } : {}, _vm.positionStyle ? { position: _vm.positionStyle } : {}])},[_c('div',{staticClass:"mobile",attrs:{"aria-expanded":_vm.isExpanded ? 'true' : 'false',"aria-controls":"navi-content"},on:{"click":_vm.toggleExpansion}},[_c('div',{staticClass:"mobile__toggler-outer"},[_c('span',{staticClass:"mobile__toggler-inner"},[_vm._v(" "+_vm._s(_vm.mobileNavTogglerName)+" ")])]),_c('span',{staticClass:"mobile__icon icon-chevron-down",class:[{ 'mobile__icon--top': _vm.isExpanded }]})]),_c('nav',{staticClass:"nav-block",style:([_vm.maxWidth ? { maxWidth: _vm.maxWidth + 'px' } : {}])},[_c('ul',{staticClass:"navi",class:[{ 'navi--show': _vm.isExpanded }],attrs:{"id":"navi-content"}},_vm._l((_vm.menuItems),function(menuItem){return _c('li',{key:menuItem.path},[_c('a',_vm._g({staticClass:"navi__link",class:[{ 'navi__link--active': _vm.isActive(menuItem.path) }],attrs:{"data-path":menuItem.path,"tabindex":"0"},on:{"click":_vm.toggleExpansion}},_vm.$listeners),[(menuItem.icon)?_c('span',{class:menuItem.icon}):_vm._e(),_vm._v(" "+_vm._s(menuItem.name)+" ")])])}),0)])]):_vm._e()}
var Navigationvue_type_template_id_86d2a74c_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/navigation/Navigation.vue?vue&type=script&lang=ts&
function Navigationvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return Navigationvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Navigationvue_type_script_lang_ts_typeof(obj); }

function Navigationvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Navigationvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Navigationvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) Navigationvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) Navigationvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Navigationvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) Navigationvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function Navigationvue_type_script_lang_ts_setPrototypeOf(o, p) { Navigationvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Navigationvue_type_script_lang_ts_setPrototypeOf(o, p); }

function Navigationvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = Navigationvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Navigationvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Navigationvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Navigationvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function Navigationvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (Navigationvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Navigationvue_type_script_lang_ts_assertThisInitialized(self); }

function Navigationvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Navigationvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Navigationvue_type_script_lang_ts_getPrototypeOf(o) { Navigationvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Navigationvue_type_script_lang_ts_getPrototypeOf(o); }




var Navigation = /*#__PURE__*/function (_Vue) {
  Navigationvue_type_script_lang_ts_inherits(Navigation, _Vue);

  var _super = Navigationvue_type_script_lang_ts_createSuper(Navigation);

  function Navigation() {
    var _this;

    Navigationvue_type_script_lang_ts_classCallCheck(this, Navigation);

    _this = _super.apply(this, arguments);
    _this.isExpanded = false;
    return _this;
  }

  Navigationvue_type_script_lang_ts_createClass(Navigation, [{
    key: "toggleExpansion",
    value: function toggleExpansion() {
      this.isExpanded = !this.isExpanded;
    }
  }, {
    key: "isActive",
    value: function isActive(itemHash) {
      return itemHash === this.activeMenuItem.path;
    }
  }, {
    key: "hasValidData",
    get: function get() {
      if (this.menuItems && this.menuItems.length) {
        return Array.isArray(this.menuItems);
      }

      return false;
    }
  }, {
    key: "mobileNavTogglerName",
    get: function get() {
      var name;

      if (this.activeMenuItem.name === undefined && this.defaultTogglerTitle !== undefined) {
        name = this.defaultTogglerTitle;
      } else if (this.activeMenuItem.name !== undefined) {
        name = this.activeMenuItem.name;
      } else {
        name = '';
      }

      return name;
    }
  }]);

  return Navigation;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], Navigation.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: null
})], Navigation.prototype, "maxWidth", void 0);

__decorate([Prop({
  default: null
})], Navigation.prototype, "topPosition", void 0);

__decorate([Prop({
  default: null
})], Navigation.prototype, "positionStyle", void 0);

__decorate([Prop({
  default: false
})], Navigation.prototype, "hasPost", void 0);

__decorate([Prop({
  default: function _default() {
    return [];
  }
})], Navigation.prototype, "menuItems", void 0);

__decorate([Prop({
  default: ''
})], Navigation.prototype, "activeMenuItem", void 0);

__decorate([Prop({
  default: ''
})], Navigation.prototype, "defaultTogglerTitle", void 0);

Navigation = __decorate([vue_class_component_esm["default"]], Navigation);
/* harmony default export */ var Navigationvue_type_script_lang_ts_ = (Navigation);
;// CONCATENATED MODULE: ./src/components/base/navigation/Navigation.vue?vue&type=script&lang=ts&
 /* harmony default export */ var navigation_Navigationvue_type_script_lang_ts_ = (Navigationvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/navigation/Navigation.vue?vue&type=style&index=0&id=86d2a74c&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/navigation/Navigation.vue?vue&type=style&index=0&id=86d2a74c&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/navigation/Navigation.vue



;


/* normalize component */

var Navigation_component = normalizeComponent(
  navigation_Navigationvue_type_script_lang_ts_,
  Navigationvue_type_template_id_86d2a74c_scoped_true_render,
  Navigationvue_type_template_id_86d2a74c_scoped_true_staticRenderFns,
  false,
  null,
  "86d2a74c",
  null
  
)

/* harmony default export */ var navigation_Navigation = (Navigation_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/PostboxTable.vue?vue&type=template&id=de34d374&
var PostboxTablevue_type_template_id_de34d374_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('table',{staticClass:"data-table data-table--fixed postbox",class:("postbox--" + _vm.responsiveClass),attrs:{"aria-describedby":"postbox table","data-observe-resizes":""}},[(this.$slots.postboxTableHead)?_c('thead',{staticClass:"hidden-xs"},[_vm._t("postboxTableHead")],2):_vm._e(),(this.$slots.postboxTableBody)?_c('tbody',[_vm._t("postboxTableBody")],2):_vm._e()])])}
var PostboxTablevue_type_template_id_de34d374_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/PostboxTable.vue?vue&type=script&lang=ts&
function PostboxTablevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return PostboxTablevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, PostboxTablevue_type_script_lang_ts_typeof(obj); }

function PostboxTablevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PostboxTablevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) PostboxTablevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) PostboxTablevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function PostboxTablevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PostboxTablevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) PostboxTablevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function PostboxTablevue_type_script_lang_ts_setPrototypeOf(o, p) { PostboxTablevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return PostboxTablevue_type_script_lang_ts_setPrototypeOf(o, p); }

function PostboxTablevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = PostboxTablevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = PostboxTablevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = PostboxTablevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return PostboxTablevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function PostboxTablevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (PostboxTablevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return PostboxTablevue_type_script_lang_ts_assertThisInitialized(self); }

function PostboxTablevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function PostboxTablevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function PostboxTablevue_type_script_lang_ts_getPrototypeOf(o) { PostboxTablevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return PostboxTablevue_type_script_lang_ts_getPrototypeOf(o); }





var PostboxTable = /*#__PURE__*/function (_Vue) {
  PostboxTablevue_type_script_lang_ts_inherits(PostboxTable, _Vue);

  var _super = PostboxTablevue_type_script_lang_ts_createSuper(PostboxTable);

  function PostboxTable() {
    PostboxTablevue_type_script_lang_ts_classCallCheck(this, PostboxTable);

    return _super.apply(this, arguments);
  }

  return PostboxTablevue_type_script_lang_ts_createClass(PostboxTable);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], PostboxTable.prototype, "disableStyles", void 0);

PostboxTable = __decorate([(0,vue_class_component_esm["default"])({
  mixins: [responsiveClassMixin]
})], PostboxTable);
/* harmony default export */ var PostboxTablevue_type_script_lang_ts_ = (PostboxTable);
;// CONCATENATED MODULE: ./src/components/base/modules/PostboxTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_PostboxTablevue_type_script_lang_ts_ = (PostboxTablevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/PostboxTable.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/PostboxTable.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/modules/PostboxTable.vue



;


/* normalize component */

var PostboxTable_component = normalizeComponent(
  modules_PostboxTablevue_type_script_lang_ts_,
  PostboxTablevue_type_template_id_de34d374_render,
  PostboxTablevue_type_template_id_de34d374_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var modules_PostboxTable = (PostboxTable_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/SearchResultBox.vue?vue&type=template&id=0616e6b5&scoped=true&
var SearchResultBoxvue_type_template_id_0616e6b5_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"data"},[_vm._l((_vm.data),function(item,index){return _c('div',{key:index},[(item.title)?_c('div',{staticClass:"title-block",attrs:{"data-observe-resizes":""}},[(item.title)?_c('div',{staticClass:"title-block--big"},[_c('strong',[_vm._v(" "+_vm._s(item.title.label)+" ")])]):_vm._e(),(item.subtitle)?_c('div',{staticClass:"title-block--small"},[_vm._v(_vm._s(item.subtitle.label))]):_vm._e()]):_vm._e(),_c('div',{staticClass:"data__list list",class:("list--" + _vm.responsiveClass),attrs:{"data-observe-resizes":""}},_vm._l((item.data),function(listItem,idx){return _c('div',{key:idx},[_c('SearchResultListLine',{attrs:{"term":listItem.label,"definition":listItem.value},on:{"click:selection":function($event){return _vm.itemSelected(listItem.label, listItem.value, listItem.id)}}})],1)}),0)])}),_vm._t("searchResultListTitle"),_vm._t("searchResultListContent")],2)])}
var SearchResultBoxvue_type_template_id_0616e6b5_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/SearchResultListLine.vue?vue&type=template&id=72107574&
var SearchResultListLinevue_type_template_id_72107574_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchData-line searchData-line__wrapper",on:{"click":function($event){$event.preventDefault();return _vm.$emit('click:selection', _vm.itemId)}}},[_c('div',{staticClass:"searchData-line__term",class:{ 'searchData-line__term--full': !_vm.term }},[_vm._v(" "+_vm._s(_vm.term)+" ")]),(_vm.term)?_c('div',{staticClass:"searchData-line__definition"},[_vm._v(" "+_vm._s(_vm.definition)+" ")]):_vm._e()])}
var SearchResultListLinevue_type_template_id_72107574_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/SearchResultListLine.vue?vue&type=script&lang=ts&
function SearchResultListLinevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return SearchResultListLinevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, SearchResultListLinevue_type_script_lang_ts_typeof(obj); }

function SearchResultListLinevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SearchResultListLinevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) SearchResultListLinevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) SearchResultListLinevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function SearchResultListLinevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchResultListLinevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) SearchResultListLinevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function SearchResultListLinevue_type_script_lang_ts_setPrototypeOf(o, p) { SearchResultListLinevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SearchResultListLinevue_type_script_lang_ts_setPrototypeOf(o, p); }

function SearchResultListLinevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = SearchResultListLinevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SearchResultListLinevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SearchResultListLinevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SearchResultListLinevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function SearchResultListLinevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (SearchResultListLinevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return SearchResultListLinevue_type_script_lang_ts_assertThisInitialized(self); }

function SearchResultListLinevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SearchResultListLinevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SearchResultListLinevue_type_script_lang_ts_getPrototypeOf(o) { SearchResultListLinevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SearchResultListLinevue_type_script_lang_ts_getPrototypeOf(o); }





var SearchResultListLine = /*#__PURE__*/function (_Vue) {
  SearchResultListLinevue_type_script_lang_ts_inherits(SearchResultListLine, _Vue);

  var _super = SearchResultListLinevue_type_script_lang_ts_createSuper(SearchResultListLine);

  function SearchResultListLine() {
    SearchResultListLinevue_type_script_lang_ts_classCallCheck(this, SearchResultListLine);

    return _super.apply(this, arguments);
  }

  return SearchResultListLinevue_type_script_lang_ts_createClass(SearchResultListLine);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: ''
})], SearchResultListLine.prototype, "term", void 0);

__decorate([Prop({
  default: ''
})], SearchResultListLine.prototype, "definition", void 0);

__decorate([Prop({
  default: ''
})], SearchResultListLine.prototype, "itemId", void 0);

SearchResultListLine = __decorate([(0,vue_class_component_esm["default"])({
  mixins: [responsiveClassMixin]
})], SearchResultListLine);
/* harmony default export */ var SearchResultListLinevue_type_script_lang_ts_ = (SearchResultListLine);
;// CONCATENATED MODULE: ./src/components/base/modules/SearchResultListLine.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_SearchResultListLinevue_type_script_lang_ts_ = (SearchResultListLinevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/SearchResultListLine.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/SearchResultListLine.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/modules/SearchResultListLine.vue



;


/* normalize component */

var SearchResultListLine_component = normalizeComponent(
  modules_SearchResultListLinevue_type_script_lang_ts_,
  SearchResultListLinevue_type_template_id_72107574_render,
  SearchResultListLinevue_type_template_id_72107574_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var modules_SearchResultListLine = (SearchResultListLine_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/SearchResultBox.vue?vue&type=script&lang=ts&
function SearchResultBoxvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return SearchResultBoxvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, SearchResultBoxvue_type_script_lang_ts_typeof(obj); }

function SearchResultBoxvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchResultBoxvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SearchResultBoxvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) SearchResultBoxvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) SearchResultBoxvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function SearchResultBoxvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) SearchResultBoxvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function SearchResultBoxvue_type_script_lang_ts_setPrototypeOf(o, p) { SearchResultBoxvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SearchResultBoxvue_type_script_lang_ts_setPrototypeOf(o, p); }

function SearchResultBoxvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = SearchResultBoxvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SearchResultBoxvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SearchResultBoxvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SearchResultBoxvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function SearchResultBoxvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (SearchResultBoxvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return SearchResultBoxvue_type_script_lang_ts_assertThisInitialized(self); }

function SearchResultBoxvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SearchResultBoxvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SearchResultBoxvue_type_script_lang_ts_getPrototypeOf(o) { SearchResultBoxvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SearchResultBoxvue_type_script_lang_ts_getPrototypeOf(o); }








var SearchResultBox = /*#__PURE__*/function (_Vue) {
  SearchResultBoxvue_type_script_lang_ts_inherits(SearchResultBox, _Vue);

  var _super = SearchResultBoxvue_type_script_lang_ts_createSuper(SearchResultBox);

  function SearchResultBox() {
    SearchResultBoxvue_type_script_lang_ts_classCallCheck(this, SearchResultBox);

    return _super.apply(this, arguments);
  }

  SearchResultBoxvue_type_script_lang_ts_createClass(SearchResultBox, [{
    key: "itemSelected",
    value: function itemSelected(label, value, id) {
      this.$emit('click:selection', label, value, id);
    }
  }]);

  return SearchResultBox;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], SearchResultBox.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: function _default() {
    return [];
  }
})], SearchResultBox.prototype, "data", void 0);

SearchResultBox = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    CustomButton: buttons_CustomButton,
    DataSection: modules_DataSection,
    SearchResultListLine: modules_SearchResultListLine
  },
  mixins: [responsiveClassMixin]
})], SearchResultBox);
/* harmony default export */ var SearchResultBoxvue_type_script_lang_ts_ = (SearchResultBox);
;// CONCATENATED MODULE: ./src/components/base/modules/SearchResultBox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_SearchResultBoxvue_type_script_lang_ts_ = (SearchResultBoxvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/SearchResultBox.vue?vue&type=style&index=0&id=0616e6b5&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/SearchResultBox.vue?vue&type=style&index=0&id=0616e6b5&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/modules/SearchResultBox.vue



;


/* normalize component */

var SearchResultBox_component = normalizeComponent(
  modules_SearchResultBoxvue_type_script_lang_ts_,
  SearchResultBoxvue_type_template_id_0616e6b5_scoped_true_render,
  SearchResultBoxvue_type_template_id_0616e6b5_scoped_true_staticRenderFns,
  false,
  null,
  "0616e6b5",
  null
  
)

/* harmony default export */ var modules_SearchResultBox = (SearchResultBox_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/SearchResultList.vue?vue&type=template&id=2ee47de0&
var SearchResultListvue_type_template_id_2ee47de0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"searchResult-items",attrs:{"data-observe-resizes":""}},[_vm._t("searchDataLines")],2)])}
var SearchResultListvue_type_template_id_2ee47de0_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/SearchResultList.vue?vue&type=script&lang=ts&
function SearchResultListvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return SearchResultListvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, SearchResultListvue_type_script_lang_ts_typeof(obj); }

function SearchResultListvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SearchResultListvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) SearchResultListvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) SearchResultListvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function SearchResultListvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchResultListvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) SearchResultListvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function SearchResultListvue_type_script_lang_ts_setPrototypeOf(o, p) { SearchResultListvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SearchResultListvue_type_script_lang_ts_setPrototypeOf(o, p); }

function SearchResultListvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = SearchResultListvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SearchResultListvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SearchResultListvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SearchResultListvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function SearchResultListvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (SearchResultListvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return SearchResultListvue_type_script_lang_ts_assertThisInitialized(self); }

function SearchResultListvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SearchResultListvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SearchResultListvue_type_script_lang_ts_getPrototypeOf(o) { SearchResultListvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SearchResultListvue_type_script_lang_ts_getPrototypeOf(o); }





var SearchResultList = /*#__PURE__*/function (_Vue) {
  SearchResultListvue_type_script_lang_ts_inherits(SearchResultList, _Vue);

  var _super = SearchResultListvue_type_script_lang_ts_createSuper(SearchResultList);

  function SearchResultList() {
    SearchResultListvue_type_script_lang_ts_classCallCheck(this, SearchResultList);

    return _super.apply(this, arguments);
  }

  return SearchResultListvue_type_script_lang_ts_createClass(SearchResultList);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], SearchResultList.prototype, "disableStyles", void 0);

SearchResultList = __decorate([(0,vue_class_component_esm["default"])({
  mixins: [responsiveClassMixin]
})], SearchResultList);
/* harmony default export */ var SearchResultListvue_type_script_lang_ts_ = (SearchResultList);
;// CONCATENATED MODULE: ./src/components/base/modules/SearchResultList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_SearchResultListvue_type_script_lang_ts_ = (SearchResultListvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/base/modules/SearchResultList.vue





/* normalize component */
;
var SearchResultList_component = normalizeComponent(
  modules_SearchResultListvue_type_script_lang_ts_,
  SearchResultListvue_type_template_id_2ee47de0_render,
  SearchResultListvue_type_template_id_2ee47de0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var modules_SearchResultList = (SearchResultList_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modal/Modal.vue?vue&type=template&id=6d5481e9&
var Modalvue_type_template_id_6d5481e9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showModal)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"modal",style:(_vm.maxWidthValue)},[_c('div',{staticClass:"modal__container",class:{ 'modal__container--centered': _vm.centeredText }},[(_vm.title.length > 0 || _vm.showCloseIcon)?_c('div',{staticClass:"modal__title"},[_c('h2',{staticClass:"modal__headline"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.showCloseIcon)?_c('div',{staticClass:"modal__closer"},[_vm._t("closerIcon",function(){return [_c('span',{staticClass:"icon-x",on:{"click":function($event){return _vm.$emit('closeModal')}}})]})],2):_vm._e()]):_vm._e(),(_vm.title.length > 0 || _vm.showCloseIcon)?_c('div',{staticClass:"modal__divider"}):_vm._e(),(this.$slots.content)?_c('div',{staticClass:"modal__content"},[_vm._t("content")],2):_vm._e(),(this.$slots.footer)?_c('div',{staticClass:"modal__footer"},[_vm._t("footer")],2):_vm._e()])])]):_vm._e()])],1)}
var Modalvue_type_template_id_6d5481e9_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modal/Modal.vue?vue&type=script&lang=ts&
function Modalvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return Modalvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Modalvue_type_script_lang_ts_typeof(obj); }

function Modalvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Modalvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Modalvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) Modalvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) Modalvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Modalvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) Modalvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function Modalvue_type_script_lang_ts_setPrototypeOf(o, p) { Modalvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Modalvue_type_script_lang_ts_setPrototypeOf(o, p); }

function Modalvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = Modalvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Modalvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Modalvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Modalvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function Modalvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (Modalvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Modalvue_type_script_lang_ts_assertThisInitialized(self); }

function Modalvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Modalvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Modalvue_type_script_lang_ts_getPrototypeOf(o) { Modalvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Modalvue_type_script_lang_ts_getPrototypeOf(o); }






var Modal = /*#__PURE__*/function (_Vue) {
  Modalvue_type_script_lang_ts_inherits(Modal, _Vue);

  var _super = Modalvue_type_script_lang_ts_createSuper(Modal);

  function Modal() {
    Modalvue_type_script_lang_ts_classCallCheck(this, Modal);

    return _super.apply(this, arguments);
  }

  Modalvue_type_script_lang_ts_createClass(Modal, [{
    key: "maxWidthValue",
    get: function get() {
      return this.maxWidth > 0 ? "maxWidth: ".concat(this.maxWidth, "px") : "maxWidth: 1070px";
    }
  }]);

  return Modal;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], Modal.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: false
})], Modal.prototype, "showModal", void 0);

__decorate([Prop({
  default: false
})], Modal.prototype, "showCloseIcon", void 0);

__decorate([Prop({
  default: false
})], Modal.prototype, "centeredText", void 0);

__decorate([Prop({
  default: ''
})], Modal.prototype, "title", void 0);

__decorate([Prop({
  default: 0
})], Modal.prototype, "maxWidth", void 0);

Modal = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    Spinner: modules_Spinner
  },
  mixins: [responsiveClassMixin]
})], Modal);
/* harmony default export */ var Modalvue_type_script_lang_ts_ = (Modal);
;// CONCATENATED MODULE: ./src/components/base/modal/Modal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modal_Modalvue_type_script_lang_ts_ = (Modalvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modal/Modal.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modal/Modal.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/modal/Modal.vue



;


/* normalize component */

var Modal_component = normalizeComponent(
  modal_Modalvue_type_script_lang_ts_,
  Modalvue_type_template_id_6d5481e9_render,
  Modalvue_type_template_id_6d5481e9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var modal_Modal = (Modal_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/ValidationRule.vue?vue&type=template&id=ec1b9e8c&scoped=true&
var ValidationRulevue_type_template_id_ec1b9e8c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ 'is-styled': !_vm.disableStyles }, { valid: _vm.valid }, { invalid: !_vm.valid }]},[_vm._t("default")],2)}
var ValidationRulevue_type_template_id_ec1b9e8c_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/ValidationRule.vue?vue&type=script&lang=ts&
function ValidationRulevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return ValidationRulevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, ValidationRulevue_type_script_lang_ts_typeof(obj); }

function ValidationRulevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ValidationRulevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) ValidationRulevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) ValidationRulevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ValidationRulevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ValidationRulevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) ValidationRulevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function ValidationRulevue_type_script_lang_ts_setPrototypeOf(o, p) { ValidationRulevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ValidationRulevue_type_script_lang_ts_setPrototypeOf(o, p); }

function ValidationRulevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = ValidationRulevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ValidationRulevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ValidationRulevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ValidationRulevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function ValidationRulevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (ValidationRulevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return ValidationRulevue_type_script_lang_ts_assertThisInitialized(self); }

function ValidationRulevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ValidationRulevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ValidationRulevue_type_script_lang_ts_getPrototypeOf(o) { ValidationRulevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ValidationRulevue_type_script_lang_ts_getPrototypeOf(o); }




var ValidationRule = /*#__PURE__*/function (_Vue) {
  ValidationRulevue_type_script_lang_ts_inherits(ValidationRule, _Vue);

  var _super = ValidationRulevue_type_script_lang_ts_createSuper(ValidationRule);

  function ValidationRule() {
    ValidationRulevue_type_script_lang_ts_classCallCheck(this, ValidationRule);

    return _super.apply(this, arguments);
  }

  return ValidationRulevue_type_script_lang_ts_createClass(ValidationRule);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], ValidationRule.prototype, "valid", void 0);

__decorate([Prop({
  default: false
})], ValidationRule.prototype, "disableStyles", void 0);

ValidationRule = __decorate([vue_class_component_esm["default"]], ValidationRule);
/* harmony default export */ var ValidationRulevue_type_script_lang_ts_ = (ValidationRule);
;// CONCATENATED MODULE: ./src/components/base/modules/ValidationRule.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_ValidationRulevue_type_script_lang_ts_ = (ValidationRulevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/ValidationRule.vue?vue&type=style&index=0&id=ec1b9e8c&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/ValidationRule.vue?vue&type=style&index=0&id=ec1b9e8c&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/modules/ValidationRule.vue



;


/* normalize component */

var ValidationRule_component = normalizeComponent(
  modules_ValidationRulevue_type_script_lang_ts_,
  ValidationRulevue_type_template_id_ec1b9e8c_scoped_true_render,
  ValidationRulevue_type_template_id_ec1b9e8c_scoped_true_staticRenderFns,
  false,
  null,
  "ec1b9e8c",
  null
  
)

/* harmony default export */ var modules_ValidationRule = (ValidationRule_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/Contact.vue?vue&type=template&id=d93f761e&
var Contactvue_type_template_id_d93f761e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"contact"},[_c('div',{staticClass:"contact__pic"},[_c('div',{class:{ 'pic-frame--icon': !this.$slots.image }},[_vm._t("image",function(){return [_c('span',{staticClass:"pic-frame__icon icon-berater-netzwerk"})]})],2)]),_c('div',{staticClass:"contact__info"},[(_vm.contactName)?_c('p',{staticClass:"contact__title"},[_vm._v(_vm._s(_vm.contactName))]):_vm._e(),(_vm.contactNameAddition)?_c('p',{staticClass:"small"},[_vm._v(" "+_vm._s(_vm.contactNameAddition)+" ")]):_vm._e(),(this.$slots.address)?_c('address',{staticClass:"contact__address"},[_vm._t("address")],2):_vm._e()])])])}
var Contactvue_type_template_id_d93f761e_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/Contact.vue?vue&type=script&lang=ts&
function Contactvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return Contactvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Contactvue_type_script_lang_ts_typeof(obj); }

function Contactvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Contactvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) Contactvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) Contactvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Contactvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Contactvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) Contactvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function Contactvue_type_script_lang_ts_setPrototypeOf(o, p) { Contactvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Contactvue_type_script_lang_ts_setPrototypeOf(o, p); }

function Contactvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = Contactvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Contactvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Contactvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Contactvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function Contactvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (Contactvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Contactvue_type_script_lang_ts_assertThisInitialized(self); }

function Contactvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Contactvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Contactvue_type_script_lang_ts_getPrototypeOf(o) { Contactvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Contactvue_type_script_lang_ts_getPrototypeOf(o); }




var Contact = /*#__PURE__*/function (_Vue) {
  Contactvue_type_script_lang_ts_inherits(Contact, _Vue);

  var _super = Contactvue_type_script_lang_ts_createSuper(Contact);

  function Contact() {
    Contactvue_type_script_lang_ts_classCallCheck(this, Contact);

    return _super.call(this);
  }

  return Contactvue_type_script_lang_ts_createClass(Contact);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], Contact.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: ''
})], Contact.prototype, "contactName", void 0);

__decorate([Prop({
  default: ''
})], Contact.prototype, "contactNameAddition", void 0);

Contact = __decorate([vue_class_component_esm["default"]], Contact);
/* harmony default export */ var Contactvue_type_script_lang_ts_ = (Contact);
;// CONCATENATED MODULE: ./src/components/base/modules/Contact.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_Contactvue_type_script_lang_ts_ = (Contactvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/Contact.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/Contact.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/modules/Contact.vue



;


/* normalize component */

var Contact_component = normalizeComponent(
  modules_Contactvue_type_script_lang_ts_,
  Contactvue_type_template_id_d93f761e_render,
  Contactvue_type_template_id_d93f761e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var modules_Contact = (Contact_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/TextImageTeaser.vue?vue&type=template&id=5824da46&
var TextImageTeaservue_type_template_id_5824da46_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ 'is-styled': !_vm.disableStyles }]},[_c('div',{staticClass:"teaser",class:[_vm.horizontalPositionClassname, _vm.backgroundColorName]},[_c('div',{staticClass:"teaser__content"},[_c('div',{staticClass:"teaser__content__top"},[_vm._t("default"),_c('div',[_vm._t("text")],2)],2),(_vm.isThereAtleastOneButton)?_c('div',{staticClass:"teaser__content__bottom"},[_c('div',{staticClass:"teaser__button"},[_vm._t("button")],2),_c('div',{staticClass:"teaser__button2"},[_vm._t("button2")],2)]):_vm._e()]),_c('div',{staticClass:"teaser__pic",class:[_vm.verticalPicPositionClassname, { 'image-cropper': _vm.imageDisplayedInCircle }]},[_vm._t("image")],2)])])}
var TextImageTeaservue_type_template_id_5824da46_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/TextImageTeaser.vue?vue&type=script&lang=ts&
function TextImageTeaservue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return TextImageTeaservue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, TextImageTeaservue_type_script_lang_ts_typeof(obj); }

function TextImageTeaservue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TextImageTeaservue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TextImageTeaservue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) TextImageTeaservue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) TextImageTeaservue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function TextImageTeaservue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) TextImageTeaservue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function TextImageTeaservue_type_script_lang_ts_setPrototypeOf(o, p) { TextImageTeaservue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return TextImageTeaservue_type_script_lang_ts_setPrototypeOf(o, p); }

function TextImageTeaservue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = TextImageTeaservue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = TextImageTeaservue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = TextImageTeaservue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return TextImageTeaservue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function TextImageTeaservue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (TextImageTeaservue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return TextImageTeaservue_type_script_lang_ts_assertThisInitialized(self); }

function TextImageTeaservue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function TextImageTeaservue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function TextImageTeaservue_type_script_lang_ts_getPrototypeOf(o) { TextImageTeaservue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return TextImageTeaservue_type_script_lang_ts_getPrototypeOf(o); }




var TextImageTeaser = /*#__PURE__*/function (_Vue) {
  TextImageTeaservue_type_script_lang_ts_inherits(TextImageTeaser, _Vue);

  var _super = TextImageTeaservue_type_script_lang_ts_createSuper(TextImageTeaser);

  function TextImageTeaser() {
    TextImageTeaservue_type_script_lang_ts_classCallCheck(this, TextImageTeaser);

    return _super.call(this);
  }

  TextImageTeaservue_type_script_lang_ts_createClass(TextImageTeaser, [{
    key: "horizontalPositionClassname",
    get: function get() {
      return this.horizontalPicPosition === 'left' ? 'teaser--image-left' : '';
    }
  }, {
    key: "verticalPicPositionClassname",
    get: function get() {
      var verticalPicPositionClass;

      switch (this.verticalPicPosition) {
        case 'top':
          verticalPicPositionClass = 'teaser__pic--top';
          break;

        case 'center':
          verticalPicPositionClass = 'teaser__pic--center';
          break;

        default:
          verticalPicPositionClass = '';
      }

      return verticalPicPositionClass;
    }
  }, {
    key: "backgroundColorName",
    get: function get() {
      return this.backgroundColor;
    }
  }, {
    key: "isThereAtleastOneButton",
    get: function get() {
      return this.$slots.button || this.$slots.button2;
    }
  }]);

  return TextImageTeaser;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], TextImageTeaser.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: 'right'
})], TextImageTeaser.prototype, "horizontalPicPosition", void 0);

__decorate([Prop({
  default: 'bottom'
})], TextImageTeaser.prototype, "verticalPicPosition", void 0);

__decorate([Prop({
  default: false
})], TextImageTeaser.prototype, "imageDisplayedInCircle", void 0);

__decorate([Prop({
  default: 'default'
})], TextImageTeaser.prototype, "backgroundColor", void 0);

TextImageTeaser = __decorate([vue_class_component_esm["default"]], TextImageTeaser);
/* harmony default export */ var TextImageTeaservue_type_script_lang_ts_ = (TextImageTeaser);
;// CONCATENATED MODULE: ./src/components/base/modules/TextImageTeaser.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_TextImageTeaservue_type_script_lang_ts_ = (TextImageTeaservue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/TextImageTeaser.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/TextImageTeaser.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/modules/TextImageTeaser.vue



;


/* normalize component */

var TextImageTeaser_component = normalizeComponent(
  modules_TextImageTeaservue_type_script_lang_ts_,
  TextImageTeaservue_type_template_id_5824da46_render,
  TextImageTeaservue_type_template_id_5824da46_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var modules_TextImageTeaser = (TextImageTeaser_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/PostboxTeaser.vue?vue&type=template&id=923377a2&
var PostboxTeaservue_type_template_id_923377a2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"postbox-teaser",class:[
    { 'is-styled': !_vm.disableStyles },
    { 'postbox-teaser--centered-vertically': _vm.contentCenteredVertically },
    { 'postbox-teaser--hover': _vm.hasHover } ],attrs:{"data-track-id":_vm.trackId}},[_c('div',{staticClass:"postbox-teaser__content"},[_vm._t("content"),_c('div',{staticClass:"postbox-teaser__message"},[_vm._t("message",function(){return [_vm._v(" ")]})],2),(this.$slots.button)?_c('div',{staticClass:"postbox-teaser__button"},[_vm._t("button")],2):_vm._e()],2)])}
var PostboxTeaservue_type_template_id_923377a2_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/PostboxTeaser.vue?vue&type=script&lang=ts&
function PostboxTeaservue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return PostboxTeaservue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, PostboxTeaservue_type_script_lang_ts_typeof(obj); }

function PostboxTeaservue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PostboxTeaservue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) PostboxTeaservue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) PostboxTeaservue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function PostboxTeaservue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PostboxTeaservue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) PostboxTeaservue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function PostboxTeaservue_type_script_lang_ts_setPrototypeOf(o, p) { PostboxTeaservue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return PostboxTeaservue_type_script_lang_ts_setPrototypeOf(o, p); }

function PostboxTeaservue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = PostboxTeaservue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = PostboxTeaservue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = PostboxTeaservue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return PostboxTeaservue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function PostboxTeaservue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (PostboxTeaservue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return PostboxTeaservue_type_script_lang_ts_assertThisInitialized(self); }

function PostboxTeaservue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function PostboxTeaservue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function PostboxTeaservue_type_script_lang_ts_getPrototypeOf(o) { PostboxTeaservue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return PostboxTeaservue_type_script_lang_ts_getPrototypeOf(o); }




var PostboxTeaser = /*#__PURE__*/function (_Vue) {
  PostboxTeaservue_type_script_lang_ts_inherits(PostboxTeaser, _Vue);

  var _super = PostboxTeaservue_type_script_lang_ts_createSuper(PostboxTeaser);

  function PostboxTeaser() {
    PostboxTeaservue_type_script_lang_ts_classCallCheck(this, PostboxTeaser);

    return _super.call(this);
  }

  return PostboxTeaservue_type_script_lang_ts_createClass(PostboxTeaser);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], PostboxTeaser.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: false
})], PostboxTeaser.prototype, "contentCenteredVertically", void 0);

__decorate([Prop({
  default: false
})], PostboxTeaser.prototype, "hasHover", void 0);

__decorate([Prop()], PostboxTeaser.prototype, "trackId", void 0);

PostboxTeaser = __decorate([vue_class_component_esm["default"]], PostboxTeaser);
/* harmony default export */ var PostboxTeaservue_type_script_lang_ts_ = (PostboxTeaser);
;// CONCATENATED MODULE: ./src/components/base/modules/PostboxTeaser.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_PostboxTeaservue_type_script_lang_ts_ = (PostboxTeaservue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/PostboxTeaser.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/PostboxTeaser.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/modules/PostboxTeaser.vue



;


/* normalize component */

var PostboxTeaser_component = normalizeComponent(
  modules_PostboxTeaservue_type_script_lang_ts_,
  PostboxTeaservue_type_template_id_923377a2_render,
  PostboxTeaservue_type_template_id_923377a2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var modules_PostboxTeaser = (PostboxTeaser_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/FlexGrid.vue?vue&type=template&id=1267bffd&
var FlexGridvue_type_template_id_1267bffd_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"flex-footer",class:("flex-footer--" + _vm.responsiveClass),attrs:{"data-observe-resizes":""}},[(this.$slots['flex-left'])?_c('div',{staticClass:"flex-footer__left"},[_vm._t("flex-left")],2):_vm._e(),(this.$slots['flex-right'])?_c('div',{staticClass:"flex-footer__right"},[_vm._t("flex-right")],2):_vm._e()])])}
var FlexGridvue_type_template_id_1267bffd_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/FlexGrid.vue?vue&type=script&lang=ts&
function FlexGridvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return FlexGridvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, FlexGridvue_type_script_lang_ts_typeof(obj); }

function FlexGridvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function FlexGridvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) FlexGridvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) FlexGridvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function FlexGridvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FlexGridvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) FlexGridvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function FlexGridvue_type_script_lang_ts_setPrototypeOf(o, p) { FlexGridvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return FlexGridvue_type_script_lang_ts_setPrototypeOf(o, p); }

function FlexGridvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = FlexGridvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = FlexGridvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = FlexGridvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return FlexGridvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function FlexGridvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (FlexGridvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return FlexGridvue_type_script_lang_ts_assertThisInitialized(self); }

function FlexGridvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function FlexGridvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function FlexGridvue_type_script_lang_ts_getPrototypeOf(o) { FlexGridvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return FlexGridvue_type_script_lang_ts_getPrototypeOf(o); }





var FlexGrid = /*#__PURE__*/function (_Vue) {
  FlexGridvue_type_script_lang_ts_inherits(FlexGrid, _Vue);

  var _super = FlexGridvue_type_script_lang_ts_createSuper(FlexGrid);

  function FlexGrid() {
    FlexGridvue_type_script_lang_ts_classCallCheck(this, FlexGrid);

    return _super.apply(this, arguments);
  }

  return FlexGridvue_type_script_lang_ts_createClass(FlexGrid);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], FlexGrid.prototype, "disableStyles", void 0);

FlexGrid = __decorate([(0,vue_class_component_esm["default"])({
  mixins: [responsiveClassMixin]
})], FlexGrid);
/* harmony default export */ var FlexGridvue_type_script_lang_ts_ = (FlexGrid);
;// CONCATENATED MODULE: ./src/components/base/container/FlexGrid.vue?vue&type=script&lang=ts&
 /* harmony default export */ var container_FlexGridvue_type_script_lang_ts_ = (FlexGridvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/FlexGrid.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/container/FlexGrid.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/container/FlexGrid.vue



;


/* normalize component */

var FlexGrid_component = normalizeComponent(
  container_FlexGridvue_type_script_lang_ts_,
  FlexGridvue_type_template_id_1267bffd_render,
  FlexGridvue_type_template_id_1267bffd_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var container_FlexGrid = (FlexGrid_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/PromotionArea.vue?vue&type=template&id=f66c6fc4&scoped=true&
var PromotionAreavue_type_template_id_f66c6fc4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promotion-area",class:[{ 'is-styled': !_vm.disableStyles }, { 'promotion-area--hover': _vm.hasHover }],attrs:{"data-track-id":_vm.trackId}},[_c('div',{staticClass:"promotion-area__content"},[_c('img',{attrs:{"loading":"lazy","src":_vm.imageUrl,"srcset":_vm.imageSrcset}}),_c('div',{staticClass:"promotion-area__button"},[_c('CustomButton',{attrs:{"button-color":"cta2"}},[_vm._v(_vm._s(_vm.buttonText))])],1)])])}
var PromotionAreavue_type_template_id_f66c6fc4_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/PromotionArea.vue?vue&type=script&lang=ts&
function PromotionAreavue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return PromotionAreavue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, PromotionAreavue_type_script_lang_ts_typeof(obj); }

function PromotionAreavue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PromotionAreavue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) PromotionAreavue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) PromotionAreavue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function PromotionAreavue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PromotionAreavue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) PromotionAreavue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function PromotionAreavue_type_script_lang_ts_setPrototypeOf(o, p) { PromotionAreavue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return PromotionAreavue_type_script_lang_ts_setPrototypeOf(o, p); }

function PromotionAreavue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = PromotionAreavue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = PromotionAreavue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = PromotionAreavue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return PromotionAreavue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function PromotionAreavue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (PromotionAreavue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return PromotionAreavue_type_script_lang_ts_assertThisInitialized(self); }

function PromotionAreavue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function PromotionAreavue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function PromotionAreavue_type_script_lang_ts_getPrototypeOf(o) { PromotionAreavue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return PromotionAreavue_type_script_lang_ts_getPrototypeOf(o); }





var PromotionArea = /*#__PURE__*/function (_Vue) {
  PromotionAreavue_type_script_lang_ts_inherits(PromotionArea, _Vue);

  var _super = PromotionAreavue_type_script_lang_ts_createSuper(PromotionArea);

  function PromotionArea() {
    PromotionAreavue_type_script_lang_ts_classCallCheck(this, PromotionArea);

    return _super.call(this);
  }

  return PromotionAreavue_type_script_lang_ts_createClass(PromotionArea);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], PromotionArea.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: true
})], PromotionArea.prototype, "hasHover", void 0);

__decorate([Prop({
  default: '',
  required: true
})], PromotionArea.prototype, "buttonText", void 0);

__decorate([Prop({
  default: '',
  required: true
})], PromotionArea.prototype, "imageUrl", void 0);

__decorate([Prop({
  default: '',
  required: true
})], PromotionArea.prototype, "imageSrcset", void 0);

__decorate([Prop()], PromotionArea.prototype, "trackId", void 0);

PromotionArea = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    CustomButton: buttons_CustomButton
  }
})], PromotionArea);
/* harmony default export */ var PromotionAreavue_type_script_lang_ts_ = (PromotionArea);
;// CONCATENATED MODULE: ./src/components/base/modules/PromotionArea.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_PromotionAreavue_type_script_lang_ts_ = (PromotionAreavue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/PromotionArea.vue?vue&type=style&index=0&id=f66c6fc4&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/PromotionArea.vue?vue&type=style&index=0&id=f66c6fc4&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/modules/PromotionArea.vue



;


/* normalize component */

var PromotionArea_component = normalizeComponent(
  modules_PromotionAreavue_type_script_lang_ts_,
  PromotionAreavue_type_template_id_f66c6fc4_scoped_true_render,
  PromotionAreavue_type_template_id_f66c6fc4_scoped_true_staticRenderFns,
  false,
  null,
  "f66c6fc4",
  null
  
)

/* harmony default export */ var modules_PromotionArea = (PromotionArea_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/SelectMenue.vue?vue&type=template&id=bf2b3ebc&
var SelectMenuevue_type_template_id_bf2b3ebc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-styled': !_vm.disableStyles }},[_c('div',{staticClass:"form-group",class:[
      { 'form-group--invalid': _vm.isError },
      { 'form-group--filled': _vm.isFilled },
      { 'form-group--empty': _vm.isEmpty },
      { 'form-group--disabled': _vm.isDisabled } ]},[_c('v-select',{staticClass:"selectmenue",attrs:{"options":_vm.options,"placeholder":_vm.showPlaceHolder ? _vm.placeholder : '',"clearable":_vm.clearable,"disabled":_vm.isDisabled,"loading":_vm.loading,"searchable":_vm.searchable,"selectOnTab":_vm.selectOnTab},on:{"search":_vm.onSearch,"input":_vm.setSelected,"open":_vm.onFocus,"close":_vm.onBlur},scopedSlots:_vm._u([{key:"open-indicator",fn:function(ref){
    var attributes = ref.attributes;
return [_c('span',_vm._b({staticClass:"icon-chevron-down"},'span',attributes,false))]}},{key:"clear",fn:function(ref){
    var attributes = ref.attributes;
return [_c('span',_vm._b({staticClass:"icon-chevron-down"},'span',attributes,false))]}},{key:"spinner",fn:function(ref){
    var loading = ref.loading;
return [(loading)?_c('div',{staticClass:"spinner spinner-selectmenu",staticStyle:{"{\n              border-left-color":"white"}}):_vm._e()]}},{key:"no-options",fn:function(ref){
    var search = ref.search;
    var searching = ref.searching;
return [(searching && search.length >= _vm.minInputForSearch)?[_vm._v(" "+_vm._s(_vm.noResultsFoundText)+" "),_c('em',[_vm._v(" "+_vm._s(search))])]:_c('div',{staticStyle:{"opacity":"1"}},[_vm._v(_vm._s(_vm.startTypingForSearchText))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_c('label',{staticClass:"form-group__label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"form-group__bar"})],1),(_vm.isError)?_c('div',{staticClass:"form-group__error select-menu"},[_vm._t("error",function(){return [_vm._v("Irgendeine Defaultfehlermeldung")]})],2):_vm._e()])}
var SelectMenuevue_type_template_id_bf2b3ebc_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var vue_select = __webpack_require__(938);
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/SelectMenue.vue?vue&type=script&lang=ts&
function SelectMenuevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return SelectMenuevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, SelectMenuevue_type_script_lang_ts_typeof(obj); }

function SelectMenuevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SelectMenuevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SelectMenuevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) SelectMenuevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) SelectMenuevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function SelectMenuevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) SelectMenuevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function SelectMenuevue_type_script_lang_ts_setPrototypeOf(o, p) { SelectMenuevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SelectMenuevue_type_script_lang_ts_setPrototypeOf(o, p); }

function SelectMenuevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = SelectMenuevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SelectMenuevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SelectMenuevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SelectMenuevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function SelectMenuevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (SelectMenuevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return SelectMenuevue_type_script_lang_ts_assertThisInitialized(self); }

function SelectMenuevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SelectMenuevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SelectMenuevue_type_script_lang_ts_getPrototypeOf(o) { SelectMenuevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SelectMenuevue_type_script_lang_ts_getPrototypeOf(o); }







var SelectMenue = /*#__PURE__*/function (_Vue) {
  SelectMenuevue_type_script_lang_ts_inherits(SelectMenue, _Vue);

  var _super = SelectMenuevue_type_script_lang_ts_createSuper(SelectMenue);

  function SelectMenue() {
    var _this;

    SelectMenuevue_type_script_lang_ts_classCallCheck(this, SelectMenue);

    _this = _super.apply(this, arguments);
    _this.showPlaceHolder = false;
    _this.id = '';
    _this.selected = _this.defaultValue;
    _this.timer = null;
    _this.value = '';
    return _this;
  }

  SelectMenuevue_type_script_lang_ts_createClass(SelectMenue, [{
    key: "isFilled",
    get: function get() {
      return !!this.selected && (this.selected.length > 0 || this.selected.length !== null) || this.loading;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.value.length === 0;
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return this.status === InputStatus.DISABLED;
    }
  }, {
    key: "isError",
    get: function get() {
      return this.status === InputStatus.ERROR;
    }
  }, {
    key: "onBlur",
    value: function onBlur(_e) {
      var _this2 = this;

      this.showPlaceHolder = false;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(function () {
        if (_this2.required && !_this2.isFilled) {
          _this2.$emit('update:error');
        } else if (_this2.isFilled) {
          _this2.$emit('update:input');
        } else {
          _this2.$emit('update:cleared');
        }
      }, 250);
    }
  }, {
    key: "setSelected",
    value: function setSelected() {
      this.$emit('input', this.selected);
    }
  }, {
    key: "onSearch",
    value: function onSearch(searchable, loading) {
      this.$emit('search', searchable, loading);
    }
  }, {
    key: "onFocus",
    value: function onFocus(_e) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.showPlaceHolder = true;
    }
  }]);

  return SelectMenue;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], SelectMenue.prototype, "disableStyles", void 0);

__decorate([Prop({
  default: 'Label'
})], SelectMenue.prototype, "label", void 0);

__decorate([Prop({
  default: function _default() {
    return [];
  }
})], SelectMenue.prototype, "options", void 0);

__decorate([Prop({
  default: ''
})], SelectMenue.prototype, "idProp", void 0);

__decorate([Prop({
  default: ''
})], SelectMenue.prototype, "placeholder", void 0);

__decorate([Prop({
  default: InputStatus.DEFAULT
})], SelectMenue.prototype, "status", void 0);

__decorate([Prop({
  default: false
})], SelectMenue.prototype, "required", void 0);

__decorate([Prop({
  default: false
})], SelectMenue.prototype, "clearable", void 0);

__decorate([Prop({
  default: false
})], SelectMenue.prototype, "disabled", void 0);

__decorate([Prop({
  default: false
})], SelectMenue.prototype, "loading", void 0);

__decorate([Prop({
  default: false
})], SelectMenue.prototype, "searchable", void 0);

__decorate([Prop({
  default: true
})], SelectMenue.prototype, "selectOnTab", void 0);

__decorate([Prop({
  default: ''
})], SelectMenue.prototype, "defaultValue", void 0);

__decorate([Prop({
  default: 'Start typing to search for a country.'
})], SelectMenue.prototype, "startTypingForSearchText", void 0);

__decorate([Prop({
  default: 'No results found for '
})], SelectMenue.prototype, "noResultsFoundText", void 0);

__decorate([Prop({
  default: 3
})], SelectMenue.prototype, "minInputForSearch", void 0);

SelectMenue = __decorate([(0,vue_mixin_decorator_umd.Component)({
  components: {
    vSelect: (vue_select_default())
  }
})], SelectMenue);
/* harmony default export */ var SelectMenuevue_type_script_lang_ts_ = (SelectMenue);
;// CONCATENATED MODULE: ./src/components/base/input/SelectMenue.vue?vue&type=script&lang=ts&
 /* harmony default export */ var input_SelectMenuevue_type_script_lang_ts_ = (SelectMenuevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/input/SelectMenue.vue?vue&type=style&index=0&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/input/SelectMenue.vue?vue&type=style&index=0&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/input/SelectMenue.vue



;


/* normalize component */

var SelectMenue_component = normalizeComponent(
  input_SelectMenuevue_type_script_lang_ts_,
  SelectMenuevue_type_template_id_bf2b3ebc_render,
  SelectMenuevue_type_template_id_bf2b3ebc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var input_SelectMenue = (SelectMenue_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/HoverableIconBig.vue?vue&type=template&id=fc78a5a6&scoped=true&
var HoverableIconBigvue_type_template_id_fc78a5a6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hoverable-icon-big",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{class:("icon-" + (_vm.iconDataSpan.iconClass))}),_c('div',{staticClass:"label",domProps:{"textContent":_vm._s(_vm.iconDataSpan.label)}})])}
var HoverableIconBigvue_type_template_id_fc78a5a6_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/HoverableIconBig.vue?vue&type=script&lang=ts&
function HoverableIconBigvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return HoverableIconBigvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, HoverableIconBigvue_type_script_lang_ts_typeof(obj); }

function HoverableIconBigvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function HoverableIconBigvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) HoverableIconBigvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) HoverableIconBigvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function HoverableIconBigvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HoverableIconBigvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) HoverableIconBigvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function HoverableIconBigvue_type_script_lang_ts_setPrototypeOf(o, p) { HoverableIconBigvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return HoverableIconBigvue_type_script_lang_ts_setPrototypeOf(o, p); }

function HoverableIconBigvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = HoverableIconBigvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = HoverableIconBigvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = HoverableIconBigvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return HoverableIconBigvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function HoverableIconBigvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (HoverableIconBigvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return HoverableIconBigvue_type_script_lang_ts_assertThisInitialized(self); }

function HoverableIconBigvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function HoverableIconBigvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function HoverableIconBigvue_type_script_lang_ts_getPrototypeOf(o) { HoverableIconBigvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return HoverableIconBigvue_type_script_lang_ts_getPrototypeOf(o); }




var HoverableIconBig = /*#__PURE__*/function (_Vue) {
  HoverableIconBigvue_type_script_lang_ts_inherits(HoverableIconBig, _Vue);

  var _super = HoverableIconBigvue_type_script_lang_ts_createSuper(HoverableIconBig);

  function HoverableIconBig() {
    HoverableIconBigvue_type_script_lang_ts_classCallCheck(this, HoverableIconBig);

    return _super.apply(this, arguments);
  }

  return HoverableIconBigvue_type_script_lang_ts_createClass(HoverableIconBig);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  required: true
})], HoverableIconBig.prototype, "iconDataSpan", void 0);

HoverableIconBig = __decorate([vue_class_component_esm["default"]], HoverableIconBig);
/* harmony default export */ var HoverableIconBigvue_type_script_lang_ts_ = (HoverableIconBig);
;// CONCATENATED MODULE: ./src/components/base/modules/HoverableIconBig.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modules_HoverableIconBigvue_type_script_lang_ts_ = (HoverableIconBigvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/modules/HoverableIconBig.vue?vue&type=style&index=0&id=fc78a5a6&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/modules/HoverableIconBig.vue?vue&type=style&index=0&id=fc78a5a6&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/modules/HoverableIconBig.vue



;


/* normalize component */

var HoverableIconBig_component = normalizeComponent(
  modules_HoverableIconBigvue_type_script_lang_ts_,
  HoverableIconBigvue_type_template_id_fc78a5a6_scoped_true_render,
  HoverableIconBigvue_type_template_id_fc78a5a6_scoped_true_staticRenderFns,
  false,
  null,
  "fc78a5a6",
  null
  
)

/* harmony default export */ var modules_HoverableIconBig = (HoverableIconBig_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/SelfServiceForm.vue?vue&type=template&id=33994d64&scoped=true&
var SelfServiceFormvue_type_template_id_33994d64_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-styled"},[(!_vm.showResponse)?_c('Card',{attrs:{"footerDivider":false,"loadingState":_vm.isLoading,"title":_vm.firstTitle || _vm.selfServiceLabels.formCardTitle},scopedSlots:_vm._u([{key:"infobox",fn:function(){return [_c('div',{staticClass:"card-row card-row-wrap"},[_c('div',{class:("col-full-width--" + _vm.responsiveClass)},[_c('div',[_c('h3',{staticClass:"infobox__title"},[_vm._v(" "+_vm._s(_vm.selfServiceLabels.formCurrentDataLabel)+" ")]),(_vm.selfServiceLabels.formCurrentDataValue)?_c('span',{staticClass:"infobox__text"},[_vm._v(": "+_vm._s(_vm.selfServiceLabels.formCurrentDataValue))]):_vm._e()]),(_vm.selfServiceLabels.formCurrentInfoText)?_c('div',{staticClass:"infobox__text",domProps:{"innerHTML":_vm._s(_vm.selfServiceLabels.formCurrentInfoText)}}):_vm._e(),(_vm.formBlocks)?_c('div',{staticClass:"infobox__text"},_vm._l((_vm.formBlocks),function(infoBlock,index){return _c('div',{key:index,staticClass:"infobox__paragraph"},_vm._l((_vm.formBlocks[index]),function(infoBlock,i){return _c('div',{key:i,staticClass:"show-as-line"},[_c('span',[_vm._v(_vm._s(infoBlock.key)+" ")]),_c('span',{staticClass:"desktop-view-only"},[_vm._v("·")]),_c('span',[_vm._v(" "+_vm._s(infoBlock.value))])])}),0)}),0):_vm._e()]),(_vm.selfServiceLabels.formCurrentExtraText)?_c('div',{class:("col-rest-width--" + _vm.responsiveClass + " center-vertical")},[_c('div',{class:("extrabox--" + _vm.responsiveClass)},[_vm._v(" "+_vm._s(_vm.selfServiceLabels.formCurrentExtraText)+" ")]),(_vm.selfServiceLabels.currentPremiumSubText)?_c('small',{staticClass:"disabled-color-white mt-8 centerHeight"},[_vm._v(" "+_vm._s(_vm.selfServiceLabels.currentPremiumSubText)+"  "),_c('span',{staticClass:"icon-vorteile disabled-color-white",on:{"click":_vm.openModalProlongationCurrentPremium}})]):_vm._e()]):_vm._e()])]},proxy:true},{key:"content",fn:function(){return [_vm._t("main"),_c('EnterDateCardRow',{attrs:{"info-label":_vm.selfServiceLabels.formDateLabel,"info-text":_vm.selfServiceLabels.formDateErrorText,"showDateOption":_vm.showDateOption},on:{"input":_vm.onDateInputValueChanged,"status":_vm.setDateInputStatus},model:{value:(_vm.localStartDate),callback:function ($$v) {_vm.localStartDate=$$v},expression:"localStartDate"}}),_c('Alert',{attrs:{"type":_vm.warning},scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('div',{staticClass:"formHintLabelTitle"},[_vm._v(_vm._s(_vm.formHintLabelTitle))]),_c('div',{staticClass:"formHintLabelText"},[_vm._v(_vm._s(_vm.formHintLabel))])]},proxy:true}],null,false,1249009103)})]},proxy:true},{key:"footer",fn:function(){return [_c('div',{staticClass:"footer-cta footer-cta--left"},[_c('CustomButton',{staticClass:"formSubmitButton",attrs:{"buttonColor":"cta1","disabledState":_vm.isDateAndFormInvalid,"pendingState":!_vm.isDateAndFormInvalid && _vm.isSubmitting},nativeOn:{"click":function($event){return _vm.$emit('button:submit')}}},[_vm._v(" "+_vm._s(_vm.formSubmitButtonLabel)+" ")]),_c('CustomButton',{staticClass:"abortButton",attrs:{"buttonColor":"cta-link"},nativeOn:{"click":function($event){return _vm.$emit('button:abort')}}},[_vm._v(" "+_vm._s(_vm.formAbortButtonLabel)+" ")])],1)]},proxy:true}],null,true)}):[_c('ResponseTile',{attrs:{"title":_vm.selfServiceLabels.responseTitle,"text":_vm.selfServiceLabels.responseText,"back-button-label":_vm.selfServiceLabels.responseTileBackButtonLabel},on:{"button:back":function($event){return _vm.$emit('button:back')}}})],(_vm.modalCurrentPremium && _vm.selfServiceLabels.currentPremiumSubText)?_c('Modal',{attrs:{"showModal":_vm.showModalProlongationCurrentPremium,"title":_vm.modalCurrentPremium.title,"centeredText":false,"maxWidth":"600","showCloseIcon":true},on:{"closeModal":_vm.closeModalProlongationCurrentPremium},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.modalCurrentPremium.text)}})]},proxy:true}],null,false,1332857722)}):_vm._e()],2)}
var SelfServiceFormvue_type_template_id_33994d64_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/EnterDateCardRow.vue?vue&type=template&id=e1cf3324&scoped=true&
var EnterDateCardRowvue_type_template_id_e1cf3324_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDateOption)?_c('div',{staticClass:"is-styled"},[_c('div',{staticClass:"date-row"},[_c('div',{staticClass:"date-choice"},[_c('div',{staticClass:"date-choice__label"},[_vm._v(" "+_vm._s(_vm.infoLabel)+" ")]),_c('div',{staticClass:"radio"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.radioValue),expression:"radioValue"}],staticClass:"radio__control",attrs:{"type":"radio","id":item.id,"name":"dateRadio","defaultCheckedValue":_vm.items[0].id},domProps:{"value":item.id,"checked":_vm._q(_vm.radioValue,item.id)},on:{"change":[function($event){_vm.radioValue=item.id},_vm.updateDate]}}),_c('label',{staticClass:"date-choice__radio-label radio__label",attrs:{"for":item.id}},[_vm._v(" "+_vm._s(item.label))])])}),0)]),_c('div',{staticClass:"date-input"},[(_vm.isCustomDateModeActive)?_c('DateInput',{attrs:{"id":"dateInput","label":_vm.validFromLabel,"placeholder":"TT.MM.JJJJ","mask":"DD.MM.YYYY","status":_vm.status},on:{"input":function($event){return _vm.emitValue()},"blur":function($event){return _vm.onBlur()}},scopedSlots:_vm._u([{key:"error",fn:function(){return [_vm._v(_vm._s(_vm.getErrorText)+" ")]},proxy:true},(!_vm.isCompleted)?{key:"info",fn:function(){return [_vm._v(_vm._s(_vm.infoText)+" ")]},proxy:true}:null],null,true),model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}}):_vm._e()],1)])]):_vm._e()}
var EnterDateCardRowvue_type_template_id_e1cf3324_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/EnterDateCardRow.vue?vue&type=script&lang=ts&
function EnterDateCardRowvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return EnterDateCardRowvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, EnterDateCardRowvue_type_script_lang_ts_typeof(obj); }

function EnterDateCardRowvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EnterDateCardRowvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function EnterDateCardRowvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) EnterDateCardRowvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) EnterDateCardRowvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function EnterDateCardRowvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) EnterDateCardRowvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function EnterDateCardRowvue_type_script_lang_ts_setPrototypeOf(o, p) { EnterDateCardRowvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return EnterDateCardRowvue_type_script_lang_ts_setPrototypeOf(o, p); }

function EnterDateCardRowvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = EnterDateCardRowvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = EnterDateCardRowvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = EnterDateCardRowvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return EnterDateCardRowvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function EnterDateCardRowvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (EnterDateCardRowvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return EnterDateCardRowvue_type_script_lang_ts_assertThisInitialized(self); }

function EnterDateCardRowvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function EnterDateCardRowvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function EnterDateCardRowvue_type_script_lang_ts_getPrototypeOf(o) { EnterDateCardRowvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return EnterDateCardRowvue_type_script_lang_ts_getPrototypeOf(o); }







dayjs_min_default().extend((customParseFormat_default()));

var EnterDateCardRow = /*#__PURE__*/function (_Vue) {
  EnterDateCardRowvue_type_script_lang_ts_inherits(EnterDateCardRow, _Vue);

  var _super = EnterDateCardRowvue_type_script_lang_ts_createSuper(EnterDateCardRow);

  function EnterDateCardRow() {
    var _this;

    EnterDateCardRowvue_type_script_lang_ts_classCallCheck(this, EnterDateCardRow);

    _this = _super.apply(this, arguments);
    _this.isDirty = false;
    _this.isCustomDateModeActiveToggle = false;
    _this.minDate = dayjs_min_default()().format('DD.MM.YYYY');
    _this.minDateTomorrow = dayjs_min_default()().add(1, 'day').format('DD.MM.YYYY');
    _this.status = InputStatus.DEFAULT; // store current date input

    _this.currentDate = '';
    _this.items = [{
      id: 'now',
      label: _this.fromNowLabel
    }, {
      id: 'beginnDate',
      label: _this.enterDateLabel
    }];
    _this.radioValue = _this.items[0].id;
    return _this;
  }

  EnterDateCardRowvue_type_script_lang_ts_createClass(EnterDateCardRow, [{
    key: "localValue",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      this.currentDate = value;
      this.emitValue();
    }
  }, {
    key: "isCustomDateModeActive",
    get: function get() {
      return this.items[1] ? this.radioValue === this.items[1].id : false;
    }
  }, {
    key: "isCompleted",
    get: function get() {
      return this.currentDate.length === 10;
    }
  }, {
    key: "getErrorText",
    get: function get() {
      if (this.isCompleted) {
        if (this.isDateValidCommon(this.currentDate)) {
          if (this.isDateValidSelfserviceBefore(this.currentDate) && !this.isDateValidSelfserviceAfter(this.currentDate)) {
            return this.errorTextAfter;
          } else if (!this.isDateValidSelfserviceBefore(this.currentDate) && this.isDateValidSelfserviceAfter(this.currentDate)) {
            return this.errorTextBefore;
          } else {
            // no errors
            this.emitValue();
            return '';
          }
        } else {
          // date syntax is wrong / no common valid date
          return this.errorTextSyntax;
        }
      } else {
        // Not completed with 10 chars
        return this.isDirty ? this.errorTextSyntax : '';
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.showDateOption) {
        if (!this.isCustomDateModeActive) {
          this.currentDate = this.minDate;
        }
      } else {
        this.currentDate = this.minDateTomorrow;
      }

      this.updateDate();
    }
  }, {
    key: "isDateValidCommon",
    value: function isDateValidCommon(date) {
      var inputDate = dayjs_min_default()(date, 'DD.MM.YYYY', true);
      return inputDate.isValid();
    } // date should not be before today and after today + one year

  }, {
    key: "isDateValidSelfservice",
    value: function isDateValidSelfservice(date) {
      return this.isDateValidSelfserviceBefore(date) && this.isDateValidSelfserviceAfter(date);
    } // date should not be before today

  }, {
    key: "isDateValidSelfserviceBefore",
    value: function isDateValidSelfserviceBefore(date) {
      var today = dayjs_min_default()();
      var todayMinusOneDay = today.subtract(1, 'day');
      var inputDate = dayjs_min_default()(date, 'DD.MM.YYYY', true);
      return inputDate.isValid() && inputDate.isAfter(todayMinusOneDay, 'date');
    } // date should not be after today + one year

  }, {
    key: "isDateValidSelfserviceAfter",
    value: function isDateValidSelfserviceAfter(date) {
      var today = dayjs_min_default()();
      var todayPlusOneYear = today.add(1, 'year').add(1, 'day');
      var inputDate = dayjs_min_default()(date, 'DD.MM.YYYY', true);
      return inputDate.isValid() && inputDate.isBefore(todayPlusOneYear, 'date');
    }
  }, {
    key: "emitValue",
    value: function emitValue() {
      if (this.isDateValidSelfservice(this.currentDate)) {
        this.status = InputStatus.VALID;
      } else {
        this.status = InputStatus.ERROR;
      }

      this.$emit('input', this.currentDate);
      this.$emit('status', this.status);
    }
  }, {
    key: "updateDate",
    value: function updateDate() {
      if (!this.isCustomDateModeActiveToggle && this.isCustomDateModeActive) {
        // If before click on "now / ab sofort", "enter date" was active then reset date value to todays date
        this.isCustomDateModeActiveToggle = true;
        this.currentDate = '';
        this.emitValue();
        return;
      }

      if (this.isCustomDateModeActiveToggle && !this.isCustomDateModeActive) {
        // If before click on "enter date", "now / ab sofort" was active then reset date value to empty string
        this.isCustomDateModeActiveToggle = false;
        this.currentDate = this.minDate;
        this.emitValue();
        return;
      }

      if (this.showDateOption) {
        if (!this.isCustomDateModeActive && (!this.value || this.value === '')) {
          this.currentDate = this.minDate;
        } else {
          this.currentDate = this.value ? this.value : '';
        }
      } else if (!this.showDateOption) {
        this.currentDate = this.minDateTomorrow;
      }

      this.emitValue(); // When selecting items[1] (enter date mode) no update is required because already localValue === minDate
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.isDirty = true;
    }
  }]);

  return EnterDateCardRow;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  required: false
})], EnterDateCardRow.prototype, "value", void 0);

__decorate([Prop({
  required: false,
  default: ''
})], EnterDateCardRow.prototype, "infoLabel", void 0);

__decorate([Prop({
  required: false,
  default: true
})], EnterDateCardRow.prototype, "showDateOption", void 0);

__decorate([Prop({
  required: false,
  default: 'ab sofort'
})], EnterDateCardRow.prototype, "fromNowLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Datum eingeben'
})], EnterDateCardRow.prototype, "enterDateLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Änderungen gültig ab?'
})], EnterDateCardRow.prototype, "validFromLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Das Datum darf nicht in der Vergangenheit und nicht mehr als 12 Monate in der Zukunft liegen.'
})], EnterDateCardRow.prototype, "infoText", void 0);

__decorate([Prop({
  required: false,
  default: 'Das Datum darf nicht in der Vergangenheit liegen.'
})], EnterDateCardRow.prototype, "errorTextBefore", void 0);

__decorate([Prop({
  required: false,
  default: 'Das Datum darf nicht mehr als 12 Monate in der Zukunft liegen.'
})], EnterDateCardRow.prototype, "errorTextAfter", void 0);

__decorate([Prop({
  required: false,
  default: 'Bitte geben Sie das Datum im Format TT.MM.JJJJ ein.'
})], EnterDateCardRow.prototype, "errorTextSyntax", void 0);

EnterDateCardRow = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    DateInput: input_DateInput
  }
})], EnterDateCardRow);
/* harmony default export */ var EnterDateCardRowvue_type_script_lang_ts_ = (EnterDateCardRow);
;// CONCATENATED MODULE: ./src/components/base/selfServices/EnterDateCardRow.vue?vue&type=script&lang=ts&
 /* harmony default export */ var selfServices_EnterDateCardRowvue_type_script_lang_ts_ = (EnterDateCardRowvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/EnterDateCardRow.vue?vue&type=style&index=0&id=e1cf3324&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/selfServices/EnterDateCardRow.vue?vue&type=style&index=0&id=e1cf3324&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/selfServices/EnterDateCardRow.vue



;


/* normalize component */

var EnterDateCardRow_component = normalizeComponent(
  selfServices_EnterDateCardRowvue_type_script_lang_ts_,
  EnterDateCardRowvue_type_template_id_e1cf3324_scoped_true_render,
  EnterDateCardRowvue_type_template_id_e1cf3324_scoped_true_staticRenderFns,
  false,
  null,
  "e1cf3324",
  null
  
)

/* harmony default export */ var selfServices_EnterDateCardRow = (EnterDateCardRow_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/ResponseTile.vue?vue&type=template&id=71094c69&scoped=true&
var ResponseTilevue_type_template_id_71094c69_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-styled"},[_c('Card',{attrs:{"footerDivider":false,"loadingState":false,"title":_vm.title},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})]},proxy:true}])},[_c('template',{slot:"footer"},[_c('div',{staticClass:"footer-cta footer-cta--left"},[_c('CustomButton',{attrs:{"buttonColor":"cta-link"},nativeOn:{"click":function($event){return _vm.$emit('button:back')}}},[_vm._v(" "+_vm._s(_vm.backButtonLabel)+" ")])],1)])],2)],1)}
var ResponseTilevue_type_template_id_71094c69_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/ResponseTile.vue?vue&type=script&lang=ts&
function ResponseTilevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return ResponseTilevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, ResponseTilevue_type_script_lang_ts_typeof(obj); }

function ResponseTilevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ResponseTilevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) ResponseTilevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) ResponseTilevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ResponseTilevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ResponseTilevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) ResponseTilevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function ResponseTilevue_type_script_lang_ts_setPrototypeOf(o, p) { ResponseTilevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ResponseTilevue_type_script_lang_ts_setPrototypeOf(o, p); }

function ResponseTilevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = ResponseTilevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ResponseTilevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ResponseTilevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ResponseTilevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function ResponseTilevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (ResponseTilevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return ResponseTilevue_type_script_lang_ts_assertThisInitialized(self); }

function ResponseTilevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ResponseTilevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ResponseTilevue_type_script_lang_ts_getPrototypeOf(o) { ResponseTilevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ResponseTilevue_type_script_lang_ts_getPrototypeOf(o); }






var ResponseTile = /*#__PURE__*/function (_Vue) {
  ResponseTilevue_type_script_lang_ts_inherits(ResponseTile, _Vue);

  var _super = ResponseTilevue_type_script_lang_ts_createSuper(ResponseTile);

  function ResponseTile() {
    ResponseTilevue_type_script_lang_ts_classCallCheck(this, ResponseTile);

    return _super.apply(this, arguments);
  }

  return ResponseTilevue_type_script_lang_ts_createClass(ResponseTile);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  required: true
})], ResponseTile.prototype, "title", void 0);

__decorate([Prop({
  required: true
})], ResponseTile.prototype, "text", void 0);

__decorate([Prop({
  required: true
})], ResponseTile.prototype, "backButtonLabel", void 0);

ResponseTile = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    Card: container_Card,
    CustomButton: buttons_CustomButton
  }
})], ResponseTile);
/* harmony default export */ var ResponseTilevue_type_script_lang_ts_ = (ResponseTile);
;// CONCATENATED MODULE: ./src/components/base/selfServices/ResponseTile.vue?vue&type=script&lang=ts&
 /* harmony default export */ var selfServices_ResponseTilevue_type_script_lang_ts_ = (ResponseTilevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/ResponseTile.vue?vue&type=style&index=0&id=71094c69&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/selfServices/ResponseTile.vue?vue&type=style&index=0&id=71094c69&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/selfServices/ResponseTile.vue



;


/* normalize component */

var ResponseTile_component = normalizeComponent(
  selfServices_ResponseTilevue_type_script_lang_ts_,
  ResponseTilevue_type_template_id_71094c69_scoped_true_render,
  ResponseTilevue_type_template_id_71094c69_scoped_true_staticRenderFns,
  false,
  null,
  "71094c69",
  null
  
)

/* harmony default export */ var selfServices_ResponseTile = (ResponseTile_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/SelfServiceForm.vue?vue&type=script&lang=ts&
function SelfServiceFormvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return SelfServiceFormvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, SelfServiceFormvue_type_script_lang_ts_typeof(obj); }

function SelfServiceFormvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SelfServiceFormvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SelfServiceFormvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) SelfServiceFormvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) SelfServiceFormvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function SelfServiceFormvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) SelfServiceFormvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function SelfServiceFormvue_type_script_lang_ts_setPrototypeOf(o, p) { SelfServiceFormvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SelfServiceFormvue_type_script_lang_ts_setPrototypeOf(o, p); }

function SelfServiceFormvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = SelfServiceFormvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SelfServiceFormvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SelfServiceFormvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SelfServiceFormvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function SelfServiceFormvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (SelfServiceFormvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return SelfServiceFormvue_type_script_lang_ts_assertThisInitialized(self); }

function SelfServiceFormvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SelfServiceFormvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SelfServiceFormvue_type_script_lang_ts_getPrototypeOf(o) { SelfServiceFormvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SelfServiceFormvue_type_script_lang_ts_getPrototypeOf(o); }












var SelfServiceForm = /*#__PURE__*/function (_Vue) {
  SelfServiceFormvue_type_script_lang_ts_inherits(SelfServiceForm, _Vue);

  var _super = SelfServiceFormvue_type_script_lang_ts_createSuper(SelfServiceForm);

  function SelfServiceForm() {
    var _this;

    SelfServiceFormvue_type_script_lang_ts_classCallCheck(this, SelfServiceForm);

    _this = _super.apply(this, arguments);
    _this.dateInputStatus = InputStatus.DEFAULT;
    _this.warning = AlertStatus.WARNING;
    _this.formSubmitButtonLabel = '';
    _this.formAbortButtonLabel = '';
    _this.formHintLabelTitle = '';
    _this.formHintLabel = '';
    _this.showModalProlongationCurrentPremium = false;
    return _this;
  }

  SelfServiceFormvue_type_script_lang_ts_createClass(SelfServiceForm, [{
    key: "updated",
    value: function updated() {
      this.checkDefaultLabels();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.checkDefaultLabels();
    }
  }, {
    key: "setDateInputStatus",
    value: function setDateInputStatus(inputStatus) {
      this.dateInputStatus = inputStatus;
    }
  }, {
    key: "onDateInputValueChanged",
    value: function onDateInputValueChanged(inputValue) {
      this.$emit('input', inputValue);
    }
  }, {
    key: "isDateAndFormInvalid",
    get: function get() {
      return this.isSubmitButtonDisabled || this.dateInputStatus !== InputStatus.VALID;
    }
  }, {
    key: "closeModalProlongationCurrentPremium",
    value: function closeModalProlongationCurrentPremium() {
      this.showModalProlongationCurrentPremium = false;
    }
  }, {
    key: "openModalProlongationCurrentPremium",
    value: function openModalProlongationCurrentPremium() {
      this.showModalProlongationCurrentPremium = true;
    }
  }, {
    key: "checkDefaultLabels",
    value: function checkDefaultLabels() {
      if (this.selfServiceLabels.formSubmitButtonLabel === undefined || this.selfServiceLabels.formSubmitButtonLabel === '') {
        this.formSubmitButtonLabel = 'Änderung beauftragen';
      } else {
        this.formSubmitButtonLabel = this.selfServiceLabels.formSubmitButtonLabel;
      }

      if (this.selfServiceLabels.formAbortButtonLabel === undefined || this.selfServiceLabels.formAbortButtonLabel === '') {
        this.formAbortButtonLabel = 'Abbrechen';
      } else {
        this.formAbortButtonLabel = this.selfServiceLabels.formAbortButtonLabel;
      }

      if (this.selfServiceLabels.formHintLabelTitle === undefined || this.selfServiceLabels.formHintLabelTitle === '') {
        this.formHintLabelTitle = 'Sind Ihre Angaben richtig?';
      } else {
        this.formHintLabelTitle = this.selfServiceLabels.formHintLabelTitle;
      }

      if (this.selfServiceLabels.formHintLabel === undefined || this.selfServiceLabels.formHintLabel === '') {
        this.formHintLabel = 'Bitte prüfen Sie Ihre Daten und beauftragen Sie die Änderung.';
      } else {
        this.formHintLabel = this.selfServiceLabels.formHintLabel;
      }
    }
  }, {
    key: "localStartDate",
    get: function get() {
      return this.value;
    },
    set: function set(val) {
      this.$emit('input', val);
    }
  }]);

  return SelfServiceForm;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  required: true
})], SelfServiceForm.prototype, "selfServiceLabels", void 0);

__decorate([Prop({})], SelfServiceForm.prototype, "formBlocks", void 0);

__decorate([Prop({
  default: false
})], SelfServiceForm.prototype, "showResponse", void 0);

__decorate([Prop({
  default: false
})], SelfServiceForm.prototype, "isLoading", void 0);

__decorate([Prop({
  default: false
})], SelfServiceForm.prototype, "isSubmitting", void 0);

__decorate([Prop({
  default: false
})], SelfServiceForm.prototype, "isSubmitButtonDisabled", void 0);

__decorate([Prop({
  required: false,
  default: ''
})], SelfServiceForm.prototype, "value", void 0);

__decorate([Prop({
  required: false,
  default: true
})], SelfServiceForm.prototype, "showDateOption", void 0);

__decorate([Prop({
  required: false,
  default: ''
})], SelfServiceForm.prototype, "tileSpecificIconIdentifier", void 0);

__decorate([Prop({
  required: false,
  default: ''
})], SelfServiceForm.prototype, "firstTitle", void 0);

__decorate([Prop({
  required: false
})], SelfServiceForm.prototype, "modalCurrentPremium", void 0);

SelfServiceForm = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    Alert: container_Alert,
    Card: container_Card,
    EnterDateCardRow: selfServices_EnterDateCardRow,
    ResponseTile: selfServices_ResponseTile,
    CustomButton: buttons_CustomButton
  },
  mixins: [responsiveClassMixin]
})], SelfServiceForm);
/* harmony default export */ var SelfServiceFormvue_type_script_lang_ts_ = (SelfServiceForm);
;// CONCATENATED MODULE: ./src/components/base/selfServices/SelfServiceForm.vue?vue&type=script&lang=ts&
 /* harmony default export */ var selfServices_SelfServiceFormvue_type_script_lang_ts_ = (SelfServiceFormvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/SelfServiceForm.vue?vue&type=style&index=0&id=33994d64&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/selfServices/SelfServiceForm.vue?vue&type=style&index=0&id=33994d64&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/base/selfServices/SelfServiceForm.vue



;


/* normalize component */

var SelfServiceForm_component = normalizeComponent(
  selfServices_SelfServiceFormvue_type_script_lang_ts_,
  SelfServiceFormvue_type_template_id_33994d64_scoped_true_render,
  SelfServiceFormvue_type_template_id_33994d64_scoped_true_staticRenderFns,
  false,
  null,
  "33994d64",
  null
  
)

/* harmony default export */ var selfServices_SelfServiceForm = (SelfServiceForm_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/AddressInput.vue?vue&type=template&id=559cda06&scoped=true&
var AddressInputvue_type_template_id_559cda06_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address-input is-styled"},[_c('div',{staticClass:"address-row"},[_c('BasicTextfield',{staticClass:"address-number",attrs:{"label":_vm.postCodeLabel,"required":true,"status":_vm.postCodeStatus},on:{"update:input":_vm.validatePostCode,"update:error":_vm.validatePostCode,"update:cleared":_vm.validatePostCode,"input":_vm.validatePostCode},scopedSlots:_vm._u([{key:"info",fn:function(){return [_vm._v(_vm._s(_vm.postCodeInfo))]},proxy:true}]),model:{value:(_vm.value.postCode),callback:function ($$v) {_vm.$set(_vm.value, "postCode", $$v)},expression:"value.postCode"}}),_c('BasicTextfield',{staticClass:"address-text",attrs:{"label":_vm.cityLabel,"required":true,"status":_vm.cityStatus},on:{"update:input":_vm.validateCity,"update:error":_vm.validateCity,"update:cleared":_vm.validateCity,"input":_vm.validateCity},scopedSlots:_vm._u([{key:"info",fn:function(){return [_vm._v(_vm._s(_vm.cityInfo))]},proxy:true}]),model:{value:(_vm.value.city),callback:function ($$v) {_vm.$set(_vm.value, "city", $$v)},expression:"value.city"}})],1),_c('div',{staticClass:"address-row"},[(_vm.postalServiceAvailable)?_c('SelectMenue',{staticClass:"address-text street-dropdown",attrs:{"label":_vm.streetLabel,"options":_vm.streetOptions,"defaultValue":_vm.value.street,"loading":_vm.streetLoading,"status":_vm.streetStatus,"searchable":true,"selectOnTab":true,"noResultsFoundText":_vm.selectMenueNoResultsLabel,"startTypingForSearchText":_vm.selectMenueHint},on:{"update:error":_vm.validateStreet,"update:input":_vm.validateStreet,"update:cleared":_vm.validateStreet,"search":_vm.searchStreet},scopedSlots:_vm._u([{key:"error",fn:function(){return [_vm._v(_vm._s(_vm.selectMenueError))]},proxy:true}],null,false,1508476590),model:{value:(_vm.value.street),callback:function ($$v) {_vm.$set(_vm.value, "street", $$v)},expression:"value.street"}}):_c('BasicTextfield',{staticClass:"address-text",attrs:{"label":_vm.streetLabel,"required":true,"status":_vm.streetStatus},on:{"update:input":_vm.validateStreet,"update:error":_vm.validateStreet,"update:cleared":_vm.validateStreet,"input":_vm.validateStreet},scopedSlots:_vm._u([{key:"info",fn:function(){return [_vm._v(_vm._s(_vm.streetInfo))]},proxy:true}]),model:{value:(_vm.value.street),callback:function ($$v) {_vm.$set(_vm.value, "street", $$v)},expression:"value.street"}}),_c('BasicTextfield',{staticClass:"address-number",attrs:{"label":_vm.streetNumberLabel,"required":true,"status":_vm.streetNumberStatus},on:{"update:input":_vm.validateStreetNumber,"update:error":_vm.validateStreetNumber,"update:cleared":_vm.validateStreetNumber,"input":_vm.validateStreetNumber},scopedSlots:_vm._u([{key:"info",fn:function(){return [_vm._v(_vm._s(_vm.streetNumberInfo))]},proxy:true}]),model:{value:(_vm.value.streetNumber),callback:function ($$v) {_vm.$set(_vm.value, "streetNumber", $$v)},expression:"value.streetNumber"}})],1),_c('div',{staticClass:"address-row"},[_c('BasicTextfield',{staticClass:"address-extra",attrs:{"label":_vm.streetExtraLabel,"required":false},on:{"update:input":_vm.validateStreetExtra,"update:error":_vm.validateStreetExtra,"update:cleared":_vm.validateStreetExtra,"input":_vm.validateStreetExtra},scopedSlots:_vm._u([{key:"info",fn:function(){return [_vm._v(_vm._s(_vm.streetExtraInfo))]},proxy:true}]),model:{value:(_vm.value.streetExtra),callback:function ($$v) {_vm.$set(_vm.value, "streetExtra", $$v)},expression:"value.streetExtra"}})],1)])}
var AddressInputvue_type_template_id_559cda06_scoped_true_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/AddressInput.vue?vue&type=script&lang=ts&
function AddressInputvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return AddressInputvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, AddressInputvue_type_script_lang_ts_typeof(obj); }

function AddressInputvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AddressInputvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AddressInputvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) AddressInputvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) AddressInputvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function AddressInputvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) AddressInputvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function AddressInputvue_type_script_lang_ts_setPrototypeOf(o, p) { AddressInputvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AddressInputvue_type_script_lang_ts_setPrototypeOf(o, p); }

function AddressInputvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = AddressInputvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = AddressInputvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = AddressInputvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return AddressInputvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function AddressInputvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (AddressInputvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return AddressInputvue_type_script_lang_ts_assertThisInitialized(self); }

function AddressInputvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function AddressInputvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function AddressInputvue_type_script_lang_ts_getPrototypeOf(o) { AddressInputvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AddressInputvue_type_script_lang_ts_getPrototypeOf(o); }








var AddressInput = /*#__PURE__*/function (_Vue) {
  AddressInputvue_type_script_lang_ts_inherits(AddressInput, _Vue);

  var _super = AddressInputvue_type_script_lang_ts_createSuper(AddressInput);

  function AddressInput() {
    var _this;

    AddressInputvue_type_script_lang_ts_classCallCheck(this, AddressInput);

    _this = _super.apply(this, arguments); // switch between postal service and manual input

    _this.postalServiceAvailable = true; // validation status

    _this.postCodeStatus = InputStatus.DEFAULT;
    _this.cityStatus = InputStatus.DEFAULT;
    _this.streetStatus = InputStatus.DEFAULT;
    _this.streetNumberStatus = InputStatus.DEFAULT; // street dropdown

    _this.streetOptions = [];
    _this.streetLoading = false;
    return _this;
  } // validation


  AddressInputvue_type_script_lang_ts_createClass(AddressInput, [{
    key: "validateStreetExtra",
    value: function validateStreetExtra() {
      this.value.streetExtra = this.value.streetExtra.trimStart().replace(/[_!¡÷?¿+=@#$%ˆ&*(){}|~<>;:"[\]]/g, '');
      this.value.streetExtra = this.value.streetExtra.substring(0, 100);
    }
  }, {
    key: "validateStreet",
    value: function validateStreet() {
      this.value.street = this.value.street.trimStart().replace(/[_!¡÷?¿+=@#$%ˆ&*(){}|~<>;:"[\]]/g, '');
      this.value.street = this.value.street.substring(0, 100);
      this.streetStatus = this.value.street.length > 0 ? InputStatus.VALID : InputStatus.DEFAULT;
    }
  }, {
    key: "validateStreetNumber",
    value: function validateStreetNumber() {
      this.value.streetNumber = this.value.streetNumber.replace(/[^0-9A-Za-z]/g, '').trim();
      this.value.streetNumber = this.value.streetNumber.substring(0, 30);
      this.streetNumberStatus = this.value.streetNumber.length > 0 ? InputStatus.VALID : InputStatus.ERROR;
    }
  }, {
    key: "validateCity",
    value: function validateCity() {
      this.value.city = this.value.city.trimStart().replace(/[_!¡÷?¿+=@#$%ˆ&*{}|~<>;:"[\]]/g, '');
      this.value.city = this.value.city.substring(0, 100);
      this.cityStatus = this.value.city.length > 0 ? InputStatus.VALID : InputStatus.ERROR;
    }
  }, {
    key: "validatePostCode",
    value: function validatePostCode() {
      var _this2 = this;

      this.value.postCode = this.value.postCode.replace(/\D/, '');
      this.value.postCode = this.value.postCode.substring(0, 5);

      if (this.value.postCode.length !== 5) {
        this.postCodeStatus = InputStatus.ERROR;
        return;
      }

      axios_default().get(this.postalServiceUrl + '/v1/cities/code', {
        headers: {
          KeyId: this.postalServiceUrlApiKey
        },
        params: {
          postalcode: this.value.postCode
        }
      }).then(function (response) {
        var newCity = response.data;

        if (newCity.length > 0) {
          _this2.value.city = newCity[0];
          _this2.postCodeStatus = InputStatus.VALID;
        } else {
          _this2.value.city = '';
          _this2.postCodeStatus = InputStatus.ERROR;
        }

        _this2.validateCity();

        _this2.streetOptions = [];
        _this2.postalServiceAvailable = true;
      }).catch(function (_error) {
        _this2.postCodeStatus = InputStatus.VALID;
        _this2.value.city = '';
        _this2.value.street = '';
        _this2.value.streetNumber = '';

        _this2.validateCity();

        _this2.validateStreet();

        _this2.validateStreetNumber();

        _this2.postalServiceAvailable = false;
      });
    }
  }, {
    key: "updateInputStatus",
    value: function updateInputStatus() {
      var allStatus = [this.postCodeStatus, this.cityStatus, this.streetStatus, this.streetNumberStatus];
      var allValid = allStatus.every(function (value) {
        return value === InputStatus.VALID;
      });
      var currentInputStatus = allValid ? InputStatus.VALID : InputStatus.ERROR;
      this.$emit('input:status', currentInputStatus);
    }
  }, {
    key: "searchStreet",
    value: function searchStreet(search, loading) {
      var _this3 = this;

      if (search.length >= 3) {
        loading(true);
        this.streetLoading = true;
        axios_default().get(this.postalServiceUrl + '/v1/streets', {
          headers: {
            KeyId: this.postalServiceUrlApiKey
          },
          params: {
            postalcode: this.value.postCode,
            name: search,
            num_results: 5
          }
        }).then(function (response) {
          _this3.streetOptions = response.data;
        }).catch(function (_error) {
          _this3.postalServiceAvailable = false;
          _this3.value.street = '';
          _this3.value.streetNumber = '';

          _this3.validateStreet();

          _this3.validateStreetNumber();

          _this3.streetOptions = [];
        }).finally(function () {
          loading(false);
          _this3.streetLoading = false;
        });
      } else {
        this.streetOptions = [];
      }
    }
  }]);

  return AddressInput;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: function _default() {
    return {
      city: '',
      postCode: '',
      street: '',
      streetExtra: '',
      streetNumber: ''
    };
  }
})], AddressInput.prototype, "value", void 0);

__decorate([Prop({
  required: true
})], AddressInput.prototype, "postalServiceUrl", void 0);

__decorate([Prop({
  required: true
})], AddressInput.prototype, "postalServiceUrlApiKey", void 0);

__decorate([Prop({
  required: false,
  default: 'Neue PLZ'
})], AddressInput.prototype, "postCodeLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Bitte geben Sie die PLZ ein.'
})], AddressInput.prototype, "postCodeInfo", void 0);

__decorate([Prop({
  required: false,
  default: 'Neuer Ort'
})], AddressInput.prototype, "cityLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Bitte geben Sie den neuen Ort ein.'
})], AddressInput.prototype, "cityInfo", void 0);

__decorate([Prop({
  required: false,
  default: 'Neue Straße'
})], AddressInput.prototype, "streetLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Bitte geben Sie Ihre neue Straße ein.'
})], AddressInput.prototype, "streetInfo", void 0);

__decorate([Prop({
  required: false,
  default: 'Nr.'
})], AddressInput.prototype, "streetNumberLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Bitte geben Sie die neue Hausnummer ein.'
})], AddressInput.prototype, "streetNumberInfo", void 0);

__decorate([Prop({
  required: false,
  default: 'Adresszusatz (optional)'
})], AddressInput.prototype, "streetExtraLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Hier können Sie weitere Informationen zu Ihrer Adresse hinterlegen.'
})], AddressInput.prototype, "streetExtraInfo", void 0);

__decorate([Prop({
  required: false,
  default: 'Keine Ergebnisse gefunden für '
})], AddressInput.prototype, "selectMenueNoResultsLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Tippen Sie 3 Zeichen für Vorschläge'
})], AddressInput.prototype, "selectMenueHint", void 0);

__decorate([Prop({
  required: false,
  default: 'Tippen Sie mindestens 3 Zeichen'
})], AddressInput.prototype, "selectMenueError", void 0);

__decorate([Watch('postCodeStatus'), Watch('cityStatus'), Watch('streetStatus'), Watch('streetNumberStatus')], AddressInput.prototype, "updateInputStatus", null);

AddressInput = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    BasicTextfield: input_BasicTextfield,
    SelectMenue: input_SelectMenue
  }
})], AddressInput);
/* harmony default export */ var AddressInputvue_type_script_lang_ts_ = (AddressInput);
;// CONCATENATED MODULE: ./src/components/base/selfServices/AddressInput.vue?vue&type=script&lang=ts&
 /* harmony default export */ var selfServices_AddressInputvue_type_script_lang_ts_ = (AddressInputvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/AddressInput.vue?vue&type=style&index=0&id=559cda06&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/selfServices/AddressInput.vue?vue&type=style&index=0&id=559cda06&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/selfServices/AddressInput.vue



;


/* normalize component */

var AddressInput_component = normalizeComponent(
  selfServices_AddressInputvue_type_script_lang_ts_,
  AddressInputvue_type_template_id_559cda06_scoped_true_render,
  AddressInputvue_type_template_id_559cda06_scoped_true_staticRenderFns,
  false,
  null,
  "559cda06",
  null
  
)

/* harmony default export */ var selfServices_AddressInput = (AddressInput_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/NameInput.vue?vue&type=template&id=520053b9&scoped=true&
var NameInputvue_type_template_id_520053b9_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name-input is-styled"},[_c('div',{staticClass:"name-row"},[(_vm.enableSalutation)?_c('SelectMenue',{staticClass:"name-select",attrs:{"label":_vm.salutationLabel,"options":_vm.salutationOptions,"defaultValue":_vm.value.salutation},scopedSlots:_vm._u([{key:"info",fn:function(){return [_vm._v(_vm._s(_vm.salutationLabel))]},proxy:true}],null,false,1538083450),model:{value:(_vm.value.salutation),callback:function ($$v) {_vm.$set(_vm.value, "salutation", $$v)},expression:"value.salutation"}}):_vm._e(),_c('SelectMenue',{staticClass:"name-select",attrs:{"label":_vm.titleLabel,"options":_vm.titleOptions,"defaultValue":_vm.value.title},scopedSlots:_vm._u([{key:"info",fn:function(){return [_vm._v(_vm._s(_vm.titleLabel))]},proxy:true}]),model:{value:(_vm.value.title),callback:function ($$v) {_vm.$set(_vm.value, "title", $$v)},expression:"value.title"}}),(_vm.enableFirstName)?_c('BasicTextfield',{staticClass:"name-text",attrs:{"id":"firstName","label":_vm.firstNameLabel,"required":true,"status":_vm.firstNameStatus},on:{"update:input":_vm.validateFirstName,"update:error":_vm.validateFirstName,"update:cleared":_vm.validateFirstName,"input":_vm.validateFirstName},scopedSlots:_vm._u([(_vm.hasFirstNameError)?{key:"error",fn:function(){return [_vm._v(_vm._s(_vm.firstNameInfo))]},proxy:true}:{key:"info",fn:function(){return [_vm._v(_vm._s(_vm.firstNameInfo))]},proxy:true}],null,true),model:{value:(_vm.value.firstName),callback:function ($$v) {_vm.$set(_vm.value, "firstName", $$v)},expression:"value.firstName"}}):_vm._e(),_c('BasicTextfield',{staticClass:"name-text",attrs:{"id":"name","label":_vm.nameLabel,"required":true,"status":_vm.nameStatus},on:{"update:input":_vm.validateName,"update:error":_vm.validateName,"update:cleared":_vm.validateName,"input":_vm.validateName},scopedSlots:_vm._u([(_vm.hasNameError)?{key:"error",fn:function(){return [_vm._v(_vm._s(_vm.nameInfo))]},proxy:true}:{key:"info",fn:function(){return [_vm._v(_vm._s(_vm.nameInfo))]},proxy:true}],null,true),model:{value:(_vm.value.name),callback:function ($$v) {_vm.$set(_vm.value, "name", $$v)},expression:"value.name"}})],1)])}
var NameInputvue_type_template_id_520053b9_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/NameInput.vue?vue&type=script&lang=ts&
function NameInputvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return NameInputvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, NameInputvue_type_script_lang_ts_typeof(obj); }

function NameInputvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NameInputvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function NameInputvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) NameInputvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) NameInputvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function NameInputvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) NameInputvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function NameInputvue_type_script_lang_ts_setPrototypeOf(o, p) { NameInputvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return NameInputvue_type_script_lang_ts_setPrototypeOf(o, p); }

function NameInputvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = NameInputvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = NameInputvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = NameInputvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return NameInputvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function NameInputvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (NameInputvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return NameInputvue_type_script_lang_ts_assertThisInitialized(self); }

function NameInputvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function NameInputvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function NameInputvue_type_script_lang_ts_getPrototypeOf(o) { NameInputvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return NameInputvue_type_script_lang_ts_getPrototypeOf(o); }







var NameInput = /*#__PURE__*/function (_Vue) {
  NameInputvue_type_script_lang_ts_inherits(NameInput, _Vue);

  var _super = NameInputvue_type_script_lang_ts_createSuper(NameInput);

  function NameInput() {
    var _this;

    NameInputvue_type_script_lang_ts_classCallCheck(this, NameInput);

    _this = _super.apply(this, arguments); // dropdowns

    _this.salutationOptions = ['Frau', 'Herr'];
    _this.titleOptions = ['kein Titel', 'Dr.', 'Dr. dent.', 'Dipl.Ing.', 'Dr. Dr.', 'Dr. h.c.', 'Dr. jur.', 'Dr. med.', 'Dr. phil.', 'Dr. vet.', 'Mag.', 'Prof. Dr.', 'Professor']; // validation status

    _this.nameStatus = InputStatus.DEFAULT;
    _this.firstNameStatus = InputStatus.DEFAULT;
    return _this;
  }

  NameInputvue_type_script_lang_ts_createClass(NameInput, [{
    key: "created",
    value: function created() {
      if (!this.value.salutation) this.value.salutation = '';
      if (!this.value.title) this.value.title = 'kein Titel';
      if (!this.value.name) this.value.name = '';
      if (!this.value.firstName) this.value.firstName = '';
    } // validation

  }, {
    key: "validateName",
    value: function validateName() {
      this.value.name = this.value.name.trimStart().replace(/[_!¡÷?¿+=@#$%ˆ&*(){}|~<>;:"[\]]/g, '');
      this.value.name = this.value.name.substring(0, 100);
      this.nameStatus = this.value.name.length > 0 ? InputStatus.VALID : InputStatus.ERROR;
    }
  }, {
    key: "validateFirstName",
    value: function validateFirstName() {
      this.value.firstName = this.value.firstName.trimStart().replace(/[_!¡÷?¿+=@#$%ˆ&*(){}|~<>;:"[\]]/g, '');
      this.value.firstName = this.value.firstName.substring(0, 100);
      this.firstNameStatus = this.value.firstName.length > 0 ? InputStatus.VALID : InputStatus.ERROR;
    }
  }, {
    key: "hasNameError",
    get: function get() {
      return this.nameStatus === InputStatus.ERROR;
    }
  }, {
    key: "hasFirstNameError",
    get: function get() {
      return this.firstNameStatus === InputStatus.ERROR;
    }
  }, {
    key: "updateInputStatus",
    value: function updateInputStatus() {
      var firstNameInputValid = this.firstNameStatus === InputStatus.VALID;
      var nameInputValid = this.nameStatus === InputStatus.VALID;
      var areAllInputsValid = this.enableFirstName ? nameInputValid && firstNameInputValid : nameInputValid;
      var inputStatus = areAllInputsValid ? InputStatus.VALID : InputStatus.ERROR;
      this.$emit('input', inputStatus);
    }
  }]);

  return NameInput;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: function _default() {
    return {
      salutation: '',
      title: 'kein Titel',
      firstName: '',
      name: ''
    };
  }
})], NameInput.prototype, "value", void 0);

__decorate([Prop({
  required: false,
  default: true
})], NameInput.prototype, "enableSalutation", void 0);

__decorate([Prop({
  required: false,
  default: true
})], NameInput.prototype, "enableFirstName", void 0);

__decorate([Prop({
  required: false,
  default: 'Anrede'
})], NameInput.prototype, "salutationLabel", void 0);

__decorate([Prop({
  required: false,
  default: ''
})], NameInput.prototype, "salutationInfo", void 0);

__decorate([Prop({
  required: false,
  default: 'Anrede'
})], NameInput.prototype, "salutationPlaceholder", void 0);

__decorate([Prop({
  required: false,
  default: 'Titel'
})], NameInput.prototype, "titleLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'bitte auswählen'
})], NameInput.prototype, "titlePlaceholder", void 0);

__decorate([Prop({
  required: false,
  default: 'Vorname'
})], NameInput.prototype, "firstNameLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Bitte geben Sie Ihre Vornamen ein.'
})], NameInput.prototype, "firstNameInfo", void 0);

__decorate([Prop({
  required: false,
  default: 'Nachname'
})], NameInput.prototype, "nameLabel", void 0);

__decorate([Prop({
  required: false,
  default: 'Bitte geben Sie Ihren neuen Nachnamen ein.'
})], NameInput.prototype, "nameInfo", void 0);

__decorate([Watch('firstNameStatus'), Watch('nameStatus')], NameInput.prototype, "updateInputStatus", null);

NameInput = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    BasicTextfield: input_BasicTextfield,
    SelectMenue: input_SelectMenue
  }
})], NameInput);
/* harmony default export */ var NameInputvue_type_script_lang_ts_ = (NameInput);
;// CONCATENATED MODULE: ./src/components/base/selfServices/NameInput.vue?vue&type=script&lang=ts&
 /* harmony default export */ var selfServices_NameInputvue_type_script_lang_ts_ = (NameInputvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/NameInput.vue?vue&type=style&index=0&id=520053b9&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/selfServices/NameInput.vue?vue&type=style&index=0&id=520053b9&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/selfServices/NameInput.vue



;


/* normalize component */

var NameInput_component = normalizeComponent(
  selfServices_NameInputvue_type_script_lang_ts_,
  NameInputvue_type_template_id_520053b9_scoped_true_render,
  NameInputvue_type_template_id_520053b9_scoped_true_staticRenderFns,
  false,
  null,
  "520053b9",
  null
  
)

/* harmony default export */ var selfServices_NameInput = (NameInput_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/SelectablePolicyTile.vue?vue&type=template&id=5a171502&scoped=true&
var SelectablePolicyTilevue_type_template_id_5a171502_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-styled"},[(_vm.isSelectAllTile)?_c('Card',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"card-row policySelectCollapser"},[_c('Checkbox',{attrs:{"value":_vm.selected},on:{"input":_vm.emitCheckedValue},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"policySelect-label"},[_c('div',{staticClass:"icon-package policySelect-icon"}),_c('div',{staticClass:"policySelect-labelText"},[_vm._v(" "+_vm._s(_vm.locale.common.allContracts)+" ")])])]},proxy:true}],null,false,4229618960)})],1)]},proxy:true}],null,false,449186461)}):_vm._e(),(!_vm.isSelectAllTile)?_c('Card',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"card-row policySelectCollapser"},[_c('div',{staticClass:"policy-selector"},[_c('Checkbox',{staticClass:"policy-checkbox",attrs:{"value":_vm.selected},on:{"input":_vm.emitCheckedValue},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"policySelect-label"},[_c('span',{staticClass:"policy-icon policySelect-icon",class:_vm.getPolicyIcon(_vm.policy)}),_c('div',{staticClass:"policy-label text-bold policySelect-labelText"},[_vm._v(" "+_vm._s(_vm.getPolicyTitle(_vm.policy))+" ")]),_c('div',{staticClass:"text-normal policySelect-labelSubText",domProps:{"innerHTML":_vm._s(_vm.policy.secondTitle || _vm.policy.policyLabel)}})])]},proxy:true}],null,false,2619459674)})],1),_c('button',{staticClass:"toggler icon",attrs:{"aria-expanded":_vm.isExpanded ? 'true' : 'false',"aria-controls":_vm.id},on:{"click":_vm.toggleExpansion}},[_c('span',{staticClass:"toggler__icon",class:[{ 'icon-circle-minus': _vm.isExpanded }, { 'icon-circle-plus': !_vm.isExpanded }]})])]),_c('div',{staticClass:"card-row policySelectCollapser__block",class:{ 'policySelectCollapser__block--show': _vm.isExpanded }},[_c('DataBox',{staticClass:"data-background",attrs:{"data":_vm.dataBoxData}})],1)]},proxy:true}],null,false,1680006465)}):_vm._e()],1)}
var SelectablePolicyTilevue_type_template_id_5a171502_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/types/DDSLines.ts
var DDSLines;

(function (DDSLines) {
  DDSLines[DDSLines["Motor"] = 0] = "Motor";
  DDSLines[DDSLines["Glass"] = 1] = "Glass";
  DDSLines[DDSLines["Household"] = 2] = "Household";
  DDSLines[DDSLines["Building"] = 3] = "Building";
  DDSLines[DDSLines["Accident"] = 4] = "Accident";
  DDSLines[DDSLines["Liability"] = 5] = "Liability";
  DDSLines[DDSLines["FireIndustry"] = 6] = "FireIndustry";
  DDSLines[DDSLines["Transport"] = 7] = "Transport";
  DDSLines[DDSLines["TechInsurance"] = 8] = "TechInsurance";
  DDSLines[DDSLines["LegalProtection"] = 9] = "LegalProtection";
  DDSLines[DDSLines["Life"] = 10] = "Life";
  DDSLines[DDSLines["IncidentalCosts"] = 11] = "IncidentalCosts";
  DDSLines[DDSLines["Investment"] = 12] = "Investment";
  DDSLines[DDSLines["Health"] = 13] = "Health";
  DDSLines[DDSLines["BuildingSaving"] = 14] = "BuildingSaving";
  DDSLines[DDSLines["CapitalInvestment"] = 15] = "CapitalInvestment";
  DDSLines[DDSLines["ExternalContract"] = 16] = "ExternalContract";
  DDSLines[DDSLines["BundledProperty"] = 17] = "BundledProperty";
})(DDSLines || (DDSLines = {}));
;// CONCATENATED MODULE: ./src/locale/selfServices/DDSLines.locale.json
var DDSLines_locale_namespaceObject = JSON.parse('{"Motor":"Kfz-Versicherung","Glass":"Glas-Versicherung","Household":"Hausrat-Versicherung","Building":"Verbundene-Gebäude-Versicherung","Accident":"Unfall-Versicherung","Liability":"Haftpflicht-Versicherung","FireIndustry":"Feuer-Industrie-Versicherung","Transport":"Transport-Versicherung","TechInsurance":"Technische Versicherung","LegalProtection":"Rechtsschutz-Versicherung","Life":"Lebensversicherung","IncidentalCosts":"Schutzbrief-Versicherung","Investment":"Investment-Versicherung","Health":"Krankenversicherung","BuildingSaving":"Bausparversicherung","CapitalInvestment":"Kapitalanlageversicherung","ExternalContract":"Fremdvertrag-Versicherung","BundledProperty":"Versicherungspaket","TestLongInsurance":"Private Personen- und/oder Sachversicherung"}');
;// CONCATENATED MODULE: ./src/components/Misc.ts


function getTranslatedDDSLine(ddsLine) {
  return DDSLines_locale_namespaceObject[ddsLine];
}
function isMotorContract(policy) {
  return policy.ddsLines.length > 0 && policy.ddsLines[0] === DDSLines[DDSLines.Motor];
}
var emptySelfServiceLabels = {
  listHeadline: '',
  formCardTitle: '',
  formCurrentDataLabel: '',
  formCurrentDataValue: '',
  formDateLabel: '',
  responseText: '',
  responseTitle: '',
  responseTileBackButtonLabel: '',
  formDateErrorText: '',
  errorTitle: '',
  errorText: ''
};
function getEmptyNewAddressData() {
  return {
    postCode: '',
    city: '',
    street: '',
    streetNumber: '',
    streetExtra: ''
  };
}
function getEmptyNewNameData() {
  return {
    salutation: '',
    title: '',
    firstName: '',
    name: ''
  };
}
function getEmptyPolicy() {
  var policy = {
    policyId: '',
    policyNumber: '',
    insuranceCompanyCode: '',
    policyStatus: '',
    policyLines: [],
    ddsLines: [],
    paymentData: {
      paymentMethod: '',
      paymentPeriod: '',
      paymentProcedure: {
        cardHolderName: '',
        iban: '',
        routingNumber: ''
      },
      grossPremiumBasedOnPaymentPeriod: {
        amount: 0,
        currency: ''
      }
    },
    policyLabel: '',
    beginningDatePolicy: '',
    expiryDatePolicy: '',
    modificationDatePolicy: '',
    partnerAddressIDVN: ''
  };
  return policy;
}
;// CONCATENATED MODULE: ./src/locale/selfServices/SelectablePolicyTile.locale.json
var SelectablePolicyTile_locale_namespaceObject = JSON.parse('{"common":{"allContracts":"Alle Verträge","vsnr":"Versicherungsnummer","licensePlate":"Kfz-Kennzeichen"}}');
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/SelectablePolicyTile.vue?vue&type=script&lang=ts&
function SelectablePolicyTilevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return SelectablePolicyTilevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, SelectablePolicyTilevue_type_script_lang_ts_typeof(obj); }

function SelectablePolicyTilevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SelectablePolicyTilevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SelectablePolicyTilevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) SelectablePolicyTilevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) SelectablePolicyTilevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function SelectablePolicyTilevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) SelectablePolicyTilevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function SelectablePolicyTilevue_type_script_lang_ts_setPrototypeOf(o, p) { SelectablePolicyTilevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SelectablePolicyTilevue_type_script_lang_ts_setPrototypeOf(o, p); }

function SelectablePolicyTilevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = SelectablePolicyTilevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SelectablePolicyTilevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SelectablePolicyTilevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SelectablePolicyTilevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function SelectablePolicyTilevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (SelectablePolicyTilevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return SelectablePolicyTilevue_type_script_lang_ts_assertThisInitialized(self); }

function SelectablePolicyTilevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SelectablePolicyTilevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SelectablePolicyTilevue_type_script_lang_ts_getPrototypeOf(o) { SelectablePolicyTilevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SelectablePolicyTilevue_type_script_lang_ts_getPrototypeOf(o); }










var SelectablePolicyTile = /*#__PURE__*/function (_Vue) {
  SelectablePolicyTilevue_type_script_lang_ts_inherits(SelectablePolicyTile, _Vue);

  var _super = SelectablePolicyTilevue_type_script_lang_ts_createSuper(SelectablePolicyTile);

  function SelectablePolicyTile() {
    var _this;

    SelectablePolicyTilevue_type_script_lang_ts_classCallCheck(this, SelectablePolicyTile);

    _this = _super.apply(this, arguments);
    _this.expandedStatus = _this.expanded;
    _this.locale = SelectablePolicyTile_locale_namespaceObject;
    _this.textBlocks = [];
    return _this;
  } // get initial data


  SelectablePolicyTilevue_type_script_lang_ts_createClass(SelectablePolicyTile, [{
    key: "mounted",
    value: function mounted() {
      if (!this.isSelectAllTile && !this.policy) {
        throw Error('Please provide a policy when isSelectAllTile is false.');
      }

      if (!this.isSelectAllTile) {
        this.handlePolicy();
      }
    }
  }, {
    key: "dataBoxData",
    get: function get() {
      if (this.policy) {
        var data = [];
        data.push({
          label: this.locale.common.vsnr,
          value: this.policy.policyNumber
        });
        this.textBlocks.forEach(function (textBlock) {
          data.push({
            label: textBlock.key,
            value: textBlock.value
          });
        });
        return [{
          data: data
        }];
      } else {
        return [];
      }
    }
  }, {
    key: "handlePolicy",
    value: function handlePolicy() {
      this.textBlocks = this.getListBlocks && this.policy ? this.getListBlocks(this.policy) : [];
    }
  }, {
    key: "emitCheckedValue",
    value: function emitCheckedValue(checked) {
      var policyId = this.policy && this.policy.policyId ? this.policy.policyId : undefined;
      this.isSelectAllTile ? this.$emit('input:select', checked) : this.$emit('input:select', checked, policyId);
    }
  }, {
    key: "stopTheEvent",
    value: function stopTheEvent(event) {
      event.stopImmediatePropagation();
    }
  }, {
    key: "getPolicyIcon",
    value: function getPolicyIcon(policy) {
      var pattern = /^icon-.*/gi;

      if (this.tileSpecificIconIdentifier && this.tileSpecificIconIdentifier.toString().match(pattern) !== null) {
        return this.tileSpecificIconIdentifier;
      }

      if (this.tileSpecificIconIdentifier && !this.tileSpecificIconIdentifier.toString().match(pattern) !== null) {
        return IconClassMap.get(this.tileSpecificIconIdentifier);
      }

      return IconClassMap.get(policy.ddsLines[0]);
    }
  }, {
    key: "getPolicyTitle",
    value: function getPolicyTitle(_policy) {
      return this.firstTitle ? this.firstTitle : getTranslatedDDSLine(this.policy ? this.policy.ddsLines[0] : '');
    } // PolicyCollapserBlock

  }, {
    key: "toggleExpansion",
    value: function toggleExpansion() {
      this.expandedStatus = !this.isExpanded;
    }
  }, {
    key: "isExpanded",
    get: function get() {
      return this.expandedStatus;
    }
  }]);

  return SelectablePolicyTile;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  required: false,
  default: false
})], SelectablePolicyTile.prototype, "selected", void 0);

__decorate([Prop({
  required: false,
  default: false
})], SelectablePolicyTile.prototype, "isSelectAllTile", void 0);

__decorate([Prop({
  required: false
})], SelectablePolicyTile.prototype, "policy", void 0);

__decorate([Prop({
  required: false
})], SelectablePolicyTile.prototype, "getListBlocks", void 0);

__decorate([Prop({
  required: false,
  default: ''
})], SelectablePolicyTile.prototype, "tileSpecificIconIdentifier", void 0);

__decorate([Prop({
  required: false,
  default: ''
})], SelectablePolicyTile.prototype, "firstTitle", void 0);

__decorate([Prop({
  default: false
})], SelectablePolicyTile.prototype, "expanded", void 0);

__decorate([Prop({
  default: ''
})], SelectablePolicyTile.prototype, "id", void 0);

SelectablePolicyTile = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    Card: container_Card,
    Checkbox: input_Checkbox,
    DataBox: modules_DataBox
  }
})], SelectablePolicyTile);
/* harmony default export */ var SelectablePolicyTilevue_type_script_lang_ts_ = (SelectablePolicyTile);
;// CONCATENATED MODULE: ./src/components/base/selfServices/SelectablePolicyTile.vue?vue&type=script&lang=ts&
 /* harmony default export */ var selfServices_SelectablePolicyTilevue_type_script_lang_ts_ = (SelectablePolicyTilevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/SelectablePolicyTile.vue?vue&type=style&index=0&id=5a171502&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/selfServices/SelectablePolicyTile.vue?vue&type=style&index=0&id=5a171502&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/selfServices/SelectablePolicyTile.vue



;


/* normalize component */

var SelectablePolicyTile_component = normalizeComponent(
  selfServices_SelectablePolicyTilevue_type_script_lang_ts_,
  SelectablePolicyTilevue_type_template_id_5a171502_scoped_true_render,
  SelectablePolicyTilevue_type_template_id_5a171502_scoped_true_staticRenderFns,
  false,
  null,
  "5a171502",
  null
  
)

/* harmony default export */ var selfServices_SelectablePolicyTile = (SelectablePolicyTile_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/SelfServiceTile.vue?vue&type=template&id=7e7bc78d&scoped=true&
var SelfServiceTilevue_type_template_id_7e7bc78d_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-styled"},[(_vm.isSelectionSubmitted)?_c('div',[_c('SelfServiceForm',{staticClass:"self-service-layout",attrs:{"showResponse":_vm.formShowResponse,"selfServiceLabels":_vm.selfServiceLabels,"modalCurrentPremium":_vm.modalCurrentPremium,"formBlocks":_vm.formBlocks,"isLoading":_vm.formLoading,"isSubmitting":_vm.formSubmitting,"isSubmitButtonDisabled":_vm.formSubmitDisabled,"showDateOption":_vm.showDateOption,"firstTitle":_vm.firstTitle},on:{"input":_vm.formInputStartDate,"button:submit":_vm.formSubmit,"button:abort":_vm.formAbortAction,"button:back":_vm.formAbortAction},scopedSlots:_vm._u([{key:"main",fn:function(){return [_vm._t("change-component")]},proxy:true}],null,true),model:{value:(_vm.formStartDate),callback:function ($$v) {_vm.formStartDate=$$v},expression:"formStartDate"}})],1):(_vm.selectablePolicies.length === 0 || _vm.listShowError)?_c('ResponseTile',{attrs:{"title":_vm.selfServiceLabels.errorTitle,"text":_vm.selfServiceLabels.errorText,"back-button-label":_vm.selfServiceLabels.responseTileBackButtonLabel},on:{"button:back":_vm.formAbortAction}}):_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[(_vm.selfServiceLabels.listHeadline)?_c('p',{staticClass:"self-service-selection-headline"},[_vm._v(" "+_vm._s(_vm.selfServiceLabels.listHeadline)+" ")]):_vm._e(),(_vm.multiSelect && _vm.selectablePolicies.length > 0)?_c('div',[_c('SelectablePolicyTile',{attrs:{"policy":undefined,"selected":_vm.isEachPolicySelected,"isSelectAllTile":true},on:{"input:select":_vm.selectAllPolicies}})],1):_vm._e(),_vm._l((_vm.selectablePolicies),function(selectablePolicy,index){return _c('SelectablePolicyTile',{key:index,attrs:{"policy":selectablePolicy.policy,"tileSpecificIconIdentifier":selectablePolicy.policy.iconIdentifier,"firstTitle":selectablePolicy.policy.firstTitle,"selected":selectablePolicy.selected,"getListBlocks":_vm.getListBlocks,"checkPolicyDetails":_vm.checkPolicyDetails},on:{"input:select":_vm.selectPolicy}})}),_c('FlexGrid',{scopedSlots:_vm._u([{key:"flex-left",fn:function(){return [_c('CustomButton',{staticClass:"listSubmitButton",attrs:{"buttonColor":"cta1","disabledState":_vm.isSubmitButtonDisabled},on:{"click":_vm.submitSelection}},[_vm._v(" "+_vm._s(_vm.locale.button.submitSelection)+" ")])]},proxy:true}])}),_c('div',{staticClass:"mt-16"},[_vm._t("list-extra")],2)],2)])],1)}
var SelfServiceTilevue_type_template_id_7e7bc78d_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/locale/selfServices/SelfServiceTile.locale.json
var SelfServiceTile_locale_namespaceObject = JSON.parse('{"button":{"submitSelection":"Auswahl bestätigen"}}');
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/SelfServiceTile.vue?vue&type=script&lang=ts&
function SelfServiceTilevue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return SelfServiceTilevue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, SelfServiceTilevue_type_script_lang_ts_typeof(obj); }

function SelfServiceTilevue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SelfServiceTilevue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SelfServiceTilevue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) SelfServiceTilevue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) SelfServiceTilevue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function SelfServiceTilevue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) SelfServiceTilevue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function SelfServiceTilevue_type_script_lang_ts_setPrototypeOf(o, p) { SelfServiceTilevue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SelfServiceTilevue_type_script_lang_ts_setPrototypeOf(o, p); }

function SelfServiceTilevue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = SelfServiceTilevue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SelfServiceTilevue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SelfServiceTilevue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SelfServiceTilevue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function SelfServiceTilevue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (SelfServiceTilevue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return SelfServiceTilevue_type_script_lang_ts_assertThisInitialized(self); }

function SelfServiceTilevue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SelfServiceTilevue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SelfServiceTilevue_type_script_lang_ts_getPrototypeOf(o) { SelfServiceTilevue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SelfServiceTilevue_type_script_lang_ts_getPrototypeOf(o); }











var SelfServiceTile = /*#__PURE__*/function (_Vue) {
  SelfServiceTilevue_type_script_lang_ts_inherits(SelfServiceTile, _Vue);

  var _super = SelfServiceTilevue_type_script_lang_ts_createSuper(SelfServiceTile);

  function SelfServiceTile() {
    var _this;

    SelfServiceTilevue_type_script_lang_ts_classCallCheck(this, SelfServiceTile);

    _this = _super.apply(this, arguments);
    _this.locale = SelfServiceTile_locale_namespaceObject;
    _this.formBlocks = [];
    _this.formStartDate = '';
    /* ### FORM props & attributes ### */

    _this.partnerProxyId = ''; // page loading and content control

    _this.loading = true;
    _this.dataAvailable = true;
    _this.isEachPolicySelected = false;
    _this.isSelectionSubmitted = false;
    _this.selectablePolicies = [];
    return _this;
  } // get initial data


  SelfServiceTilevue_type_script_lang_ts_createClass(SelfServiceTile, [{
    key: "mounted",
    value: function mounted() {
      if (this.staticPolicies) {
        this.processPolicies(this.staticPolicies);
      } else if (this.staticPoliciesWithIconAndTitles) {
        this.processPolicies(this.staticPoliciesWithIconAndTitles);
      }
    }
  }, {
    key: "processPolicies",
    value: function processPolicies(policies) {
      var _this2 = this;

      var filteredPolicies = policies.filter(function (policy) {
        return _this2.checkPolicyOverview(policy);
      });

      if (!this.checkPoliciesDetails(filteredPolicies)) {
        filteredPolicies = [];
      }

      filteredPolicies = filteredPolicies.filter(function (policy) {
        return _this2.checkPolicyDetails(policy);
      });
      this.selectablePolicies = filteredPolicies.map(function (policy) {
        return {
          policy: policy,
          selected: _this2.isEachPolicySelected
        };
      });

      if (this.selectablePolicies.length > 0) {
        // One ore more valid policies received. Enable component.
        this.dataAvailable = true;
      } else {
        // No valid policy received. Show error response tile.
        this.showResponseTile();
      }

      this.loading = false;
    }
  }, {
    key: "formSubmit",
    value: function formSubmit() {
      this.$emit('formSubmit', true);
    }
  }, {
    key: "formInputStartDate",
    value: function formInputStartDate(date) {
      this.$emit('formInputStartDate', date);
    }
  }, {
    key: "showResponseTile",
    value: function showResponseTile() {
      this.dataAvailable = false;
      this.loading = false;
    }
  }, {
    key: "getAllPolicies",
    value: function getAllPolicies() {
      return this.selectablePolicies.map(function (selectedPolicy) {
        return selectedPolicy.policy;
      });
    }
  }, {
    key: "getSelectedPolicies",
    value: function getSelectedPolicies() {
      return this.selectablePolicies.filter(function (selectablePolicy) {
        return selectablePolicy.selected;
      }).map(function (selectablePolicy) {
        return selectablePolicy.policy;
      });
    }
  }, {
    key: "isSubmitButtonDisabled",
    get: function get() {
      return this.getSelectedPolicies().length === 0 || this.getSelectedPolicies().length > 1 && !this.multiSelect;
    }
  }, {
    key: "evalIsEachPolicySelected",
    value: function evalIsEachPolicySelected() {
      this.isEachPolicySelected = this.selectablePolicies.filter(function (selectablePolicy) {
        return selectablePolicy.selected;
      }).length === this.selectablePolicies.length;
    }
  }, {
    key: "selectPolicy",
    value: function selectPolicy(checked, policyId) {
      var _this3 = this;

      this.selectablePolicies.forEach(function (selectablePolicy) {
        if (!_this3.multiSelect) {
          selectablePolicy.selected = selectablePolicy.policy.policyId === policyId ? checked : false;
        } else {
          if (selectablePolicy.policy.policyId === policyId) {
            selectablePolicy.selected = checked;
          }
        }
      });
      this.evalIsEachPolicySelected();
    }
  }, {
    key: "selectAllPolicies",
    value: function selectAllPolicies(checked) {
      this.selectablePolicies.forEach(function (selectablePolicy) {
        return selectablePolicy.selected = checked;
      });
      this.evalIsEachPolicySelected();
    }
  }, {
    key: "submitSelection",
    value: function submitSelection() {
      this.setSelectedPolicies(this.getSelectedPolicies());
      this.isSelectionSubmitted = true;
      this.formBlocks = this.getFormBlocks(this.getSelectedPolicies());
    }
  }]);

  return SelfServiceTile;
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  required: false,
  default: true
})], SelfServiceTile.prototype, "multiSelect", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "checkPoliciesDetails", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "checkPolicyOverview", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "checkPolicyDetails", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "getListBlocks", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "getFormBlocks", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "changeRequestType", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "setSelectedPolicies", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "selfServiceLabels", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "formSubmitDisabled", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "formShowResponse", void 0);

__decorate([Prop({
  required: false,
  default: false
})], SelfServiceTile.prototype, "listShowError", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "formLoading", void 0);

__decorate([Prop({
  default: false
})], SelfServiceTile.prototype, "formSubmitting", void 0);

__decorate([Prop({
  required: true
})], SelfServiceTile.prototype, "formAbortAction", void 0);

__decorate([Prop({
  required: false,
  default: true
})], SelfServiceTile.prototype, "showDateOption", void 0);

__decorate([Prop({
  required: false,
  default: ''
})], SelfServiceTile.prototype, "tileSpecificIconIdentifier", void 0);

__decorate([Prop({
  required: false,
  default: ''
})], SelfServiceTile.prototype, "firstTitle", void 0);

__decorate([Prop({
  required: false
})], SelfServiceTile.prototype, "modalCurrentPremium", void 0);

__decorate([Prop({
  required: false
})], SelfServiceTile.prototype, "staticPolicies", void 0);

__decorate([Prop({
  required: false
})], SelfServiceTile.prototype, "staticPoliciesWithIconAndTitles", void 0);

SelfServiceTile = __decorate([(0,vue_class_component_esm["default"])({
  components: {
    SelectablePolicyTile: selfServices_SelectablePolicyTile,
    CustomButton: buttons_CustomButton,
    FlexGrid: container_FlexGrid,
    ResponseTile: selfServices_ResponseTile,
    Card: container_Card,
    SelfServiceForm: selfServices_SelfServiceForm
  }
})], SelfServiceTile);
/* harmony default export */ var SelfServiceTilevue_type_script_lang_ts_ = (SelfServiceTile);
;// CONCATENATED MODULE: ./src/components/base/selfServices/SelfServiceTile.vue?vue&type=script&lang=ts&
 /* harmony default export */ var selfServices_SelfServiceTilevue_type_script_lang_ts_ = (SelfServiceTilevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-64[0].rules[0].use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[1]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-64[0].rules[0].use[3]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/selfServices/SelfServiceTile.vue?vue&type=style&index=0&id=7e7bc78d&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/base/selfServices/SelfServiceTile.vue?vue&type=style&index=0&id=7e7bc78d&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/base/selfServices/SelfServiceTile.vue



;


/* normalize component */

var SelfServiceTile_component = normalizeComponent(
  selfServices_SelfServiceTilevue_type_script_lang_ts_,
  SelfServiceTilevue_type_template_id_7e7bc78d_scoped_true_render,
  SelfServiceTilevue_type_template_id_7e7bc78d_scoped_true_staticRenderFns,
  false,
  null,
  "7e7bc78d",
  null
  
)

/* harmony default export */ var selfServices_SelfServiceTile = (SelfServiceTile_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/GridContent.vue?vue&type=template&id=26cd2d56&
var GridContentvue_type_template_id_26cd2d56_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-content"},[_vm._t("gridContent")],2)}
var GridContentvue_type_template_id_26cd2d56_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-83[0].rules[0].use[2]!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/base/container/GridContent.vue?vue&type=script&lang=ts&
function GridContentvue_type_script_lang_ts_typeof(obj) { "@babel/helpers - typeof"; return GridContentvue_type_script_lang_ts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, GridContentvue_type_script_lang_ts_typeof(obj); }

function GridContentvue_type_script_lang_ts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function GridContentvue_type_script_lang_ts_createClass(Constructor, protoProps, staticProps) { if (protoProps) GridContentvue_type_script_lang_ts_defineProperties(Constructor.prototype, protoProps); if (staticProps) GridContentvue_type_script_lang_ts_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function GridContentvue_type_script_lang_ts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GridContentvue_type_script_lang_ts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) GridContentvue_type_script_lang_ts_setPrototypeOf(subClass, superClass); }

function GridContentvue_type_script_lang_ts_setPrototypeOf(o, p) { GridContentvue_type_script_lang_ts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return GridContentvue_type_script_lang_ts_setPrototypeOf(o, p); }

function GridContentvue_type_script_lang_ts_createSuper(Derived) { var hasNativeReflectConstruct = GridContentvue_type_script_lang_ts_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = GridContentvue_type_script_lang_ts_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = GridContentvue_type_script_lang_ts_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return GridContentvue_type_script_lang_ts_possibleConstructorReturn(this, result); }; }

function GridContentvue_type_script_lang_ts_possibleConstructorReturn(self, call) { if (call && (GridContentvue_type_script_lang_ts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return GridContentvue_type_script_lang_ts_assertThisInitialized(self); }

function GridContentvue_type_script_lang_ts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function GridContentvue_type_script_lang_ts_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function GridContentvue_type_script_lang_ts_getPrototypeOf(o) { GridContentvue_type_script_lang_ts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return GridContentvue_type_script_lang_ts_getPrototypeOf(o); }





var GridContent = /*#__PURE__*/function (_Vue) {
  GridContentvue_type_script_lang_ts_inherits(GridContent, _Vue);

  var _super = GridContentvue_type_script_lang_ts_createSuper(GridContent);

  function GridContent() {
    GridContentvue_type_script_lang_ts_classCallCheck(this, GridContent);

    return _super.apply(this, arguments);
  }

  return GridContentvue_type_script_lang_ts_createClass(GridContent);
}((external_commonjs_vue_commonjs2_vue_root_Vue_default()));

__decorate([Prop({
  default: false
})], GridContent.prototype, "disableStyles", void 0);

GridContent = __decorate([(0,vue_class_component_esm["default"])({
  mixins: [responsiveClassMixin]
})], GridContent);
/* harmony default export */ var GridContentvue_type_script_lang_ts_ = (GridContent);
;// CONCATENATED MODULE: ./src/components/base/container/GridContent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var container_GridContentvue_type_script_lang_ts_ = (GridContentvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/base/container/GridContent.vue





/* normalize component */
;
var GridContent_component = normalizeComponent(
  container_GridContentvue_type_script_lang_ts_,
  GridContentvue_type_template_id_26cd2d56_render,
  GridContentvue_type_template_id_26cd2d56_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var container_GridContent = (GridContent_component.exports);
// EXTERNAL MODULE: ./src/components/types/Policy.ts
var Policy = __webpack_require__(332);
// EXTERNAL MODULE: ./src/components/types/AddressData.ts
var AddressData = __webpack_require__(70);
// EXTERNAL MODULE: ./src/components/types/NameData.ts
var NameData = __webpack_require__(746);
// EXTERNAL MODULE: ./src/components/types/KeyValueType.ts
var KeyValueType = __webpack_require__(676);
// EXTERNAL MODULE: ./src/components/types/ApiRequestConfig.ts
var ApiRequestConfig = __webpack_require__(546);
;// CONCATENATED MODULE: ./src/components/types/ChangeRequestType.ts
var ChangeRequestType;

(function (ChangeRequestType) {
  ChangeRequestType["BankData"] = "BankData";
  ChangeRequestType["MotorCockpit"] = "MotorCockpit";
})(ChangeRequestType || (ChangeRequestType = {}));
// EXTERNAL MODULE: ./src/components/types/SelfServiceLabels.ts
var SelfServiceLabels = __webpack_require__(278);
// EXTERNAL MODULE: ./src/components/types/Payment.ts
var Payment = __webpack_require__(645);
// EXTERNAL MODULE: ./src/components/base/modules/DataBoxInterface.ts
var DataBoxInterface = __webpack_require__(377);
;// CONCATENATED MODULE: ./src/main.ts
// Importing the global css file
 // Da-Direkt specific components


 // Da-Direkt components

var main_TabPane = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('TabPane', tabpane_TabPane);
var main_BackToTop = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('BackToTop', navigation_BackToTop);

 // Vue Components









































 // Interfaces












 // Enums




 // Functions

 // Object.keys(Components).forEach(name => {
//     Vue.component(name, Components[name]);
// });

var main_CustomButton = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('CustomButton', buttons_CustomButton);
var main_Card = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('Card', container_Card);
var main_SubCard = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('SubCard', container_SubCard);
var main_BasicTextfield = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('BasicTextfield', input_BasicTextfield);
var main_TextArea = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('TextArea', input_TextArea);
var main_DateInput = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('DateInput', input_DateInput);
var main_Checkbox = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('Checkbox', input_Checkbox);
var main_SwitchButton = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('SwitchButton', input_SwitchButton);
var main_Collapser = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('Collapser', container_Collapser);
var main_Radiogroup = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('Radiogroup', input_Radiogroup);
var main_CarLicense = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('CarLicense', modules_CarLicense);
var main_DataBox = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('DataBox', modules_DataBox);
var main_Spinner = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('Spinner', modules_Spinner);
var main_HeaderTitle = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('HeaderTitle', container_HeaderTitle);
var main_Alert = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('Alert', container_Alert);
var main_Navigation = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('Navigation', navigation_Navigation);
var main_PostboxTable = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('PostboxTable', modules_PostboxTable);
var main_SearchResultBox = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('SearchResultBox', modules_SearchResultBox);
var main_SearchResultList = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('SearchResultList', modules_SearchResultList);
var main_SearchResultListLine = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('SearchResultListLine', modules_SearchResultListLine);
var main_DataSection = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('DataSection', modules_DataSection);
var main_DataLine = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('DataLine', modules_DataLine);
var main_DataTable = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('DataTable', modules_DataTable);
var main_Modal = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('Modal', modal_Modal);
var main_ValidationRule = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('ValidationRule', modules_ValidationRule);
var main_Contact = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('Contact', modules_Contact);
var main_FlexGrid = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('FlexGrid', container_FlexGrid);
var main_TextImageTeaser = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('TextImageTeaser', modules_TextImageTeaser);
var main_PostboxTeaser = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('PostboxTeaser', modules_PostboxTeaser);
var main_PromotionArea = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('PromotionArea', modules_PromotionArea);
var main_SelectMenue = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('SelectMenue', input_SelectMenue);
var main_HoverableIcon = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('HoverableIcon', modules_HoverableIcon);
var main_HoverableIconBig = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('HoverableIconBig', modules_HoverableIconBig);
var main_SelfServiceForm = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('SelfServiceForm', selfServices_SelfServiceForm);
var main_EnterDateCardRow = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('EnterDateCardRow', selfServices_EnterDateCardRow);
var main_ResponseTile = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('ResponseTile', selfServices_ResponseTile);
var main_AddressInput = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('AddressInput', selfServices_AddressInput);
var main_NameInput = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('NameInput', selfServices_NameInput);
var main_SelectablePolicyTile = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('SelectablePolicyTile', selfServices_SelectablePolicyTile);
var main_SelfServiceTile = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('SelfServiceTile', selfServices_SelfServiceTile);
var main_GridContent = external_commonjs_vue_commonjs2_vue_root_Vue_default().component('GridContent', container_GridContent);

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=ui-library-da.umd.js.map